var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to2, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to2;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faCircleExclamation.js
var require_faCircleExclamation = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faCircleExclamation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "circle-exclamation";
    var width = 512;
    var height = 512;
    var aliases = ["exclamation-circle"];
    var unicode = "f06a";
    var svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faCircleExclamation = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faFloppyDisk.js
var require_faFloppyDisk = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faFloppyDisk.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "floppy-disk";
    var width = 448;
    var height = 512;
    var aliases = [128190, 128426, "save"];
    var unicode = "f0c7";
    var svgPathData = "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faFloppyDisk = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowsRotate.js
var require_faArrowsRotate = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowsRotate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "arrows-rotate";
    var width = 512;
    var height = 512;
    var aliases = [128472, "refresh", "sync"];
    var unicode = "f021";
    var svgPathData = "M496 200c0 13.3-10.7 24-24 24h0H360 328c-13.3 0-24-10.7-24-24s10.7-24 24-24h32 54.1l-52.1-52.1C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1V88l0-.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24V200zM40 288H152c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faArrowsRotate = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js
var require_faSun = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "sun";
    var width = 512;
    var height = 512;
    var aliases = [9728];
    var unicode = "f185";
    var svgPathData = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSun = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js
var require_faMoon = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "moon";
    var width = 384;
    var height = 512;
    var aliases = [127769, 9214];
    var unicode = "f186";
    var svgPathData = "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faMoon = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faSwatchbook.js
var require_faSwatchbook = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faSwatchbook.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "swatchbook";
    var width = 512;
    var height = 512;
    var aliases = [];
    var unicode = "f5c3";
    var svgPathData = "M0 400c0 61.9 50.1 112 112 112H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H385.9l50.7-50.7c25-25 25-65.5 0-90.5L365.3 75.3c-25-25-65.5-25-90.5 0L224 126.1V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V400zm448 64H209.9l128-128H448c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16zM402.7 203.3L224 382.1V193.9l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64V304H176v96c0 35.3-28.7 64-64 64zM48 256V176H176v80H48zm0-128V64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16v64H48zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSwatchbook = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// src/components/ThemeEditor/ThemeEditor.tsx
import { useEffect as useEffect4 } from "react";

// src/context/Context.tsx
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var useThemeEditor = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useThemeEditor must be used within an ThemeEditorProvider"
    );
  }
  return context;
};
var Context_default = Context;

// src/components/DonateComponentModal/DonateComponentModal.tsx
var import_faCircleExclamation = __toESM(require_faCircleExclamation());
var import_faFloppyDisk = __toESM(require_faFloppyDisk());
var import_faArrowsRotate = __toESM(require_faArrowsRotate());
import { useEffect as useEffect3, useState as useState3 } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalFooter,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Button,
  Icon as Icon2,
  Alert,
  AlertDescription
} from "@appcues/sonar-builder";
import { get as get2 } from "object-path-immutable";
import camelCase from "lodash.camelcase";
import startCase from "lodash.startcase";

// src/components/PreviewPane/PreviewPane.tsx
var import_faSun = __toESM(require_faSun());
var import_faMoon = __toESM(require_faMoon());
import { useState as useState2 } from "react";
import {
  SegmentedControlGroup,
  SegmentedControlGroupItem,
  Icon
} from "@appcues/sonar-builder";

// src/lib/preview/style-from.ts
import { get } from "object-path-immutable";
var getTokenValueFromPath = (tokens, path) => get(tokens, path)?.$value;
var resolveTokenValue = (theme, reference, overrideId) => {
  const path = reference.replace(/[{}]/g, "");
  if (overrideId) {
    const overrideTokens = theme.content.overrides?.find(
      ({ id: id2 }) => id2 === overrideId
    )?.tokens;
    if (overrideTokens) {
      const value2 = getTokenValueFromPath(overrideTokens, path);
      if (value2) {
        if (value2.startsWith("{")) {
          return resolveTokenValue(theme, value2);
        }
        return value2;
      }
    }
  }
  const value = getTokenValueFromPath(theme.content.tokens, path);
  if (value) {
    if (value.startsWith("{")) {
      return resolveTokenValue(theme, value);
    }
    return value;
  }
  return reference;
};
var transformValue = (platform, value) => {
  if (platform === "web") {
    return value;
  }
  if (typeof value === "string" && value.endsWith("px")) {
    return Number.parseFloat(value);
  }
  if (value === "100%") {
    return -1;
  }
  return value;
};
var handleMobileFontFamily = (theme, styleObject, overrideId) => {
  const path = styleObject.fontFamily.replace(/[{}]/g, "");
  const tokenObj = get(theme.content.tokens, path);
  const fontExtensions = tokenObj?.$extensions?.["com.appcues.theme.font"];
  const fontWeight = resolveTokenValue(theme, styleObject.fontWeight, overrideId) || "regular";
  const mobileFontName = fontExtensions?.mobile?.[fontWeight];
  return mobileFontName;
};
var styleFrom = (theme, platform, path, overrideId) => {
  const componentStyle = get(theme.content.components, `${path}.$style`);
  const override = theme.content.overrides?.find(({ id: id2 }) => id2 === overrideId);
  const overrideStyle = override ? get(override.components, `${path}.$style`) : void 0;
  if (!componentStyle && !overrideStyle) return {};
  const mergedStyle = {
    ...componentStyle,
    ...overrideStyle
  };
  const resolveStyleTokens = (styleObject) => {
    if (typeof styleObject !== "object" || styleObject === null) {
      return styleObject;
    }
    return Object.entries(styleObject).reduce(
      (acc, [key, value]) => {
        if (platform === "mobile" && key === "fontFamily") {
          const val = handleMobileFontFamily(theme, styleObject, overrideId);
          acc.fontName = val;
          return acc;
        }
        if (typeof value === "string" && value.startsWith("{")) {
          acc[key] = transformValue(
            platform,
            resolveTokenValue(theme, value, overrideId)
          );
        } else if (typeof value === "object") {
          acc[key] = resolveStyleTokens(value);
        } else {
          acc[key] = transformValue(platform, value);
        }
        return acc;
      },
      {}
    );
  };
  return resolveStyleTokens(mergedStyle);
};

// src/lib/preview/make-mobile-experience.ts
var PLATFORM = "mobile";
var stackBlockWrapper = (content) => ({
  type: "stack",
  id: `${content.id}-stack`,
  orientation: "horizontal",
  distribution: "equal",
  items: [
    {
      type: "block",
      blockType: "image",
      id: `${content.id}-block`,
      content
    }
  ]
});
var makeImageRows = (theme) => Object.keys(theme.content.components?.image || {}).map(
  (imageKey) => stackBlockWrapper({
    type: "image",
    id: `image.${imageKey}-image`,
    imageUrl: "https://images.appcues.com/v1658371422/mobile-builder/default-image.jpg",
    style: styleFrom(theme, PLATFORM, `image.${imageKey}`)
  })
);
var makeTextRows = (theme) => Object.keys(theme.content.components?.text || {}).map(
  (textKey) => stackBlockWrapper({
    type: "text",
    id: `text.${textKey}-text`,
    text: `${textKey.charAt(0).toUpperCase() + textKey.slice(1)} text`,
    style: styleFrom(theme, PLATFORM, `text.${textKey}`)
  })
);
var makeButtonRows = (theme) => Object.keys(theme.content.components?.button || {}).map(
  (buttonKey) => stackBlockWrapper({
    type: "button",
    id: `${buttonKey}-button`,
    content: {
      type: "text",
      id: `${buttonKey}-text`,
      text: `${buttonKey.charAt(0).toUpperCase() + buttonKey.slice(1)} Button`,
      style: styleFrom(theme, PLATFORM, `button.${buttonKey}.text`)
    },
    style: styleFrom(theme, PLATFORM, `button.${buttonKey}`)
  })
);
var makeMobileExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "mobile",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: [
        {
          type: "@appcues/modal",
          config: {
            presentationStyle: "dialog",
            style: styleFrom(theme, PLATFORM, "container.modal.default")
          }
        },
        {
          type: "@appcues/backdrop",
          config: styleFrom(
            theme,
            PLATFORM,
            "container.modal.default.backdrop"
          )
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              ...makeImageRows(theme),
              ...makeTextRows(theme),
              ...makeButtonRows(theme)
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});
var wrapMobileComponentPreview = ({
  traits,
  block
}) => ({
  id: "exp-0",
  name: "Component",
  type: "mobile_embed",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: traits ?? [
        {
          type: "@appcues/embedded",
          config: {
            presentationStyle: "embed"
          }
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              block ?? stackBlockWrapper({
                type: "text",
                id: "text-0",
                text: "",
                style: {
                  fontSize: 16,
                  marginTop: 48,
                  marginBottom: 48
                }
              })
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});

// src/lib/preview/make-web-experience.ts
var PLATFORM2 = "web";
var cellWrapper = (content) => ({
  nodeId: `${content.nodeId}-cell`,
  type: "block",
  version: 1,
  props: {
    blockType: "Cell",
    is: "div",
    style: {
      alignItems: "center",
      boxSizing: "border-box",
      display: "flex",
      flex: 1,
      height: "100%",
      justifyContent: "center",
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingTop: 0,
      position: "relative",
      width: "100%"
    },
    children: [content]
  }
});
var HEADING_LEVELS = ["h1", "h2", "h3", "h4", "h5"];
var makeRichTextRow = (theme) => {
  const webComponents = theme.content.components?.web;
  const headingChildren = HEADING_LEVELS.flatMap(
    (headingTag) => Object.keys(webComponents?.[headingTag] || {}).map((variantKey) => ({
      nodeId: `${headingTag}.${variantKey}`,
      type: "primitive",
      props: {
        is: headingTag,
        style: styleFrom(theme, PLATFORM2, `web.${headingTag}.${variantKey}`),
        children: [
          variantKey !== "default" ? `${variantKey} (${headingTag.toUpperCase()})` : `Heading ${headingTag.toUpperCase()}`
        ]
      }
    }))
  );
  const paragraphChildren = Object.keys(webComponents?.p || {}).map(
    (variantKey) => ({
      nodeId: `p.${variantKey}`,
      type: "primitive",
      props: {
        is: "p",
        style: styleFrom(theme, PLATFORM2, `web.p.${variantKey}`),
        children: [
          variantKey !== "default" ? `${variantKey} (Paragraph)` : "Paragraph"
        ]
      }
    })
  );
  const children = [...headingChildren, ...paragraphChildren];
  if (children.length === 0) {
    return [];
  }
  return [
    cellWrapper({
      nodeId: "rich-text-styles",
      type: "block",
      version: 1,
      props: {
        blockType: "RichText",
        id: "rich-text-styles",
        is: "div",
        style: {
          margin: 0,
          minWidth: "200px"
        },
        children
      }
    })
  ];
};
var makeButtonRows2 = (theme) => Object.keys(
  theme.content.components?.web?.button || {}
).map(
  (buttonKey) => cellWrapper({
    nodeId: `${buttonKey}-button`,
    type: "block",
    version: 1,
    props: {
      blockType: "Button",
      id: `button-${buttonKey}-button`,
      is: "button",
      style: styleFrom(theme, PLATFORM2, `web.button.${buttonKey}`),
      children: [
        `${buttonKey.charAt(0).toUpperCase() + buttonKey.slice(1)} Button`
      ]
    }
  })
);
var makeWebExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "flow",
  accountId: "103523",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            maxHeight: "80vh",
            maxWidth: "80vw",
            minHeight: "min-content",
            minWidth: "min-content",
            position: "relative",
            ...styleFrom(theme, PLATFORM2, "web.modal.default")
          },
          children: [
            {
              nodeId: "layout-builder",
              type: "block",
              version: 1,
              props: {
                behaviors: {
                  interaction: true
                },
                blockType: "LayoutBuilder",
                id: "layout-builder-53b4ddf0-e523-49d3-ac76-41755676dbd4",
                is: "div",
                root: false,
                style: {
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  height: "100%",
                  minHeight: "min-content",
                  minWidth: "min-content",
                  pointerEvents: "all",
                  width: "100%"
                },
                children: [...makeRichTextRow(theme), ...makeButtonRows2(theme)]
              }
            }
          ]
        }
      }
    }
  ]
});
var wrapWebComponentPreview = (block) => ({
  id: "exp-0",
  name: "Component",
  type: "flow",
  accountId: "103523",
  tags: [],
  theme: "",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            minHeight: "min-content",
            minWidth: "min-content",
            fontFamily: "Arial, sans-serif"
          },
          children: [block]
        }
      }
    }
  ]
});

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { useEffect, useRef } from "react";

// src/components/PreviewPane/PreviewPane.styled.ts
import styled from "styled-components";
var Panel = styled.div`
  background-color: ${({ colorMode }) => colorMode === "dark" ? "#000" : "#fff"};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
var ControlBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 var(--spacing-regular);
  padding: var(--spacing-regular) 0;
  border-bottom: 1px solid var(--border-default);
`;
var PreviewWrapper = styled.div`
  position: relative;
  flex: 1;
`;
var PreviewTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: var(--spacing-regular);
  font-weight: var(--bold);
  line-height: normal;
`;
var PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
`;
var Preview = {
  Wrapper: PreviewWrapper,
  Title: PreviewTitle,
  Frame: PreviewFrame
};

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MobilePreviewFrame = ({
  title,
  mobileExperience,
  colorMode = "light"
}) => {
  const iframeRef = useRef(null);
  const srcUrl = `${window.location.origin}/image-service`;
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.addEventListener("load", () => {
        iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
          colorMode
        });
      });
    }
  });
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
        colorMode
      });
    }
  }, [mobileExperience, colorMode]);
  return /* @__PURE__ */ jsxs(Preview.Wrapper, { children: [
    /* @__PURE__ */ jsx(
      Preview.Frame,
      {
        ref: iframeRef,
        title,
        scrolling: "no",
        src: srcUrl
      }
    ),
    title && /* @__PURE__ */ jsx(Preview.Title, { children: title })
  ] });
};

// src/components/PreviewPane/WebPreviewFrame.tsx
import { useEffect as useEffect2, useCallback, useState } from "react";

// ../open-builder/build/open-builder.js
var M = function() {
  return M = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, M.apply(this, arguments);
};
function vi(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function nt(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function st(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, o = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function mt(t, e, n) {
  if (arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var at;
(function(t) {
  t.Start = "xstate.start", t.Stop = "xstate.stop", t.Raise = "xstate.raise", t.Send = "xstate.send", t.Cancel = "xstate.cancel", t.NullEvent = "", t.Assign = "xstate.assign", t.After = "xstate.after", t.DoneState = "done.state", t.DoneInvoke = "done.invoke", t.Log = "xstate.log", t.Init = "xstate.init", t.Invoke = "xstate.invoke", t.ErrorExecution = "error.execution", t.ErrorCommunication = "error.communication", t.ErrorPlatform = "error.platform", t.ErrorCustom = "xstate.error", t.Update = "xstate.update", t.Pure = "xstate.pure", t.Choose = "xstate.choose";
})(at || (at = {}));
var Ge;
(function(t) {
  t.Parent = "#_parent", t.Internal = "#_internal";
})(Ge || (Ge = {}));
var Zr = at.Start;
var gi = at.Stop;
var wr = at.Raise;
var xr = at.Send;
var rs = at.Cancel;
var Nc = at.NullEvent;
var Jr = at.Assign;
at.After;
at.DoneState;
var is = at.Log;
var Pc = at.Init;
var Qr = at.Invoke;
at.ErrorExecution;
var Xi = at.ErrorPlatform;
var Ic = at.ErrorCustom;
var os = at.Update;
var Dc = at.Choose;
var Lc = at.Pure;
var ss = ".";
var Yi = {};
var ti = "xstate.guard";
var $c = "";
var Fn;
function yi(t, e, n) {
  n === void 0 && (n = ss);
  var r = xn(t, n), i = xn(e, n);
  return it(i) ? it(r) ? i === r : false : it(r) ? r in i : Object.keys(r).every(function(o) {
    return o in i ? yi(r[o], i[o]) : false;
  });
}
function as(t) {
  try {
    return it(t) || typeof t == "number" ? "".concat(t) : t.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function ei(t, e) {
  try {
    return tn(t) ? t : t.toString().split(e);
  } catch {
    throw new Error("'".concat(t, "' is not a valid state path."));
  }
}
function kc(t) {
  return typeof t == "object" && "value" in t && "context" in t && "event" in t && "_event" in t;
}
function xn(t, e) {
  if (kc(t))
    return t.value;
  if (tn(t))
    return or(t);
  if (typeof t != "string")
    return t;
  var n = ei(t, e);
  return or(n);
}
function or(t) {
  if (t.length === 1)
    return t[0];
  for (var e = {}, n = e, r = 0; r < t.length - 1; r++)
    r === t.length - 2 ? n[t[r]] = t[r + 1] : (n[t[r]] = {}, n = n[t[r]]);
  return e;
}
function mn(t, e) {
  for (var n = {}, r = Object.keys(t), i = 0; i < r.length; i++) {
    var o = r[i];
    n[o] = e(t[o], o, t, i);
  }
  return n;
}
function Zi(t, e, n) {
  var r, i, o = {};
  try {
    for (var s = nt(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, l = t[c];
      n(l) && (o[c] = e(l, c, t));
    }
  } catch (v) {
    r = {
      error: v
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
var Mc = function(t) {
  return function(e) {
    var n, r, i = e;
    try {
      for (var o = nt(t), s = o.next(); !s.done; s = o.next()) {
        var a = s.value;
        i = i[a];
      }
    } catch (c) {
      n = {
        error: c
      };
    } finally {
      try {
        s && !s.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return i;
  };
};
function Hc(t, e) {
  return function(n) {
    var r, i, o = n;
    try {
      for (var s = nt(t), a = s.next(); !a.done; a = s.next()) {
        var c = a.value;
        o = o[e][c];
      }
    } catch (l) {
      r = {
        error: l
      };
    } finally {
      try {
        a && !a.done && (i = s.return) && i.call(s);
      } finally {
        if (r) throw r.error;
      }
    }
    return o;
  };
}
function Jn(t) {
  if (!t)
    return [[]];
  if (it(t))
    return [[t]];
  var e = ht(Object.keys(t).map(function(n) {
    var r = t[n];
    return typeof r != "string" && (!r || !Object.keys(r).length) ? [[n]] : Jn(t[n]).map(function(i) {
      return [n].concat(i);
    });
  }));
  return e;
}
function ht(t) {
  var e;
  return (e = []).concat.apply(e, mt([], st(t), false));
}
function cs(t) {
  return tn(t) ? t : [t];
}
function qt(t) {
  return t === void 0 ? [] : cs(t);
}
function sr(t, e, n) {
  var r, i;
  if (lt(t))
    return t(e, n.data);
  var o = {};
  try {
    for (var s = nt(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, l = t[c];
      lt(l) ? o[c] = l(e, n.data) : o[c] = l;
    }
  } catch (v) {
    r = {
      error: v
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
function jc(t) {
  return /^(done|error)\./.test(t);
}
function Ji(t) {
  return !!(t instanceof Promise || t !== null && (lt(t) || typeof t == "object") && lt(t.then));
}
function Fc(t) {
  return t !== null && typeof t == "object" && "transition" in t && typeof t.transition == "function";
}
function ls(t, e) {
  var n, r, i = st([[], []], 2), o = i[0], s = i[1];
  try {
    for (var a = nt(t), c = a.next(); !c.done; c = a.next()) {
      var l = c.value;
      e(l) ? o.push(l) : s.push(l);
    }
  } catch (v) {
    n = {
      error: v
    };
  } finally {
    try {
      c && !c.done && (r = a.return) && r.call(a);
    } finally {
      if (n) throw n.error;
    }
  }
  return [o, s];
}
function us(t, e) {
  return mn(t.states, function(n, r) {
    if (n) {
      var i = (it(e) ? void 0 : e[r]) || (n ? n.current : void 0);
      if (i)
        return {
          current: i,
          states: us(n, i)
        };
    }
  });
}
function Uc(t, e) {
  return {
    current: e,
    states: us(t, e)
  };
}
function Qi(t, e, n, r) {
  var i = t && n.reduce(function(o, s) {
    var a, c, l = s.assignment, v = {
      state: r,
      action: s,
      _event: e
    }, f = {};
    if (lt(l))
      f = l(o, e.data, v);
    else
      try {
        for (var u = nt(Object.keys(l)), p = u.next(); !p.done; p = u.next()) {
          var h = p.value, g = l[h];
          f[h] = lt(g) ? g(o, e.data, v) : g;
        }
      } catch (E) {
        a = {
          error: E
        };
      } finally {
        try {
          p && !p.done && (c = u.return) && c.call(u);
        } finally {
          if (a) throw a.error;
        }
      }
    return Object.assign({}, o, f);
  }, t);
  return i;
}
var Bc = function() {
};
function tn(t) {
  return Array.isArray(t);
}
function lt(t) {
  return typeof t == "function";
}
function it(t) {
  return typeof t == "string";
}
function fs(t, e) {
  if (t)
    return it(t) ? {
      type: ti,
      name: t,
      predicate: e ? e[t] : void 0
    } : lt(t) ? {
      type: ti,
      name: t.name,
      predicate: t
    } : t;
}
function zc(t) {
  try {
    return "subscribe" in t && lt(t.subscribe);
  } catch {
    return false;
  }
}
var me = /* @__PURE__ */ (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
Fn = {}, Fn[me] = function() {
  return this;
}, Fn[Symbol.observable] = function() {
  return this;
};
function Ke(t) {
  return !!t && "__xstatenode" in t;
}
function qc(t) {
  return !!t && typeof t.send == "function";
}
var Vc = /* @__PURE__ */ (function() {
  var t = 0;
  return function() {
    return t++, t.toString(16);
  };
})();
function mi(t, e) {
  return it(t) || typeof t == "number" ? M({
    type: t
  }, e) : t;
}
function At(t, e) {
  if (!it(t) && "$$type" in t && t.$$type === "scxml")
    return t;
  var n = mi(t);
  return M({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, e);
}
function ke(t, e) {
  var n = cs(e).map(function(r) {
    return typeof r > "u" || typeof r == "string" || Ke(r) ? {
      target: r,
      event: t
    } : M(M({}, r), {
      event: t
    });
  });
  return n;
}
function Wc(t) {
  if (!(t === void 0 || t === $c))
    return qt(t);
}
function ds(t, e, n, r, i) {
  var o = t.options.guards, s = {
    state: i,
    cond: e,
    _event: r
  };
  if (e.type === ti)
    return (o?.[e.name] || e.predicate)(n, r.data, s);
  var a = o?.[e.type];
  if (!a)
    throw new Error("Guard '".concat(e.type, "' is not implemented on machine '").concat(t.id, "'."));
  return a(n, r.data, s);
}
function ps(t) {
  return typeof t == "string" ? {
    type: t
  } : t;
}
function ni(t, e, n) {
  if (typeof t == "object")
    return t;
  var r = function() {
  };
  return {
    next: t,
    error: e || r,
    complete: n || r
  };
}
function Un(t, e) {
  return "".concat(t, ":invocation[").concat(e, "]");
}
var ar = /* @__PURE__ */ At({
  type: Pc
});
function ri(t, e) {
  return e && e[t] || void 0;
}
function Rn(t, e) {
  var n;
  if (it(t) || typeof t == "number") {
    var r = ri(t, e);
    lt(r) ? n = {
      type: t,
      exec: r
    } : r ? n = r : n = {
      type: t,
      exec: void 0
    };
  } else if (lt(t))
    n = {
      // Convert action to string if unnamed
      type: t.name || t.toString(),
      exec: t
    };
  else {
    var r = ri(t.type, e);
    if (lt(r))
      n = M(M({}, t), {
        exec: r
      });
    else if (r) {
      var i = r.type || t.type;
      n = M(M(M({}, r), t), {
        type: i
      });
    } else
      n = t;
  }
  return n;
}
var cr = function(t, e) {
  if (!t)
    return [];
  var n = tn(t) ? t : [t];
  return n.map(function(r) {
    return Rn(r, e);
  });
};
function Ei(t) {
  var e = Rn(t);
  return M(M({
    id: it(t) ? t : e.id
  }, e), {
    type: e.type
  });
}
function hs(t) {
  return it(t) ? {
    type: wr,
    event: t
  } : An(t, {
    to: Ge.Internal
  });
}
function Gc(t) {
  return {
    type: wr,
    _event: At(t.event)
  };
}
function An(t, e) {
  return {
    to: e ? e.to : void 0,
    type: xr,
    event: lt(t) ? t : mi(t),
    delay: e ? e.delay : void 0,
    id: e && e.id !== void 0 ? e.id : lt(t) ? t.name : as(t)
  };
}
function Kc(t, e, n, r) {
  var i = {
    _event: n
  }, o = At(lt(t.event) ? t.event(e, n.data, i) : t.event), s;
  if (it(t.delay)) {
    var a = r && r[t.delay];
    s = lt(a) ? a(e, n.data, i) : a;
  } else
    s = lt(t.delay) ? t.delay(e, n.data, i) : t.delay;
  var c = lt(t.to) ? t.to(e, n.data, i) : t.to;
  return M(M({}, t), {
    to: c,
    _event: o,
    event: o.data,
    delay: s
  });
}
function Xc(t, e) {
  return An(t, M(M({}, e), {
    to: Ge.Parent
  }));
}
var Yc = function(t, e, n) {
  return M(M({}, t), {
    value: it(t.expr) ? t.expr : t.expr(e, n.data, {
      _event: n
    })
  });
};
var Zc = function(t) {
  return {
    type: rs,
    sendId: t
  };
};
function Jc(t) {
  var e = Ei(t);
  return {
    type: at.Start,
    activity: e,
    exec: void 0
  };
}
function Qc(t) {
  var e = lt(t) ? t : Ei(t);
  return {
    type: at.Stop,
    activity: e,
    exec: void 0
  };
}
function tl(t, e, n) {
  var r = lt(t.activity) ? t.activity(e, n.data) : t.activity, i = typeof r == "string" ? {
    id: r
  } : r, o = {
    type: at.Stop,
    activity: i
  };
  return o;
}
var el = function(t) {
  return {
    type: Jr,
    assignment: t
  };
};
function nl(t, e) {
  var n = e ? "#".concat(e) : "";
  return "".concat(at.After, "(").concat(t, ")").concat(n);
}
function Bn(t, e) {
  var n = "".concat(at.DoneState, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function Qn(t, e) {
  var n = "".concat(at.DoneInvoke, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function En(t, e) {
  var n = "".concat(at.ErrorPlatform, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function rl(t) {
  return {
    type: at.Pure,
    get: t
  };
}
function il(t, e) {
  return An(function(n, r) {
    return r;
  }, M(M({}, e), {
    to: t
  }));
}
function vs(t) {
  return {
    type: at.Choose,
    conds: t
  };
}
function ii(t, e, n, r, i, o) {
  o === void 0 && (o = false);
  var s = st(o ? [[], i] : ls(i, function(u) {
    return u.type === Jr;
  }), 2), a = s[0], c = s[1], l = a.length ? Qi(n, r, a, e) : n, v = o ? [n] : void 0, f = ht(c.map(function(u) {
    var p;
    switch (u.type) {
      case wr:
        return Gc(u);
      case xr:
        var h = Kc(u, l, r, t.options.delays);
        return h;
      case is:
        return Yc(u, l, r);
      case Dc: {
        var g = u, E = (p = g.conds.find(function(D) {
          var $ = fs(D.cond, t.options.guards);
          return !$ || ds(t, $, l, r, e);
        })) === null || p === void 0 ? void 0 : p.actions;
        if (!E)
          return [];
        var S = st(ii(t, e, l, r, cr(qt(E), t.options.actions), o), 2), y = S[0], b = S[1];
        return l = b, v?.push(l), y;
      }
      case Lc: {
        var E = u.get(l, r.data);
        if (!E)
          return [];
        var _ = st(ii(t, e, l, r, cr(qt(E), t.options.actions), o), 2), w = _[0], A = _[1];
        return l = A, v?.push(l), w;
      }
      case gi:
        return tl(u, l, r);
      case Jr: {
        l = Qi(l, r, [u], e), v?.push(l);
        break;
      }
      default:
        var O = Rn(u, t.options.actions), C = O.exec;
        if (C && v) {
          var I = v.length - 1;
          O = M(M({}, O), {
            exec: function(D) {
              for (var $ = [], j = 1; j < arguments.length; j++)
                $[j - 1] = arguments[j];
              C.apply(void 0, mt([v[I]], st($), false));
            }
          });
        }
        return O;
    }
  }).filter(function(u) {
    return !!u;
  }));
  return [f, l];
}
var lr = [];
var Sn = function(t, e) {
  lr.push(t);
  var n = e(t);
  return lr.pop(), n;
};
var ol = function(t) {
  return t(lr[lr.length - 1]);
};
function gs(t) {
  var e;
  return e = {
    id: t,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: t
      };
    }
  }, e[me] = function() {
    return this;
  }, e;
}
function sl(t, e, n, r) {
  var i, o = ps(t.src), s = (i = e?.options.services) === null || i === void 0 ? void 0 : i[o.type], a = t.data ? sr(t.data, n, r) : void 0, c = s ? ys(s, t.id, a) : gs(t.id);
  return c.meta = t, c;
}
function ys(t, e, n) {
  var r = gs(e);
  if (r.deferred = true, Ke(t)) {
    var i = r.state = Sn(void 0, function() {
      return (n ? t.withContext(n) : t).initialState;
    });
    r.getSnapshot = function() {
      return i;
    };
  }
  return r;
}
function al(t) {
  try {
    return typeof t.send == "function";
  } catch {
    return false;
  }
}
function cl(t) {
  return al(t) && "id" in t;
}
function ll(t) {
  var e;
  return M((e = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, e[me] = function() {
    return this;
  }, e), t);
}
var ur = function(t) {
  return t.type === "atomic" || t.type === "final";
};
function Xe(t) {
  return Object.keys(t.states).map(function(e) {
    return t.states[e];
  }).filter(function(e) {
    return e.type !== "history";
  });
}
function ms(t) {
  var e = [t];
  return ur(t) ? e : e.concat(ht(Xe(t).map(ms)));
}
function Ue(t, e) {
  var n, r, i, o, s, a, c, l, v = new Set(t), f = oi(v), u = new Set(e);
  try {
    for (var p = nt(u), h = p.next(); !h.done; h = p.next())
      for (var g = h.value, E = g.parent; E && !u.has(E); )
        u.add(E), E = E.parent;
  } catch (I) {
    n = {
      error: I
    };
  } finally {
    try {
      h && !h.done && (r = p.return) && r.call(p);
    } finally {
      if (n) throw n.error;
    }
  }
  var S = oi(u);
  try {
    for (var y = nt(u), b = y.next(); !b.done; b = y.next()) {
      var g = b.value;
      if (g.type === "compound" && (!S.get(g) || !S.get(g).length))
        f.get(g) ? f.get(g).forEach(function(D) {
          return u.add(D);
        }) : g.initialStateNodes.forEach(function(D) {
          return u.add(D);
        });
      else if (g.type === "parallel")
        try {
          for (var _ = (s = void 0, nt(Xe(g))), w = _.next(); !w.done; w = _.next()) {
            var A = w.value;
            u.has(A) || (u.add(A), f.get(A) ? f.get(A).forEach(function(D) {
              return u.add(D);
            }) : A.initialStateNodes.forEach(function(D) {
              return u.add(D);
            }));
          }
        } catch (D) {
          s = {
            error: D
          };
        } finally {
          try {
            w && !w.done && (a = _.return) && a.call(_);
          } finally {
            if (s) throw s.error;
          }
        }
    }
  } catch (I) {
    i = {
      error: I
    };
  } finally {
    try {
      b && !b.done && (o = y.return) && o.call(y);
    } finally {
      if (i) throw i.error;
    }
  }
  try {
    for (var O = nt(u), C = O.next(); !C.done; C = O.next())
      for (var g = C.value, E = g.parent; E && !u.has(E); )
        u.add(E), E = E.parent;
  } catch (I) {
    c = {
      error: I
    };
  } finally {
    try {
      C && !C.done && (l = O.return) && l.call(O);
    } finally {
      if (c) throw c.error;
    }
  }
  return u;
}
function Es(t, e) {
  var n = e.get(t);
  if (!n)
    return {};
  if (t.type === "compound") {
    var r = n[0];
    if (r) {
      if (ur(r))
        return r.key;
    } else
      return {};
  }
  var i = {};
  return n.forEach(function(o) {
    i[o.key] = Es(o, e);
  }), i;
}
function oi(t) {
  var e, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = nt(t), o = i.next(); !o.done; o = i.next()) {
      var s = o.value;
      r.has(s) || r.set(s, []), s.parent && (r.has(s.parent) || r.set(s.parent, []), r.get(s.parent).push(s));
    }
  } catch (a) {
    e = {
      error: a
    };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return r;
}
function ul(t, e) {
  var n = Ue([t], e);
  return Es(t, oi(n));
}
function tr(t, e) {
  return Array.isArray(t) ? t.some(function(n) {
    return n === e;
  }) : t instanceof Set ? t.has(e) : false;
}
function fl(t) {
  return mt([], st(new Set(ht(mt([], st(t.map(function(e) {
    return e.ownEvents;
  })), false)))), false);
}
function _n(t, e) {
  return e.type === "compound" ? Xe(e).some(function(n) {
    return n.type === "final" && tr(t, n);
  }) : e.type === "parallel" ? Xe(e).every(function(n) {
    return _n(t, n);
  }) : false;
}
function dl(t) {
  return t === void 0 && (t = []), t.reduce(function(e, n) {
    return n.meta !== void 0 && (e[n.id] = n.meta), e;
  }, {});
}
function to(t) {
  return new Set(ht(t.map(function(e) {
    return e.tags;
  })));
}
function Ss(t, e) {
  if (t === e)
    return true;
  if (t === void 0 || e === void 0)
    return false;
  if (it(t) || it(e))
    return t === e;
  var n = Object.keys(t), r = Object.keys(e);
  return n.length === r.length && n.every(function(i) {
    return Ss(t[i], e[i]);
  });
}
function pl(t) {
  return typeof t != "object" || t === null ? false : "value" in t && "_event" in t;
}
function hl(t, e) {
  var n = t.exec, r = M(M({}, t), {
    exec: n !== void 0 ? function() {
      return n(e.context, e.event, {
        action: t,
        state: e,
        _event: e._event
      });
    } : void 0
  });
  return r;
}
var ne = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      var n = this, r;
      this.actions = [], this.activities = Yi, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || Yi, this.meta = dl(e.configuration), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = (r = Array.isArray(e.tags) ? new Set(e.tags) : e.tags) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return fl(n.configuration);
        }
      });
    }
    return t.from = function(e, n) {
      if (e instanceof t)
        return e.context !== n ? new t({
          value: e.value,
          context: n,
          _event: e._event,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          actions: [],
          activities: e.activities,
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : e;
      var r = ar;
      return new t({
        value: e,
        context: n,
        _event: r,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, t.create = function(e) {
      return new t(e);
    }, t.inert = function(e, n) {
      if (e instanceof t) {
        if (!e.actions.length)
          return e;
        var r = ar;
        return new t({
          value: e.value,
          context: n,
          _event: r,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          activities: e.activities,
          configuration: e.configuration,
          transitions: [],
          children: {}
        });
      }
      return t.from(e, n);
    }, t.prototype.toStrings = function(e, n) {
      var r = this;
      if (e === void 0 && (e = this.value), n === void 0 && (n = "."), it(e))
        return [e];
      var i = Object.keys(e);
      return i.concat.apply(i, mt([], st(i.map(function(o) {
        return r.toStrings(e[o], n).map(function(s) {
          return o + n + s;
        });
      })), false));
    }, t.prototype.toJSON = function() {
      var e = this;
      e.configuration, e.transitions;
      var n = e.tags;
      e.machine;
      var r = vi(e, ["configuration", "transitions", "tags", "machine"]);
      return M(M({}, r), {
        tags: Array.from(n)
      });
    }, t.prototype.matches = function(e) {
      return yi(e, this.value);
    }, t.prototype.hasTag = function(e) {
      return this.tags.has(e);
    }, t.prototype.can = function(e) {
      var n;
      Bc(!!this.machine);
      var r = (n = this.machine) === null || n === void 0 ? void 0 : n.getTransitionData(this, e);
      return !!r?.transitions.length && // Check that at least one transition is not forbidden
      r.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, t;
  })()
);
var vl = {
  deferEvents: false
};
var eo = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      this.processingEvent = false, this.queue = [], this.initialized = false, this.options = M(M({}, vl), e);
    }
    return t.prototype.initialize = function(e) {
      if (this.initialized = true, e) {
        if (!this.options.deferEvents) {
          this.schedule(e);
          return;
        }
        this.process(e);
      }
      this.flushEvents();
    }, t.prototype.schedule = function(e) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(e);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(e), this.flushEvents();
    }, t.prototype.clear = function() {
      this.queue = [];
    }, t.prototype.flushEvents = function() {
      for (var e = this.queue.shift(); e; )
        this.process(e), e = this.queue.shift();
    }, t.prototype.process = function(e) {
      this.processingEvent = true;
      try {
        e();
      } catch (n) {
        throw this.clear(), n;
      } finally {
        this.processingEvent = false;
      }
    }, t;
  })()
);
var $r = /* @__PURE__ */ new Map();
var gl = 0;
var zn = {
  bookId: function() {
    return "x:".concat(gl++);
  },
  register: function(t, e) {
    return $r.set(t, e), t;
  },
  get: function(t) {
    return $r.get(t);
  },
  free: function(t) {
    $r.delete(t);
  }
};
function Si() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function yl() {
  var t = Si();
  if (t && "__xstate__" in t)
    return t.__xstate__;
}
function ml(t) {
  if (Si()) {
    var e = yl();
    e && e.register(t);
  }
}
function El(t, e) {
  e === void 0 && (e = {});
  var n = t.initialState, r = /* @__PURE__ */ new Set(), i = [], o = false, s = function() {
    if (!o) {
      for (o = true; i.length > 0; ) {
        var l = i.shift();
        n = t.transition(n, l, c), r.forEach(function(v) {
          return v.next(n);
        });
      }
      o = false;
    }
  }, a = ll({
    id: e.id,
    send: function(l) {
      i.push(l), s();
    },
    getSnapshot: function() {
      return n;
    },
    subscribe: function(l, v, f) {
      var u = ni(l, v, f);
      return r.add(u), u.next(n), {
        unsubscribe: function() {
          r.delete(u);
        }
      };
    }
  }), c = {
    parent: e.parent,
    self: a,
    id: e.id || "anonymous",
    observers: r
  };
  return n = t.start ? t.start(c) : n, a;
}
var si = {
  sync: false,
  autoForward: false
};
var Pt;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
})(Pt || (Pt = {}));
var Sl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n) {
      var r = this;
      n === void 0 && (n = t.defaultOptions), this.machine = e, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = false, this.status = Pt.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this.init = this.start, this.send = function(v, f) {
        if (tn(v))
          return r.batch(v), r.state;
        var u = At(mi(v, f));
        if (r.status === Pt.Stopped)
          return r.state;
        if (r.status !== Pt.Running && !r.options.deferEvents)
          throw new Error('Event "'.concat(u.name, '" was sent to uninitialized service "').concat(
            r.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(u.data)));
        return r.scheduler.schedule(function() {
          r.forward(u);
          var p = r.nextState(u);
          r.update(p, u);
        }), r._state;
      }, this.sendTo = function(v, f) {
        var u = r.parent && (f === Ge.Parent || r.parent.id === f), p = u ? r.parent : it(f) ? r.children.get(f) || zn.get(f) : qc(f) ? f : void 0;
        if (!p) {
          if (!u)
            throw new Error("Unable to send event to child '".concat(f, "' from service '").concat(r.id, "'."));
          return;
        }
        "machine" in p ? p.send(M(M({}, v), {
          name: v.name === Ic ? "".concat(En(r.id)) : v.name,
          origin: r.sessionId
        })) : p.send(v.data);
      };
      var i = M(M({}, t.defaultOptions), n), o = i.clock, s = i.logger, a = i.parent, c = i.id, l = c !== void 0 ? c : e.id;
      this.id = l, this.logger = s, this.clock = o, this.parent = a, this.options = i, this.scheduler = new eo({
        deferEvents: this.options.deferEvents
      }), this.sessionId = zn.bookId();
    }
    return Object.defineProperty(t.prototype, "initialState", {
      get: function() {
        var e = this;
        return this._initialState ? this._initialState : Sn(this, function() {
          return e._initialState = e.machine.initialState, e._initialState;
        });
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "state", {
      get: function() {
        return this._state;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.execute = function(e, n) {
      var r, i;
      try {
        for (var o = nt(e.actions), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          this.exec(a, e, n);
        }
      } catch (c) {
        r = {
          error: c
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.update = function(e, n) {
      var r, i, o, s, a, c, l, v, f = this;
      if (e._sessionid = this.sessionId, this._state = e, this.options.execute && this.execute(this.state), this.children.forEach(function(I) {
        f.state.children[I.id] = I;
      }), this.devTools && this.devTools.send(n.data, e), e.event)
        try {
          for (var u = nt(this.eventListeners), p = u.next(); !p.done; p = u.next()) {
            var h = p.value;
            h(e.event);
          }
        } catch (I) {
          r = {
            error: I
          };
        } finally {
          try {
            p && !p.done && (i = u.return) && i.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      try {
        for (var g = nt(this.listeners), E = g.next(); !E.done; E = g.next()) {
          var h = E.value;
          h(e, e.event);
        }
      } catch (I) {
        o = {
          error: I
        };
      } finally {
        try {
          E && !E.done && (s = g.return) && s.call(g);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var S = nt(this.contextListeners), y = S.next(); !y.done; y = S.next()) {
          var b = y.value;
          b(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (I) {
        a = {
          error: I
        };
      } finally {
        try {
          y && !y.done && (c = S.return) && c.call(S);
        } finally {
          if (a) throw a.error;
        }
      }
      var _ = _n(e.configuration || [], this.machine);
      if (this.state.configuration && _) {
        var w = e.configuration.find(function(I) {
          return I.type === "final" && I.parent === f.machine;
        }), A = w && w.doneData ? sr(w.doneData, e.context, n) : void 0;
        try {
          for (var O = nt(this.doneListeners), C = O.next(); !C.done; C = O.next()) {
            var h = C.value;
            h(Qn(this.id, A));
          }
        } catch (I) {
          l = {
            error: I
          };
        } finally {
          try {
            C && !C.done && (v = O.return) && v.call(O);
          } finally {
            if (l) throw l.error;
          }
        }
        this.stop();
      }
    }, t.prototype.onTransition = function(e) {
      return this.listeners.add(e), this.status === Pt.Running && e(this.state, this.state.event), this;
    }, t.prototype.subscribe = function(e, n, r) {
      var i = this;
      if (!e)
        return {
          unsubscribe: function() {
          }
        };
      var o, s = r;
      return typeof e == "function" ? o = e : (o = e.next.bind(e), s = e.complete.bind(e)), this.listeners.add(o), this.status !== Pt.NotStarted && o(this.state), s && (this.status === Pt.Stopped ? s() : this.onDone(s)), {
        unsubscribe: function() {
          o && i.listeners.delete(o), s && i.doneListeners.delete(s);
        }
      };
    }, t.prototype.onEvent = function(e) {
      return this.eventListeners.add(e), this;
    }, t.prototype.onSend = function(e) {
      return this.sendListeners.add(e), this;
    }, t.prototype.onChange = function(e) {
      return this.contextListeners.add(e), this;
    }, t.prototype.onStop = function(e) {
      return this.stopListeners.add(e), this;
    }, t.prototype.onDone = function(e) {
      return this.doneListeners.add(e), this;
    }, t.prototype.off = function(e) {
      return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
    }, t.prototype.start = function(e) {
      var n = this;
      if (this.status === Pt.Running)
        return this;
      this.machine._init(), zn.register(this.sessionId, this), this.initialized = true, this.status = Pt.Running;
      var r = e === void 0 ? this.initialState : Sn(this, function() {
        return pl(e) ? n.machine.resolveState(e) : n.machine.resolveState(ne.from(e, n.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        n.update(r, ar);
      }), this;
    }, t.prototype.stop = function() {
      var e, n, r, i, o, s, a, c, l, v, f = this;
      try {
        for (var u = nt(this.listeners), p = u.next(); !p.done; p = u.next()) {
          var h = p.value;
          this.listeners.delete(h);
        }
      } catch (C) {
        e = {
          error: C
        };
      } finally {
        try {
          p && !p.done && (n = u.return) && n.call(u);
        } finally {
          if (e) throw e.error;
        }
      }
      try {
        for (var g = nt(this.stopListeners), E = g.next(); !E.done; E = g.next()) {
          var h = E.value;
          h(), this.stopListeners.delete(h);
        }
      } catch (C) {
        r = {
          error: C
        };
      } finally {
        try {
          E && !E.done && (i = g.return) && i.call(g);
        } finally {
          if (r) throw r.error;
        }
      }
      try {
        for (var S = nt(this.contextListeners), y = S.next(); !y.done; y = S.next()) {
          var h = y.value;
          this.contextListeners.delete(h);
        }
      } catch (C) {
        o = {
          error: C
        };
      } finally {
        try {
          y && !y.done && (s = S.return) && s.call(S);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var b = nt(this.doneListeners), _ = b.next(); !_.done; _ = b.next()) {
          var h = _.value;
          this.doneListeners.delete(h);
        }
      } catch (C) {
        a = {
          error: C
        };
      } finally {
        try {
          _ && !_.done && (c = b.return) && c.call(b);
        } finally {
          if (a) throw a.error;
        }
      }
      if (!this.initialized)
        return this;
      mt([], st(this.state.configuration), false).sort(function(C, I) {
        return I.order - C.order;
      }).forEach(function(C) {
        var I, D;
        try {
          for (var $ = nt(C.definition.exit), j = $.next(); !j.done; j = $.next()) {
            var q = j.value;
            f.exec(q, f.state);
          }
        } catch (Z) {
          I = {
            error: Z
          };
        } finally {
          try {
            j && !j.done && (D = $.return) && D.call($);
          } finally {
            if (I) throw I.error;
          }
        }
      }), this.children.forEach(function(C) {
        lt(C.stop) && C.stop();
      }), this.children.clear();
      try {
        for (var w = nt(Object.keys(this.delayedEventsMap)), A = w.next(); !A.done; A = w.next()) {
          var O = A.value;
          this.clock.clearTimeout(this.delayedEventsMap[O]);
        }
      } catch (C) {
        l = {
          error: C
        };
      } finally {
        try {
          A && !A.done && (v = w.return) && v.call(w);
        } finally {
          if (l) throw l.error;
        }
      }
      return this.scheduler.clear(), this.scheduler = new eo({
        deferEvents: this.options.deferEvents
      }), this.initialized = false, this.status = Pt.Stopped, this._initialState = void 0, zn.free(this.sessionId), this;
    }, t.prototype.batch = function(e) {
      var n = this;
      if (!(this.status === Pt.NotStarted && this.options.deferEvents)) {
        if (this.status !== Pt.Running)
          throw new Error(
            // tslint:disable-next-line:max-line-length
            "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
          );
      }
      this.scheduler.schedule(function() {
        var r, i, o = n.state, s = false, a = [], c = function(u) {
          var p = At(u);
          n.forward(p), o = Sn(n, function() {
            return n.machine.transition(o, p);
          }), a.push.apply(a, mt([], st(o.actions.map(function(h) {
            return hl(h, o);
          })), false)), s = s || !!o.changed;
        };
        try {
          for (var l = nt(e), v = l.next(); !v.done; v = l.next()) {
            var f = v.value;
            c(f);
          }
        } catch (u) {
          r = {
            error: u
          };
        } finally {
          try {
            v && !v.done && (i = l.return) && i.call(l);
          } finally {
            if (r) throw r.error;
          }
        }
        o.changed = s, o.actions = a, n.update(o, At(e[e.length - 1]));
      });
    }, t.prototype.sender = function(e) {
      return this.send.bind(this, e);
    }, t.prototype.nextState = function(e) {
      var n = this, r = At(e);
      if (r.name.indexOf(Xi) === 0 && !this.state.nextEvents.some(function(o) {
        return o.indexOf(Xi) === 0;
      }))
        throw r.data.data;
      var i = Sn(this, function() {
        return n.machine.transition(n.state, r);
      });
      return i;
    }, t.prototype.forward = function(e) {
      var n, r;
      try {
        for (var i = nt(this.forwardTo), o = i.next(); !o.done; o = i.next()) {
          var s = o.value, a = this.children.get(s);
          if (!a)
            throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(s, "'."));
          a.send(e);
        }
      } catch (c) {
        n = {
          error: c
        };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
    }, t.prototype.defer = function(e) {
      var n = this;
      this.delayedEventsMap[e.id] = this.clock.setTimeout(function() {
        e.to ? n.sendTo(e._event, e.to) : n.send(e._event);
      }, e.delay);
    }, t.prototype.cancel = function(e) {
      this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
    }, t.prototype.exec = function(e, n, r) {
      r === void 0 && (r = this.machine.options.actions);
      var i = n.context, o = n._event, s = e.exec || ri(e.type, r), a = lt(s) ? s : s ? s.exec : e.exec;
      if (a)
        try {
          return a(i, o.data, {
            action: e,
            state: this.state,
            _event: o
          });
        } catch (_) {
          throw this.parent && this.parent.send({
            type: "xstate.error",
            data: _
          }), _;
        }
      switch (e.type) {
        case xr:
          var c = e;
          if (typeof c.delay == "number") {
            this.defer(c);
            return;
          } else
            c.to ? this.sendTo(c._event, c.to) : this.send(c._event);
          break;
        case rs:
          this.cancel(e.sendId);
          break;
        case Zr: {
          if (this.status !== Pt.Running)
            return;
          var l = e.activity;
          if (!this.state.activities[l.id || l.type])
            break;
          if (l.type === at.Invoke) {
            var v = ps(l.src), f = this.machine.options.services ? this.machine.options.services[v.type] : void 0, u = l.id, p = l.data, h = "autoForward" in l ? l.autoForward : !!l.forward;
            if (!f)
              return;
            var g = p ? sr(p, i, o) : void 0;
            if (typeof f == "string")
              return;
            var E = lt(f) ? f(i, o.data, {
              data: g,
              src: v,
              meta: l.meta
            }) : f;
            if (!E)
              return;
            var S = void 0;
            Ke(E) && (E = g ? E.withContext(g) : E, S = {
              autoForward: h
            }), this.spawn(E, u, S);
          } else
            this.spawnActivity(l);
          break;
        }
        case gi: {
          this.stopChild(e.activity.id);
          break;
        }
        case is:
          var y = e.label, b = e.value;
          y ? this.logger(y, b) : this.logger(b);
          break;
      }
    }, t.prototype.removeChild = function(e) {
      var n;
      this.children.delete(e), this.forwardTo.delete(e), (n = this.state) === null || n === void 0 || delete n.children[e];
    }, t.prototype.stopChild = function(e) {
      var n = this.children.get(e);
      n && (this.removeChild(e), lt(n.stop) && n.stop());
    }, t.prototype.spawn = function(e, n, r) {
      if (Ji(e))
        return this.spawnPromise(Promise.resolve(e), n);
      if (lt(e))
        return this.spawnCallback(e, n);
      if (cl(e))
        return this.spawnActor(e, n);
      if (zc(e))
        return this.spawnObservable(e, n);
      if (Ke(e))
        return this.spawnMachine(e, M(M({}, r), {
          id: n
        }));
      if (Fc(e))
        return this.spawnBehavior(e, n);
      throw new Error('Unable to spawn entity "'.concat(n, '" of type "').concat(typeof e, '".'));
    }, t.prototype.spawnMachine = function(e, n) {
      var r = this;
      n === void 0 && (n = {});
      var i = new t(e, M(M({}, this.options), {
        parent: this,
        id: n.id || e.id
      })), o = M(M({}, si), n);
      o.sync && i.onTransition(function(a) {
        r.send(os, {
          state: a,
          id: i.id
        });
      });
      var s = i;
      return this.children.set(i.id, s), o.autoForward && this.forwardTo.add(i.id), i.onDone(function(a) {
        r.removeChild(i.id), r.send(At(a, {
          origin: i.id
        }));
      }).start(), s;
    }, t.prototype.spawnBehavior = function(e, n) {
      var r = El(e, {
        id: n,
        parent: this
      });
      return this.children.set(n, r), r;
    }, t.prototype.spawnPromise = function(e, n) {
      var r, i = this, o = false, s;
      e.then(function(c) {
        o || (s = c, i.removeChild(n), i.send(At(Qn(n, c), {
          origin: n
        })));
      }, function(c) {
        if (!o) {
          i.removeChild(n);
          var l = En(n, c);
          try {
            i.send(At(l, {
              origin: n
            }));
          } catch {
            i.devTools && i.devTools.send(l, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, l, v) {
          var f = ni(c, l, v), u = false;
          return e.then(function(p) {
            u || (f.next(p), !u && f.complete());
          }, function(p) {
            u || f.error(p);
          }), {
            unsubscribe: function() {
              return u = true;
            }
          };
        },
        stop: function() {
          o = true;
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return s;
        }
      }, r[me] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnCallback = function(e, n) {
      var r, i = this, o = false, s = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), c, l = function(u) {
        c = u, a.forEach(function(p) {
          return p(u);
        }), !o && i.send(At(u, {
          origin: n
        }));
      }, v;
      try {
        v = e(l, function(u) {
          s.add(u);
        });
      } catch (u) {
        this.send(En(n, u));
      }
      if (Ji(v))
        return this.spawnPromise(v, n);
      var f = (r = {
        id: n,
        send: function(u) {
          return s.forEach(function(p) {
            return p(u);
          });
        },
        subscribe: function(u) {
          var p = ni(u);
          return a.add(p.next), {
            unsubscribe: function() {
              a.delete(p.next);
            }
          };
        },
        stop: function() {
          o = true, lt(v) && v();
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return c;
        }
      }, r[me] = function() {
        return this;
      }, r);
      return this.children.set(n, f), f;
    }, t.prototype.spawnObservable = function(e, n) {
      var r, i = this, o, s = e.subscribe(function(c) {
        o = c, i.send(At(c, {
          origin: n
        }));
      }, function(c) {
        i.removeChild(n), i.send(At(En(n, c), {
          origin: n
        }));
      }, function() {
        i.removeChild(n), i.send(At(Qn(n), {
          origin: n
        }));
      }), a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, l, v) {
          return e.subscribe(c, l, v);
        },
        stop: function() {
          return s.unsubscribe();
        },
        getSnapshot: function() {
          return o;
        },
        toJSON: function() {
          return {
            id: n
          };
        }
      }, r[me] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnActor = function(e, n) {
      return this.children.set(n, e), e;
    }, t.prototype.spawnActivity = function(e) {
      var n = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
      if (n) {
        var r = n(this.state.context, e);
        this.spawnEffect(e.id, r);
      }
    }, t.prototype.spawnEffect = function(e, n) {
      var r;
      this.children.set(e, (r = {
        id: e,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: n || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: e
          };
        }
      }, r[me] = function() {
        return this;
      }, r));
    }, t.prototype.attachDev = function() {
      var e = Si();
      if (this.options.devTools && e) {
        if (e.__REDUX_DEVTOOLS_EXTENSION__) {
          var n = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(M(M({
            name: this.id,
            autoPause: true,
            stateSanitizer: function(r) {
              return {
                value: r.value,
                context: r.context,
                actions: r.actions
              };
            }
          }, n), {
            features: M({
              jump: false,
              skip: false
            }, n ? n.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        ml(this);
      }
    }, t.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, t.prototype[me] = function() {
      return this;
    }, t.prototype.getSnapshot = function() {
      return this.status === Pt.NotStarted ? this.initialState : this._state;
    }, t.defaultOptions = {
      execute: true,
      deferEvents: true,
      clock: {
        setTimeout: function(e, n) {
          return setTimeout(e, n);
        },
        clearTimeout: function(e) {
          return clearTimeout(e);
        }
      },
      logger: /* @__PURE__ */ (() => {
      }).bind(console),
      devTools: false
    }, t.interpret = ws, t;
  })()
);
var bl = function(t) {
  return it(t) ? M(M({}, si), {
    name: t
  }) : M(M(M({}, si), {
    name: Vc()
  }), t);
};
function bs(t, e) {
  var n = bl(e);
  return ol(function(r) {
    return r ? r.spawn(t, n.name, n) : ys(t, n.name);
  });
}
function ws(t, e) {
  var n = new Sl(t, e);
  return n;
}
function wl(t) {
  if (typeof t == "string") {
    var e = {
      type: t
    };
    return e.toString = function() {
      return t;
    }, e;
  }
  return t;
}
function qn(t) {
  return M(M({
    type: Qr
  }, t), {
    toJSON: function() {
      t.onDone, t.onError;
      var e = vi(t, ["onDone", "onError"]);
      return M(M({}, e), {
        type: Qr,
        src: wl(t.src)
      });
    }
  });
}
var Vn = "";
var ai = "#";
var kr = "*";
var Me = {};
var He = function(t) {
  return t[0] === ai;
};
var xl = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};
var _l = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n, r, i) {
      var o = this;
      r === void 0 && (r = "context" in e ? e.context : void 0);
      var s;
      this.config = e, this._context = r, this.order = -1, this.__xstatenode = true, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(xl(), n), this.parent = i?.parent, this.key = this.config.key || i?.key || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : ss), this.id = this.config.id || mt([this.machine.key], st(this.path), false).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (s = this.config.schema) !== null && s !== void 0 ? s : {}, this.description = this.config.description, this.initial = this.config.initial, this.states = this.config.states ? mn(this.config.states, function(l, v) {
        var f, u = new t(l, {}, void 0, {
          parent: o,
          key: v
        });
        return Object.assign(o.idMap, M((f = {}, f[u.id] = u, f), u.idMap)), u;
      }) : Me;
      var a = 0;
      function c(l) {
        var v, f;
        l.order = a++;
        try {
          for (var u = nt(Xe(l)), p = u.next(); !p.done; p = u.next()) {
            var h = p.value;
            c(h);
          }
        } catch (g) {
          v = {
            error: g
          };
        } finally {
          try {
            p && !p.done && (f = u.return) && f.call(u);
          } finally {
            if (v) throw v.error;
          }
        }
      }
      c(this), this.history = this.config.history === true ? "shallow" : this.config.history || false, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(l) {
        var v = l.event;
        return v === Vn;
      }) : Vn in this.config.on : false), this.strict = !!this.config.strict, this.onEntry = qt(this.config.entry || this.config.onEntry).map(function(l) {
        return Rn(l);
      }), this.onExit = qt(this.config.exit || this.config.onExit).map(function(l) {
        return Rn(l);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = qt(this.config.invoke).map(function(l, v) {
        var f, u;
        if (Ke(l)) {
          var p = Un(o.id, v);
          return o.machine.options.services = M((f = {}, f[p] = l, f), o.machine.options.services), qn({
            src: p,
            id: p
          });
        } else if (it(l.src)) {
          var p = l.id || Un(o.id, v);
          return qn(M(M({}, l), {
            id: p,
            src: l.src
          }));
        } else if (Ke(l.src) || lt(l.src)) {
          var p = l.id || Un(o.id, v);
          return o.machine.options.services = M((u = {}, u[p] = l.src, u), o.machine.options.services), qn(M(M({
            id: p
          }, l), {
            src: p
          }));
        } else {
          var h = l.src;
          return qn(M(M({
            id: Un(o.id, v)
          }, l), {
            src: h
          }));
        }
      }), this.activities = qt(this.config.activities).concat(this.invoke).map(function(l) {
        return Ei(l);
      }), this.transition = this.transition.bind(this), this.tags = qt(this.config.tags);
    }
    return t.prototype._init = function() {
      this.__cache.transitions || ms(this).forEach(function(e) {
        return e.on;
      });
    }, t.prototype.withConfig = function(e, n) {
      var r = this.options, i = r.actions, o = r.activities, s = r.guards, a = r.services, c = r.delays;
      return new t(this.config, {
        actions: M(M({}, i), e.actions),
        activities: M(M({}, o), e.activities),
        guards: M(M({}, s), e.guards),
        services: M(M({}, a), e.services),
        delays: M(M({}, c), e.delays)
      }, n ?? this.context);
    }, t.prototype.withContext = function(e) {
      return new t(this.config, this.options, e);
    }, Object.defineProperty(t.prototype, "context", {
      get: function() {
        return lt(this._context) ? this._context() : this._context;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: mn(this.states, function(e) {
            return e.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: false,
      configurable: true
    }), t.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(t.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var e = this.transitions;
        return this.__cache.on = e.reduce(function(n, r) {
          return n[r.eventType] = n[r.eventType] || [], n[r.eventType].push(r), n;
        }, {});
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getCandidates = function(e) {
      if (this.__cache.candidates[e])
        return this.__cache.candidates[e];
      var n = e === Vn, r = this.transitions.filter(function(i) {
        var o = i.eventType === e;
        return n ? o : o || i.eventType === kr;
      });
      return this.__cache.candidates[e] = r, r;
    }, t.prototype.getDelayedTransitions = function() {
      var e = this, n = this.config.after;
      if (!n)
        return [];
      var r = function(o, s) {
        var a = lt(o) ? "".concat(e.id, ":delay[").concat(s, "]") : o, c = nl(a, e.id);
        return e.onEntry.push(An(c, {
          delay: o
        })), e.onExit.push(Zc(c)), c;
      }, i = tn(n) ? n.map(function(o, s) {
        var a = r(o.delay, s);
        return M(M({}, o), {
          event: a
        });
      }) : ht(Object.keys(n).map(function(o, s) {
        var a = n[o], c = it(a) ? {
          target: a
        } : a, l = isNaN(+o) ? o : +o, v = r(l, s);
        return qt(c).map(function(f) {
          return M(M({}, f), {
            event: v,
            delay: l
          });
        });
      }));
      return i.map(function(o) {
        var s = o.delay;
        return M(M({}, e.formatTransition(o)), {
          delay: s
        });
      });
    }, t.prototype.getStateNodes = function(e) {
      var n, r = this;
      if (!e)
        return [];
      var i = e instanceof ne ? e.value : xn(e, this.delimiter);
      if (it(i)) {
        var o = this.getStateNode(i).initial;
        return o !== void 0 ? this.getStateNodes((n = {}, n[i] = o, n)) : [this, this.states[i]];
      }
      var s = Object.keys(i), a = [this];
      return a.push.apply(a, mt([], st(ht(s.map(function(c) {
        return r.getStateNode(c).getStateNodes(i[c]);
      }))), false)), a;
    }, t.prototype.handles = function(e) {
      var n = as(e);
      return this.events.includes(n);
    }, t.prototype.resolveState = function(e) {
      var n = e instanceof ne ? e : ne.create(e), r = Array.from(Ue([], this.getStateNodes(n.value)));
      return new ne(M(M({}, n), {
        value: this.resolve(n.value),
        configuration: r,
        done: _n(r, this),
        tags: to(r),
        machine: this.machine
      }));
    }, t.prototype.transitionLeafNode = function(e, n, r) {
      var i = this.getStateNode(e), o = i.next(n, r);
      return !o || !o.transitions.length ? this.next(n, r) : o;
    }, t.prototype.transitionCompoundNode = function(e, n, r) {
      var i = Object.keys(e), o = this.getStateNode(i[0]), s = o._transition(e[i[0]], n, r);
      return !s || !s.transitions.length ? this.next(n, r) : s;
    }, t.prototype.transitionParallelNode = function(e, n, r) {
      var i, o, s = {};
      try {
        for (var a = nt(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
          var l = c.value, v = e[l];
          if (v) {
            var f = this.getStateNode(l), u = f._transition(v, n, r);
            u && (s[l] = u);
          }
        }
      } catch (y) {
        i = {
          error: y
        };
      } finally {
        try {
          c && !c.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      var p = Object.keys(s).map(function(y) {
        return s[y];
      }), h = ht(p.map(function(y) {
        return y.transitions;
      })), g = p.some(function(y) {
        return y.transitions.length > 0;
      });
      if (!g)
        return this.next(n, r);
      var E = ht(p.map(function(y) {
        return y.entrySet;
      })), S = ht(Object.keys(s).map(function(y) {
        return s[y].configuration;
      }));
      return {
        transitions: h,
        entrySet: E,
        exitSet: ht(p.map(function(y) {
          return y.exitSet;
        })),
        configuration: S,
        source: n,
        actions: ht(Object.keys(s).map(function(y) {
          return s[y].actions;
        }))
      };
    }, t.prototype._transition = function(e, n, r) {
      return it(e) ? this.transitionLeafNode(e, n, r) : Object.keys(e).length === 1 ? this.transitionCompoundNode(e, n, r) : this.transitionParallelNode(e, n, r);
    }, t.prototype.getTransitionData = function(e, n) {
      return this._transition(e.value, e, At(n));
    }, t.prototype.next = function(e, n) {
      var r, i, o = this, s = n.name, a = [], c = [], l;
      try {
        for (var v = nt(this.getCandidates(s)), f = v.next(); !f.done; f = v.next()) {
          var u = f.value, p = u.cond, h = u.in, g = e.context, E = h ? it(h) && He(h) ? (
            // Check if in state by ID
            e.matches(xn(this.getStateNodeById(h).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            yi(xn(h, this.delimiter), Mc(this.path.slice(0, -2))(e.value))
          ) : true, S = false;
          try {
            S = !p || ds(this.machine, p, g, n, e);
          } catch (w) {
            throw new Error("Unable to evaluate guard '".concat(p.name || p.type, "' in transition for event '").concat(s, "' in state node '").concat(this.id, `':
`).concat(w.message));
          }
          if (S && E) {
            u.target !== void 0 && (c = u.target), a.push.apply(a, mt([], st(u.actions), false)), l = u;
            break;
          }
        }
      } catch (w) {
        r = {
          error: w
        };
      } finally {
        try {
          f && !f.done && (i = v.return) && i.call(v);
        } finally {
          if (r) throw r.error;
        }
      }
      if (l) {
        if (!c.length)
          return {
            transitions: [l],
            entrySet: [],
            exitSet: [],
            configuration: e.value ? [this] : [],
            source: e,
            actions: a
          };
        var y = ht(c.map(function(w) {
          return o.getRelativeStateNodes(w, e.historyValue);
        })), b = !!l.internal, _ = b ? [] : ht(y.map(function(w) {
          return o.nodesFromChild(w);
        }));
        return {
          transitions: [l],
          entrySet: _,
          exitSet: b ? [] : [this],
          configuration: y,
          source: e,
          actions: a
        };
      }
    }, t.prototype.nodesFromChild = function(e) {
      if (e.escapes(this))
        return [];
      for (var n = [], r = e; r && r !== this; )
        n.push(r), r = r.parent;
      return n.push(this), n;
    }, t.prototype.escapes = function(e) {
      if (this === e)
        return false;
      for (var n = this.parent; n; ) {
        if (n === e)
          return false;
        n = n.parent;
      }
      return true;
    }, t.prototype.getActions = function(e, n, r, i) {
      var o, s, a, c, l = Ue([], i ? this.getStateNodes(i.value) : [this]), v = e.configuration.length ? Ue(l, e.configuration) : l;
      try {
        for (var f = nt(v), u = f.next(); !u.done; u = f.next()) {
          var p = u.value;
          tr(l, p) || e.entrySet.push(p);
        }
      } catch (O) {
        o = {
          error: O
        };
      } finally {
        try {
          u && !u.done && (s = f.return) && s.call(f);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var h = nt(l), g = h.next(); !g.done; g = h.next()) {
          var p = g.value;
          (!tr(v, p) || tr(e.exitSet, p.parent)) && e.exitSet.push(p);
        }
      } catch (O) {
        a = {
          error: O
        };
      } finally {
        try {
          g && !g.done && (c = h.return) && c.call(h);
        } finally {
          if (a) throw a.error;
        }
      }
      var E = ht(e.entrySet.map(function(O) {
        var C = [];
        if (O.type !== "final")
          return C;
        var I = O.parent;
        if (!I.parent)
          return C;
        C.push(
          Bn(O.id, O.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          Bn(I.id, O.doneData ? sr(O.doneData, n, r) : void 0)
        );
        var D = I.parent;
        return D.type === "parallel" && Xe(D).every(function($) {
          return _n(e.configuration, $);
        }) && C.push(Bn(D.id)), C;
      }));
      e.exitSet.sort(function(O, C) {
        return C.order - O.order;
      }), e.entrySet.sort(function(O, C) {
        return O.order - C.order;
      });
      var S = new Set(e.entrySet), y = new Set(e.exitSet), b = st([ht(Array.from(S).map(function(O) {
        return mt(mt([], st(O.activities.map(function(C) {
          return Jc(C);
        })), false), st(O.onEntry), false);
      })).concat(E.map(hs)), ht(Array.from(y).map(function(O) {
        return mt(mt([], st(O.onExit), false), st(O.activities.map(function(C) {
          return Qc(C);
        })), false);
      }))], 2), _ = b[0], w = b[1], A = cr(w.concat(e.actions).concat(_), this.machine.options.actions);
      return A;
    }, t.prototype.transition = function(e, n, r) {
      e === void 0 && (e = this.initialState);
      var i = At(n), o;
      if (e instanceof ne)
        o = r === void 0 ? e : this.resolveState(ne.from(e, r));
      else {
        var s = it(e) ? this.resolve(or(this.getResolvedPath(e))) : this.resolve(e), a = r ?? this.machine.context;
        o = this.resolveState(ne.from(s, a));
      }
      if (this.strict && !this.events.includes(i.name) && !jc(i.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(i.name, "'"));
      var c = this._transition(o.value, o, i) || {
        transitions: [],
        configuration: [],
        entrySet: [],
        exitSet: [],
        source: o,
        actions: []
      }, l = Ue([], this.getStateNodes(o.value)), v = c.configuration.length ? Ue(l, c.configuration) : l;
      return c.configuration = mt([], st(v), false), this.resolveTransition(c, o, o.context, i);
    }, t.prototype.resolveRaisedTransition = function(e, n, r) {
      var i, o = e.actions;
      return e = this.transition(e, n), e._event = r, e.event = r.data, (i = e.actions).unshift.apply(i, mt([], st(o), false)), e;
    }, t.prototype.resolveTransition = function(e, n, r, i) {
      var o, s, a = this;
      i === void 0 && (i = ar);
      var c = e.configuration, l = !n || e.transitions.length > 0, v = l ? ul(this.machine, c) : void 0, f = n ? n.historyValue ? n.historyValue : e.source ? this.machine.historyValue(n.value) : void 0 : void 0, u = this.getActions(e, r, i, n), p = n ? M({}, n.activities) : {};
      try {
        for (var h = nt(u), g = h.next(); !g.done; g = h.next()) {
          var E = g.value;
          E.type === Zr ? p[E.activity.id || E.activity.type] = E : E.type === gi && (p[E.activity.id || E.activity.type] = false);
        }
      } catch (V) {
        o = {
          error: V
        };
      } finally {
        try {
          g && !g.done && (s = h.return) && s.call(h);
        } finally {
          if (o) throw o.error;
        }
      }
      var S = st(ii(this, n, r, i, u, this.machine.config.preserveActionOrder), 2), y = S[0], b = S[1], _ = st(ls(y, function(V) {
        return V.type === wr || V.type === xr && V.to === Ge.Internal;
      }), 2), w = _[0], A = _[1], O = y.filter(function(V) {
        var ft;
        return V.type === Zr && ((ft = V.activity) === null || ft === void 0 ? void 0 : ft.type) === Qr;
      }), C = O.reduce(function(V, ft) {
        return V[ft.activity.id] = sl(ft.activity, a.machine, b, i), V;
      }, n ? M({}, n.children) : {}), I = l ? e.configuration : n ? n.configuration : [], D = _n(I, this), $ = new ne({
        value: v || n.value,
        context: b,
        _event: i,
        // Persist _sessionid between states
        _sessionid: n ? n._sessionid : null,
        historyValue: v ? f ? Uc(f, v) : void 0 : n ? n.historyValue : void 0,
        history: !v || e.source ? n : void 0,
        actions: v ? A : [],
        activities: v ? p : n ? n.activities : {},
        events: [],
        configuration: I,
        transitions: e.transitions,
        children: C,
        done: D,
        tags: to(I),
        machine: this
      }), j = r !== b;
      $.changed = i.name === os || j;
      var q = $.history;
      q && delete q.history;
      var Z = !D && (this._transient || c.some(function(V) {
        return V._transient;
      }));
      if (!l && (!Z || i.name === Vn))
        return $;
      var K = $;
      if (!D)
        for (Z && (K = this.resolveRaisedTransition(K, {
          type: Nc
        }, i)); w.length; ) {
          var rt = w.shift();
          K = this.resolveRaisedTransition(K, rt._event, i);
        }
      var ct = K.changed || (q ? !!K.actions.length || j || typeof q.value != typeof K.value || !Ss(K.value, q.value) : void 0);
      return K.changed = ct, K.history = q, K;
    }, t.prototype.getStateNode = function(e) {
      if (He(e))
        return this.machine.getStateNodeById(e);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(e, "' from '").concat(this.id, "'; no child states exist."));
      var n = this.states[e];
      if (!n)
        throw new Error("Child state '".concat(e, "' does not exist on '").concat(this.id, "'"));
      return n;
    }, t.prototype.getStateNodeById = function(e) {
      var n = He(e) ? e.slice(ai.length) : e;
      if (n === this.id)
        return this;
      var r = this.machine.idMap[n];
      if (!r)
        throw new Error("Child state node '#".concat(n, "' does not exist on machine '").concat(this.id, "'"));
      return r;
    }, t.prototype.getStateNodeByPath = function(e) {
      if (typeof e == "string" && He(e))
        try {
          return this.getStateNodeById(e.slice(1));
        } catch {
        }
      for (var n = ei(e, this.delimiter).slice(), r = this; n.length; ) {
        var i = n.shift();
        if (!i.length)
          break;
        r = r.getStateNode(i);
      }
      return r;
    }, t.prototype.resolve = function(e) {
      var n, r = this;
      if (!e)
        return this.initialStateValue || Me;
      switch (this.type) {
        case "parallel":
          return mn(this.initialStateValue, function(o, s) {
            return o ? r.getStateNode(s).resolve(e[s] || o) : Me;
          });
        case "compound":
          if (it(e)) {
            var i = this.getStateNode(e);
            return i.type === "parallel" || i.type === "compound" ? (n = {}, n[e] = i.initialStateValue, n) : e;
          }
          return Object.keys(e).length ? mn(e, function(o, s) {
            return o ? r.getStateNode(s).resolve(o) : Me;
          }) : this.initialStateValue || {};
        default:
          return e || Me;
      }
    }, t.prototype.getResolvedPath = function(e) {
      if (He(e)) {
        var n = this.machine.idMap[e.slice(ai.length)];
        if (!n)
          throw new Error("Unable to find state node '".concat(e, "'"));
        return n.path;
      }
      return ei(e, this.delimiter);
    }, Object.defineProperty(t.prototype, "initialStateValue", {
      get: function() {
        var e;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var n;
        if (this.type === "parallel")
          n = Zi(this.states, function(r) {
            return r.initialStateValue || Me;
          }, function(r) {
            return r.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          n = ur(this.states[this.initial]) ? this.initial : (e = {}, e[this.initial] = this.states[this.initial].initialStateValue, e);
        } else
          n = {};
        return this.__cache.initialStateValue = n, this.__cache.initialStateValue;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getInitialState = function(e, n) {
      this._init();
      var r = this.getStateNodes(e);
      return this.resolveTransition({
        configuration: r,
        entrySet: r,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, n ?? this.machine.context, void 0);
    }, Object.defineProperty(t.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var e = this.initialStateValue;
        if (!e)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(e);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var e;
        if (this.type === "history") {
          var n = this.config;
          it(n.target) ? e = He(n.target) ? or(this.machine.getStateNodeById(n.target).path.slice(this.path.length - 1)) : n.target : e = n.target;
        }
        return e;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getRelativeStateNodes = function(e, n, r) {
      return r === void 0 && (r = true), r ? e.type === "history" ? e.resolveHistory(n) : e.initialStateNodes : [e];
    }, Object.defineProperty(t.prototype, "initialStateNodes", {
      get: function() {
        var e = this;
        if (ur(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return [this];
        var n = Jn(this.initialStateValue);
        return ht(n.map(function(r) {
          return e.getFromRelativePath(r);
        }));
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getFromRelativePath = function(e) {
      if (!e.length)
        return [this];
      var n = st(e), r = n[0], i = n.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(r, "' from node with no states"));
      var o = this.getStateNode(r);
      if (o.type === "history")
        return o.resolveHistory();
      if (!this.states[r])
        throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
      return this.states[r].getFromRelativePath(i);
    }, t.prototype.historyValue = function(e) {
      if (Object.keys(this.states).length)
        return {
          current: e || this.initialStateValue,
          states: Zi(this.states, function(n, r) {
            if (!e)
              return n.historyValue();
            var i = it(e) ? void 0 : e[r];
            return n.historyValue(i || n.initialStateValue);
          }, function(n) {
            return !n.history;
          })
        };
    }, t.prototype.resolveHistory = function(e) {
      var n = this;
      if (this.type !== "history")
        return [this];
      var r = this.parent;
      if (!e) {
        var i = this.target;
        return i ? ht(Jn(i).map(function(s) {
          return r.getFromRelativePath(s);
        })) : r.initialStateNodes;
      }
      var o = Hc(r.path, "states")(e).current;
      return it(o) ? [r.getStateNode(o)] : ht(Jn(o).map(function(s) {
        return n.history === "deep" ? r.getFromRelativePath(s) : [r.states[s[0]]];
      }));
    }, Object.defineProperty(t.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var e = this, n = ht(Object.keys(this.states).map(function(r) {
          return e.states[r].stateIds;
        }));
        return [this.id].concat(n);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var e, n, r, i;
        if (this.__cache.events)
          return this.__cache.events;
        var o = this.states, s = new Set(this.ownEvents);
        if (o)
          try {
            for (var a = nt(Object.keys(o)), c = a.next(); !c.done; c = a.next()) {
              var l = c.value, v = o[l];
              if (v.states)
                try {
                  for (var f = (r = void 0, nt(v.events)), u = f.next(); !u.done; u = f.next()) {
                    var p = u.value;
                    s.add("".concat(p));
                  }
                } catch (h) {
                  r = {
                    error: h
                  };
                } finally {
                  try {
                    u && !u.done && (i = f.return) && i.call(f);
                  } finally {
                    if (r) throw r.error;
                  }
                }
            }
          } catch (h) {
            e = {
              error: h
            };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
        return this.__cache.events = Array.from(s);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var e = new Set(this.transitions.filter(function(n) {
          return !(!n.target && !n.actions.length && n.internal);
        }).map(function(n) {
          return n.eventType;
        }));
        return Array.from(e);
      },
      enumerable: false,
      configurable: true
    }), t.prototype.resolveTarget = function(e) {
      var n = this;
      if (e !== void 0)
        return e.map(function(r) {
          if (!it(r))
            return r;
          var i = r[0] === n.delimiter;
          if (i && !n.parent)
            return n.getStateNodeByPath(r.slice(1));
          var o = i ? n.key + r : r;
          if (n.parent)
            try {
              var s = n.parent.getStateNodeByPath(o);
              return s;
            } catch (a) {
              throw new Error("Invalid transition definition for state node '".concat(n.id, `':
`).concat(a.message));
            }
          else
            return n.getStateNodeByPath(o);
        });
    }, t.prototype.formatTransition = function(e) {
      var n = this, r = Wc(e.target), i = "internal" in e ? e.internal : r ? r.some(function(c) {
        return it(c) && c[0] === n.delimiter;
      }) : true, o = this.machine.options.guards, s = this.resolveTarget(r), a = M(M({}, e), {
        actions: cr(qt(e.actions)),
        cond: fs(e.cond, o),
        target: s,
        source: this,
        internal: i,
        eventType: e.event,
        toJSON: function() {
          return M(M({}, a), {
            target: a.target ? a.target.map(function(c) {
              return "#".concat(c.id);
            }) : void 0,
            source: "#".concat(n.id)
          });
        }
      });
      return a;
    }, t.prototype.formatTransitions = function() {
      var e, n, r = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var o = this.config.on, s = kr, a = o[s], c = a === void 0 ? [] : a, l = vi(o, [typeof s == "symbol" ? s : s + ""]);
        i = ht(Object.keys(l).map(function(y) {
          var b = ke(y, l[y]);
          return b;
        }).concat(ke(kr, c)));
      }
      var v = this.config.always ? ke("", this.config.always) : [], f = this.config.onDone ? ke(String(Bn(this.id)), this.config.onDone) : [], u = ht(this.invoke.map(function(y) {
        var b = [];
        return y.onDone && b.push.apply(b, mt([], st(ke(String(Qn(y.id)), y.onDone)), false)), y.onError && b.push.apply(b, mt([], st(ke(String(En(y.id)), y.onError)), false)), b;
      })), p = this.after, h = ht(mt(mt(mt(mt([], st(f), false), st(u), false), st(i), false), st(v), false).map(function(y) {
        return qt(y).map(function(b) {
          return r.formatTransition(b);
        });
      }));
      try {
        for (var g = nt(p), E = g.next(); !E.done; E = g.next()) {
          var S = E.value;
          h.push(S);
        }
      } catch (y) {
        e = {
          error: y
        };
      } finally {
        try {
          E && !E.done && (n = g.return) && n.call(g);
        } finally {
          if (e) throw e.error;
        }
      }
      return h;
    }, t;
  })()
);
function _r(t, e) {
  return new _l(t, e);
}
var Et = el;
var Tr = An;
var Ft = Xc;
var je = il;
function no(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ro(t) {
  var e, n;
  return no(t) === false ? false : (e = t.constructor, e === void 0 ? true : (n = e.prototype, !(no(n) === false || n.hasOwnProperty("isPrototypeOf") === false)));
}
var Ut = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Tl(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var i = false;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: true }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: true,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var er = { exports: {} };
var Rl = er.exports;
var io;
function Cl() {
  return io || (io = 1, (function(t) {
    (function(e, n) {
      t.exports = n();
    })(Rl, function() {
      var e = Object.prototype.toString;
      function n(f, u) {
        return f == null ? false : Object.prototype.hasOwnProperty.call(f, u);
      }
      function r(f) {
        if (!f || s(f) && f.length === 0)
          return true;
        if (typeof f != "string") {
          for (var u in f)
            if (n(f, u))
              return false;
          return true;
        }
        return false;
      }
      function i(f) {
        return e.call(f);
      }
      function o(f) {
        return typeof f == "object" && i(f) === "[object Object]";
      }
      var s = Array.isArray || function(f) {
        return e.call(f) === "[object Array]";
      };
      function a(f) {
        return typeof f == "boolean" || i(f) === "[object Boolean]";
      }
      function c(f) {
        var u = parseInt(f);
        return u.toString() === f ? u : f;
      }
      function l(f) {
        f = f || {};
        var u = function(S) {
          return Object.keys(u).reduce(function(y, b) {
            return b === "create" || typeof u[b] == "function" && (y[b] = u[b].bind(u, S)), y;
          }, {});
        }, p;
        f.includeInheritedProps ? p = function() {
          return true;
        } : p = function(S, y) {
          return typeof y == "number" && Array.isArray(S) || n(S, y);
        };
        function h(S, y) {
          if (p(S, y))
            return S[y];
        }
        var g;
        f.includeInheritedProps ? g = function(S, y) {
          typeof y != "string" && typeof y != "number" && (y = String(y));
          var b = h(S, y);
          if (y === "__proto__" || y === "prototype" || y === "constructor" && typeof b == "function")
            throw new Error("For security reasons, object's magic properties cannot be set");
          return b;
        } : g = function(S, y) {
          return h(S, y);
        };
        function E(S, y, b, _) {
          if (typeof y == "number" && (y = [y]), !y || y.length === 0)
            return S;
          if (typeof y == "string")
            return E(S, y.split(".").map(c), b, _);
          var w = y[0], A = g(S, w);
          return y.length === 1 ? ((A === void 0 || !_) && (S[w] = b), A) : (A === void 0 && (typeof y[1] == "number" ? S[w] = [] : S[w] = {}), E(S[w], y.slice(1), b, _));
        }
        return u.has = function(S, y) {
          if (typeof y == "number" ? y = [y] : typeof y == "string" && (y = y.split(".")), !y || y.length === 0)
            return !!S;
          for (var b = 0; b < y.length; b++) {
            var _ = c(y[b]);
            if (typeof _ == "number" && s(S) && _ < S.length || (f.includeInheritedProps ? _ in Object(S) : n(S, _)))
              S = S[_];
            else
              return false;
          }
          return true;
        }, u.ensureExists = function(S, y, b) {
          return E(S, y, b, true);
        }, u.set = function(S, y, b, _) {
          return E(S, y, b, _);
        }, u.insert = function(S, y, b, _) {
          var w = u.get(S, y);
          _ = ~~_, s(w) || (w = [], u.set(S, y, w)), w.splice(_, 0, b);
        }, u.empty = function(S, y) {
          if (!r(y) && S != null) {
            var b, _;
            if (b = u.get(S, y)) {
              if (typeof b == "string")
                return u.set(S, y, "");
              if (a(b))
                return u.set(S, y, false);
              if (typeof b == "number")
                return u.set(S, y, 0);
              if (s(b))
                b.length = 0;
              else if (o(b))
                for (_ in b)
                  p(b, _) && delete b[_];
              else
                return u.set(S, y, null);
            }
          }
        }, u.push = function(S, y) {
          var b = u.get(S, y);
          s(b) || (b = [], u.set(S, y, b)), b.push.apply(b, Array.prototype.slice.call(arguments, 2));
        }, u.coalesce = function(S, y, b) {
          for (var _, w = 0, A = y.length; w < A; w++)
            if ((_ = u.get(S, y[w])) !== void 0)
              return _;
          return b;
        }, u.get = function(S, y, b) {
          if (typeof y == "number" && (y = [y]), !y || y.length === 0)
            return S;
          if (S == null)
            return b;
          if (typeof y == "string")
            return u.get(S, y.split("."), b);
          var _ = c(y[0]), w = g(S, _);
          return w === void 0 ? b : y.length === 1 ? w : u.get(S[_], y.slice(1), b);
        }, u.del = function(y, b) {
          if (typeof b == "number" && (b = [b]), y == null || r(b))
            return y;
          if (typeof b == "string")
            return u.del(y, b.split("."));
          var _ = c(b[0]);
          if (g(y, _), !p(y, _))
            return y;
          if (b.length === 1)
            s(y) ? y.splice(_, 1) : delete y[_];
          else
            return u.del(y[_], b.slice(1));
          return y;
        }, u;
      }
      var v = l();
      return v.create = l, v.withInheritedProps = l({ includeInheritedProps: true }), v;
    });
  })(er)), er.exports;
}
var Ol = Cl();
var Al = /* @__PURE__ */ Pe(Ol);
var ze = Object.prototype.hasOwnProperty;
function Xt(t) {
  if (ci(t))
    return false;
  if (!t || Ye(t) && t.length === 0)
    return true;
  if (!xs(t)) {
    for (var e in t)
      if (ze.call(t, e))
        return false;
    return true;
  }
  return false;
}
function ci(t) {
  return typeof t == "number";
}
function xs(t) {
  return typeof t == "string";
}
function Ye(t) {
  return Array.isArray(t);
}
function li(t, e) {
  for (var n in e)
    ze.call(e, n) && (t[n] = e[n]);
  return t;
}
function Nl(t) {
  var e = parseInt(t);
  return e.toString() === t ? e : t;
}
function fr(t, e, n) {
  return t == null ? e ? n ? [] : {} : t : Ye(t) ? t.slice() : li({}, t);
}
function dr(t, e) {
  if (t !== e && ro(t) && ro(e)) {
    var n = {};
    for (var r in t)
      ze.call(t, r) && (ze.call(e, r) ? n[r] = dr(t[r], e[r]) : n[r] = t[r]);
    for (r in e)
      ze.call(e, r) && (n[r] = dr(t[r], e[r]));
    return n;
  }
  return e;
}
function se(t, e, n, r) {
  if (ci(n) && (n = [n]), Xt(n))
    return e;
  if (xs(n))
    return se(t, e, n.split(".").map(Nl), r);
  var i = n[0];
  return (!t || t === e) && (t = fr(e, true, ci(i))), n.length === 1 ? r(t, i) : (e != null && (e = e[i]), t[i] = se(t[i], e, n.slice(1), r), t);
}
var $t = {};
$t.set = function(e, n, r, i) {
  return Xt(r) ? i : se(e, n, r, function(o, s) {
    return o[s] = i, o;
  });
};
$t.update = function(e, n, r, i) {
  return Xt(r) ? i(fr(n)) : se(e, n, r, function(o, s) {
    return o[s] = i(o[s]), o;
  });
};
$t.push = function(e, n, r) {
  var i = Array.prototype.slice.call(arguments, 3);
  return Xt(r) ? Ye(n) ? n.concat(i) : i : se(e, n, r, function(o, s) {
    return Ye(o[s]) ? o[s] = o[s].concat(i) : o[s] = i, o;
  });
};
$t.insert = function(e, n, r, i, o) {
  if (o = ~~o, Xt(r)) {
    if (!Ye(n))
      return [i];
    var s = n.slice(0, o);
    return s.push(i), s.concat(n.slice(o));
  }
  return se(e, n, r, function(a, c) {
    var l = a[c];
    if (!Ye(l)) {
      if (l != null && typeof l < "u")
        throw new Error("Expected " + r + "to be an array. Instead got " + typeof r);
      l = [];
    }
    var v = l.slice(0, o);
    return v.push(i), a[c] = v.concat(l.slice(o)), a;
  });
};
$t.del = function(e, n, r) {
  if (!Xt(r))
    return se(e, n, r, function(i, o) {
      return Array.isArray(i) ? i[o] !== void 0 && i.splice(o, 1) : ze.call(i, o) && delete i[o], i;
    });
};
$t.assign = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : li(fr(n), i) : se(e, n, r, function(o, s) {
    i = Object(i);
    var a = fr(o[s], true);
    return li(a, i), o[s] = a, o;
  });
};
$t.merge = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : dr(n, i) : se(e, n, r, function(o, s) {
    return i = Object(i), o[s] = dr(o[s], i), o;
  });
};
var Pl = $t.set.bind(null, null);
var nr = $t.update.bind(null, null);
$t.push.bind(null, null);
$t.insert.bind(null, null);
$t.del.bind(null, null);
$t.assign.bind(null, null);
$t.merge.bind(null, null);
var Il = Al.get;
var Wn;
var Dl = new Uint8Array(16);
function Ll() {
  if (!Wn && (Wn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Wn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Wn(Dl);
}
var $l = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function kl(t) {
  return typeof t == "string" && $l.test(t);
}
var Ct = [];
for (Mr = 0; Mr < 256; ++Mr)
  Ct.push((Mr + 256).toString(16).substr(1));
var Mr;
function Ml(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (Ct[t[e + 0]] + Ct[t[e + 1]] + Ct[t[e + 2]] + Ct[t[e + 3]] + "-" + Ct[t[e + 4]] + Ct[t[e + 5]] + "-" + Ct[t[e + 6]] + Ct[t[e + 7]] + "-" + Ct[t[e + 8]] + Ct[t[e + 9]] + "-" + Ct[t[e + 10]] + Ct[t[e + 11]] + Ct[t[e + 12]] + Ct[t[e + 13]] + Ct[t[e + 14]] + Ct[t[e + 15]]).toLowerCase();
  if (!kl(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function Hl(t, e, n) {
  t = t || {};
  var r = t.random || (t.rng || Ll)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ml(r);
}
var bn = { exports: {} };
bn.exports;
var oo;
function jl() {
  return oo || (oo = 1, (function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", i = 1, o = 2, s = 9007199254740991, a = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", v = "[object Boolean]", f = "[object Date]", u = "[object Error]", p = "[object Function]", h = "[object GeneratorFunction]", g = "[object Map]", E = "[object Number]", S = "[object Null]", y = "[object Object]", b = "[object Promise]", _ = "[object Proxy]", w = "[object RegExp]", A = "[object Set]", O = "[object String]", C = "[object Symbol]", I = "[object Undefined]", D = "[object WeakMap]", $ = "[object ArrayBuffer]", j = "[object DataView]", q = "[object Float32Array]", Z = "[object Float64Array]", K = "[object Int8Array]", rt = "[object Int16Array]", ct = "[object Int32Array]", V = "[object Uint8Array]", ft = "[object Uint8ClampedArray]", tt = "[object Uint16Array]", et = "[object Uint32Array]", Q = /[\\^$.*+?()[\]{}|]/g, gt = /^\[object .+?Constructor\]$/, W = /^(?:0|[1-9]\d*)$/, F = {};
    F[q] = F[Z] = F[K] = F[rt] = F[ct] = F[V] = F[ft] = F[tt] = F[et] = true, F[a] = F[c] = F[$] = F[v] = F[j] = F[f] = F[u] = F[p] = F[g] = F[E] = F[y] = F[w] = F[A] = F[O] = F[D] = false;
    var xt = typeof Ut == "object" && Ut && Ut.Object === Object && Ut, J = typeof self == "object" && self && self.Object === Object && self, dt = xt || J || Function("return this")(), _t = e && !e.nodeType && e, Dt = _t && true && t && !t.nodeType && t, Zt = Dt && Dt.exports === _t, Nt = Zt && xt.process, Lt = (function() {
      try {
        return Nt && Nt.binding && Nt.binding("util");
      } catch {
      }
    })(), Jt = Lt && Lt.isTypedArray;
    function De(m, T) {
      for (var L = -1, B = m == null ? 0 : m.length, pt = 0, X = []; ++L < B; ) {
        var yt = m[L];
        T(yt, L, m) && (X[pt++] = yt);
      }
      return X;
    }
    function ue(m, T) {
      for (var L = -1, B = T.length, pt = m.length; ++L < B; )
        m[pt + L] = T[L];
      return m;
    }
    function on(m, T) {
      for (var L = -1, B = m == null ? 0 : m.length; ++L < B; )
        if (T(m[L], L, m))
          return true;
      return false;
    }
    function sn(m, T) {
      for (var L = -1, B = Array(m); ++L < m; )
        B[L] = T(L);
      return B;
    }
    function an(m) {
      return function(T) {
        return m(T);
      };
    }
    function fe(m, T) {
      return m.has(T);
    }
    function de(m, T) {
      return m?.[T];
    }
    function cn(m) {
      var T = -1, L = Array(m.size);
      return m.forEach(function(B, pt) {
        L[++T] = [pt, B];
      }), L;
    }
    function ln(m, T) {
      return function(L) {
        return m(T(L));
      };
    }
    function un(m) {
      var T = -1, L = Array(m.size);
      return m.forEach(function(B) {
        L[++T] = B;
      }), L;
    }
    var fn = Array.prototype, Le = Function.prototype, pe = Object.prototype, Qt = dt["__core-js_shared__"], we = Le.toString, R = pe.hasOwnProperty, H = (function() {
      var m = /[^.]+$/.exec(Qt && Qt.keys && Qt.keys.IE_PROTO || "");
      return m ? "Symbol(src)_1." + m : "";
    })(), d = pe.toString, x = RegExp(
      "^" + we.call(R).replace(Q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), P = Zt ? dt.Buffer : void 0, N = dt.Symbol, k = dt.Uint8Array, U = pe.propertyIsEnumerable, z = fn.splice, G = N ? N.toStringTag : void 0, Y = Object.getOwnPropertySymbols, ot = P ? P.isBuffer : void 0, ut = ln(Object.keys, Object), St = $e(dt, "DataView"), Tt = $e(dt, "Map"), Gt = $e(dt, "Promise"), dn = $e(dt, "Set"), Ir = $e(dt, "WeakMap"), pn = $e(Object, "create"), ka = Te(St), Ma = Te(Tt), Ha = Te(Gt), ja = Te(dn), Fa = Te(Ir), Hi = N ? N.prototype : void 0, Dr = Hi ? Hi.valueOf : void 0;
    function xe(m) {
      var T = -1, L = m == null ? 0 : m.length;
      for (this.clear(); ++T < L; ) {
        var B = m[T];
        this.set(B[0], B[1]);
      }
    }
    function Ua() {
      this.__data__ = pn ? pn(null) : {}, this.size = 0;
    }
    function Ba(m) {
      var T = this.has(m) && delete this.__data__[m];
      return this.size -= T ? 1 : 0, T;
    }
    function za(m) {
      var T = this.__data__;
      if (pn) {
        var L = T[m];
        return L === r ? void 0 : L;
      }
      return R.call(T, m) ? T[m] : void 0;
    }
    function qa(m) {
      var T = this.__data__;
      return pn ? T[m] !== void 0 : R.call(T, m);
    }
    function Va(m, T) {
      var L = this.__data__;
      return this.size += this.has(m) ? 0 : 1, L[m] = pn && T === void 0 ? r : T, this;
    }
    xe.prototype.clear = Ua, xe.prototype.delete = Ba, xe.prototype.get = za, xe.prototype.has = qa, xe.prototype.set = Va;
    function te(m) {
      var T = -1, L = m == null ? 0 : m.length;
      for (this.clear(); ++T < L; ) {
        var B = m[T];
        this.set(B[0], B[1]);
      }
    }
    function Wa() {
      this.__data__ = [], this.size = 0;
    }
    function Ga(m) {
      var T = this.__data__, L = $n(T, m);
      if (L < 0)
        return false;
      var B = T.length - 1;
      return L == B ? T.pop() : z.call(T, L, 1), --this.size, true;
    }
    function Ka(m) {
      var T = this.__data__, L = $n(T, m);
      return L < 0 ? void 0 : T[L][1];
    }
    function Xa(m) {
      return $n(this.__data__, m) > -1;
    }
    function Ya(m, T) {
      var L = this.__data__, B = $n(L, m);
      return B < 0 ? (++this.size, L.push([m, T])) : L[B][1] = T, this;
    }
    te.prototype.clear = Wa, te.prototype.delete = Ga, te.prototype.get = Ka, te.prototype.has = Xa, te.prototype.set = Ya;
    function _e(m) {
      var T = -1, L = m == null ? 0 : m.length;
      for (this.clear(); ++T < L; ) {
        var B = m[T];
        this.set(B[0], B[1]);
      }
    }
    function Za() {
      this.size = 0, this.__data__ = {
        hash: new xe(),
        map: new (Tt || te)(),
        string: new xe()
      };
    }
    function Ja(m) {
      var T = kn(this, m).delete(m);
      return this.size -= T ? 1 : 0, T;
    }
    function Qa(m) {
      return kn(this, m).get(m);
    }
    function tc(m) {
      return kn(this, m).has(m);
    }
    function ec(m, T) {
      var L = kn(this, m), B = L.size;
      return L.set(m, T), this.size += L.size == B ? 0 : 1, this;
    }
    _e.prototype.clear = Za, _e.prototype.delete = Ja, _e.prototype.get = Qa, _e.prototype.has = tc, _e.prototype.set = ec;
    function Ln(m) {
      var T = -1, L = m == null ? 0 : m.length;
      for (this.__data__ = new _e(); ++T < L; )
        this.add(m[T]);
    }
    function nc(m) {
      return this.__data__.set(m, r), this;
    }
    function rc(m) {
      return this.__data__.has(m);
    }
    Ln.prototype.add = Ln.prototype.push = nc, Ln.prototype.has = rc;
    function he(m) {
      var T = this.__data__ = new te(m);
      this.size = T.size;
    }
    function ic() {
      this.__data__ = new te(), this.size = 0;
    }
    function oc(m) {
      var T = this.__data__, L = T.delete(m);
      return this.size = T.size, L;
    }
    function sc(m) {
      return this.__data__.get(m);
    }
    function ac(m) {
      return this.__data__.has(m);
    }
    function cc(m, T) {
      var L = this.__data__;
      if (L instanceof te) {
        var B = L.__data__;
        if (!Tt || B.length < n - 1)
          return B.push([m, T]), this.size = ++L.size, this;
        L = this.__data__ = new _e(B);
      }
      return L.set(m, T), this.size = L.size, this;
    }
    he.prototype.clear = ic, he.prototype.delete = oc, he.prototype.get = sc, he.prototype.has = ac, he.prototype.set = cc;
    function lc(m, T) {
      var L = Mn(m), B = !L && _c(m), pt = !L && !B && Lr(m), X = !L && !B && !pt && Gi(m), yt = L || B || pt || X, wt = yt ? sn(m.length, String) : [], Rt = wt.length;
      for (var vt in m)
        R.call(m, vt) && !(yt && // Safari 9 has enumerable `arguments.length` in strict mode.
        (vt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        pt && (vt == "offset" || vt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        X && (vt == "buffer" || vt == "byteLength" || vt == "byteOffset") || // Skip index properties.
        Ec(vt, Rt))) && wt.push(vt);
      return wt;
    }
    function $n(m, T) {
      for (var L = m.length; L--; )
        if (zi(m[L][0], T))
          return L;
      return -1;
    }
    function uc(m, T, L) {
      var B = T(m);
      return Mn(m) ? B : ue(B, L(m));
    }
    function hn(m) {
      return m == null ? m === void 0 ? I : S : G && G in Object(m) ? yc(m) : xc(m);
    }
    function ji(m) {
      return vn(m) && hn(m) == a;
    }
    function Fi(m, T, L, B, pt) {
      return m === T ? true : m == null || T == null || !vn(m) && !vn(T) ? m !== m && T !== T : fc(m, T, L, B, Fi, pt);
    }
    function fc(m, T, L, B, pt, X) {
      var yt = Mn(m), wt = Mn(T), Rt = yt ? c : ve(m), vt = wt ? c : ve(T);
      Rt = Rt == a ? y : Rt, vt = vt == a ? y : vt;
      var kt = Rt == y, Bt = vt == y, Ot = Rt == vt;
      if (Ot && Lr(m)) {
        if (!Lr(T))
          return false;
        yt = true, kt = false;
      }
      if (Ot && !kt)
        return X || (X = new he()), yt || Gi(m) ? Ui(m, T, L, B, pt, X) : vc(m, T, Rt, L, B, pt, X);
      if (!(L & i)) {
        var Ht = kt && R.call(m, "__wrapped__"), jt = Bt && R.call(T, "__wrapped__");
        if (Ht || jt) {
          var ge = Ht ? m.value() : m, ee = jt ? T.value() : T;
          return X || (X = new he()), pt(ge, ee, L, B, X);
        }
      }
      return Ot ? (X || (X = new he()), gc(m, T, L, B, pt, X)) : false;
    }
    function dc(m) {
      if (!Wi(m) || bc(m))
        return false;
      var T = qi(m) ? x : gt;
      return T.test(Te(m));
    }
    function pc(m) {
      return vn(m) && Vi(m.length) && !!F[hn(m)];
    }
    function hc(m) {
      if (!wc(m))
        return ut(m);
      var T = [];
      for (var L in Object(m))
        R.call(m, L) && L != "constructor" && T.push(L);
      return T;
    }
    function Ui(m, T, L, B, pt, X) {
      var yt = L & i, wt = m.length, Rt = T.length;
      if (wt != Rt && !(yt && Rt > wt))
        return false;
      var vt = X.get(m);
      if (vt && X.get(T))
        return vt == T;
      var kt = -1, Bt = true, Ot = L & o ? new Ln() : void 0;
      for (X.set(m, T), X.set(T, m); ++kt < wt; ) {
        var Ht = m[kt], jt = T[kt];
        if (B)
          var ge = yt ? B(jt, Ht, kt, T, m, X) : B(Ht, jt, kt, m, T, X);
        if (ge !== void 0) {
          if (ge)
            continue;
          Bt = false;
          break;
        }
        if (Ot) {
          if (!on(T, function(ee, Re) {
            if (!fe(Ot, Re) && (Ht === ee || pt(Ht, ee, L, B, X)))
              return Ot.push(Re);
          })) {
            Bt = false;
            break;
          }
        } else if (!(Ht === jt || pt(Ht, jt, L, B, X))) {
          Bt = false;
          break;
        }
      }
      return X.delete(m), X.delete(T), Bt;
    }
    function vc(m, T, L, B, pt, X, yt) {
      switch (L) {
        case j:
          if (m.byteLength != T.byteLength || m.byteOffset != T.byteOffset)
            return false;
          m = m.buffer, T = T.buffer;
        case $:
          return !(m.byteLength != T.byteLength || !X(new k(m), new k(T)));
        case v:
        case f:
        case E:
          return zi(+m, +T);
        case u:
          return m.name == T.name && m.message == T.message;
        case w:
        case O:
          return m == T + "";
        case g:
          var wt = cn;
        case A:
          var Rt = B & i;
          if (wt || (wt = un), m.size != T.size && !Rt)
            return false;
          var vt = yt.get(m);
          if (vt)
            return vt == T;
          B |= o, yt.set(m, T);
          var kt = Ui(wt(m), wt(T), B, pt, X, yt);
          return yt.delete(m), kt;
        case C:
          if (Dr)
            return Dr.call(m) == Dr.call(T);
      }
      return false;
    }
    function gc(m, T, L, B, pt, X) {
      var yt = L & i, wt = Bi(m), Rt = wt.length, vt = Bi(T), kt = vt.length;
      if (Rt != kt && !yt)
        return false;
      for (var Bt = Rt; Bt--; ) {
        var Ot = wt[Bt];
        if (!(yt ? Ot in T : R.call(T, Ot)))
          return false;
      }
      var Ht = X.get(m);
      if (Ht && X.get(T))
        return Ht == T;
      var jt = true;
      X.set(m, T), X.set(T, m);
      for (var ge = yt; ++Bt < Rt; ) {
        Ot = wt[Bt];
        var ee = m[Ot], Re = T[Ot];
        if (B)
          var Ki = yt ? B(Re, ee, Ot, T, m, X) : B(ee, Re, Ot, m, T, X);
        if (!(Ki === void 0 ? ee === Re || pt(ee, Re, L, B, X) : Ki)) {
          jt = false;
          break;
        }
        ge || (ge = Ot == "constructor");
      }
      if (jt && !ge) {
        var Hn = m.constructor, jn = T.constructor;
        Hn != jn && "constructor" in m && "constructor" in T && !(typeof Hn == "function" && Hn instanceof Hn && typeof jn == "function" && jn instanceof jn) && (jt = false);
      }
      return X.delete(m), X.delete(T), jt;
    }
    function Bi(m) {
      return uc(m, Cc, mc);
    }
    function kn(m, T) {
      var L = m.__data__;
      return Sc(T) ? L[typeof T == "string" ? "string" : "hash"] : L.map;
    }
    function $e(m, T) {
      var L = de(m, T);
      return dc(L) ? L : void 0;
    }
    function yc(m) {
      var T = R.call(m, G), L = m[G];
      try {
        m[G] = void 0;
        var B = true;
      } catch {
      }
      var pt = d.call(m);
      return B && (T ? m[G] = L : delete m[G]), pt;
    }
    var mc = Y ? function(m) {
      return m == null ? [] : (m = Object(m), De(Y(m), function(T) {
        return U.call(m, T);
      }));
    } : Oc, ve = hn;
    (St && ve(new St(new ArrayBuffer(1))) != j || Tt && ve(new Tt()) != g || Gt && ve(Gt.resolve()) != b || dn && ve(new dn()) != A || Ir && ve(new Ir()) != D) && (ve = function(m) {
      var T = hn(m), L = T == y ? m.constructor : void 0, B = L ? Te(L) : "";
      if (B)
        switch (B) {
          case ka:
            return j;
          case Ma:
            return g;
          case Ha:
            return b;
          case ja:
            return A;
          case Fa:
            return D;
        }
      return T;
    });
    function Ec(m, T) {
      return T = T ?? s, !!T && (typeof m == "number" || W.test(m)) && m > -1 && m % 1 == 0 && m < T;
    }
    function Sc(m) {
      var T = typeof m;
      return T == "string" || T == "number" || T == "symbol" || T == "boolean" ? m !== "__proto__" : m === null;
    }
    function bc(m) {
      return !!H && H in m;
    }
    function wc(m) {
      var T = m && m.constructor, L = typeof T == "function" && T.prototype || pe;
      return m === L;
    }
    function xc(m) {
      return d.call(m);
    }
    function Te(m) {
      if (m != null) {
        try {
          return we.call(m);
        } catch {
        }
        try {
          return m + "";
        } catch {
        }
      }
      return "";
    }
    function zi(m, T) {
      return m === T || m !== m && T !== T;
    }
    var _c = ji(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? ji : function(m) {
      return vn(m) && R.call(m, "callee") && !U.call(m, "callee");
    }, Mn = Array.isArray;
    function Tc(m) {
      return m != null && Vi(m.length) && !qi(m);
    }
    var Lr = ot || Ac;
    function Rc(m, T) {
      return Fi(m, T);
    }
    function qi(m) {
      if (!Wi(m))
        return false;
      var T = hn(m);
      return T == p || T == h || T == l || T == _;
    }
    function Vi(m) {
      return typeof m == "number" && m > -1 && m % 1 == 0 && m <= s;
    }
    function Wi(m) {
      var T = typeof m;
      return m != null && (T == "object" || T == "function");
    }
    function vn(m) {
      return m != null && typeof m == "object";
    }
    var Gi = Jt ? an(Jt) : pc;
    function Cc(m) {
      return Tc(m) ? lc(m) : hc(m);
    }
    function Oc() {
      return [];
    }
    function Ac() {
      return false;
    }
    t.exports = Rc;
  })(bn, bn.exports)), bn.exports;
}
var Fl = jl();
var wn = /* @__PURE__ */ Pe(Fl);
var Ul = "EXPERIENCE_STARTED";
var so = "SHOW";
var Ce = "STOP_EXPERIENCE";
var Ee = {
  NAVIGATION: "navigation",
  DISMISSED: "dismissed"
};
var Bl = "EXTENDED_EVENT";
var _s = "START_STEP";
var bi = "STOP_STEP";
var Ts = "UPDATE_STEP";
var Rs = "SET_STEP_CONTAINER_TARGET";
var Cs = "UPDATE_STEP_CONTENT";
var zl = "RECOVER_STEP";
var ql = "AUTO_RECOVER_STEP";
var Vl = "PARENT_RECOVER_STEP";
var Wl = "ERROR";
var Gl = "STEP_INTERACTION";
var Kl = "STEP_SEEN";
var Os = "UPDATE_ROOT_STYLE";
var Xl = "RELOAD";
var As = "STEP_STOPPED";
var Yl = "EXPERIENCE_DISMISSED";
var Zl = "EXPERIENCE_SNOOZED";
var Jl = "FORWARD_TO_PARENT";
var Ns = "TRANSITION_TO_END";
var Ps = "ACTIONS_STARTED";
var Is = "ACTIONS_FINISHED";
var Ql = "experience.begin";
var tu = "experience.end";
var wi = "step.begin";
var Ds = "step.prerender";
var Ls = "step.postrender";
var pr = "step.end";
var $s = "step.error";
var ks = "step.container_change";
var Ms = "RUN_HOOKS";
var eu = "RUN_HOOKS_DONE";
var xi = "START_THEME_REMOVAL_LISTENER";
var Hs = "STOP_THEME_REMOVAL_LISTENER";
var nu = "GLOBAL_CONTAINER_REMOVED";
var _i = "STEP_CONTAINER_REMOVED";
var Tn = "appcues-experience-container";
var Nn = "APPCUES-EXPERIENCE-CONTAINER";
var Pn = "APPCUES-EXPERIENCE-CONTAINER-BUILDER";
var js = "data-appcues-container-id";
var Ti = "RUN_TRAITS_DONE";
var Fs = "RUN_TRAITS_ERROR";
var ru = "BIND_ACTIONS_ERROR";
var iu = () => {
  const t = /* @__PURE__ */ new Map(), e = (i) => {
    const { observerInstance: o } = t.get(i);
    if (o) return;
    const s = { childList: true, subtree: true }, a = (...v) => {
      const { callbacks: f } = t.get(i);
      f.forEach((u) => u(...v));
    }, c = new MutationObserver(a);
    c.observe(i, s);
    const { callbacks: l } = t.get(i);
    t.set(i, {
      callbacks: l,
      observerInstance: c
    });
  }, n = (i, o) => {
    const s = t.get(i);
    if (s) {
      const { callbacks: a, observerInstance: c } = s, l = a.filter((v) => v !== o);
      if (l.length > 0) {
        t.set(i, {
          callbacks: l,
          observerInstance: c
        });
        return;
      }
      c.disconnect(), t.delete(i);
    }
  };
  return (i, o) => {
    const { callbacks: s = [], observerInstance: a = null } = t.get(i) ?? {};
    return t.set(i, {
      observerInstance: a,
      callbacks: [...s, o]
    }), e(i), () => n(i, o);
  };
};
var Be = iu();
var ou = (t, ...e) => {
  e.forEach(
    (n) => t.addEventListener(n, (r) => {
      r.stopPropagation();
    })
  );
};
var ao = "|shadow-root|";
var co = "|iframe|";
var Ze = (t, e) => {
  try {
    return t.includes(ao) || t.includes(co) ? t.split(ao).flatMap((n) => n.split(co)).reduce((n, r) => n === null ? [...e.querySelectorAll(r)] : n.flatMap((i) => i.shadowRoot ? [...i.shadowRoot.querySelectorAll(r)] : i.tagName === "IFRAME" ? [
      ...i.contentDocument.querySelectorAll(r)
    ] : []), null) ?? [] : e.querySelectorAll(t);
  } catch {
    return [];
  }
};
var su = (t, e) => {
  const n = Ze(t, e);
  return n.length > 0 ? n[0] : null;
};
var Ie = (t) => `appcues-container-${t}`;
var lo = (t, e, n) => {
  try {
    if (t.contentDocument && t.contentDocument.body && t.contentDocument.body.children.length > 0) {
      if (n()) return;
      e(t.contentDocument.body);
    } else {
      const r = () => {
        try {
          const i = t.contentDocument;
          if (!i || !i.body || n()) return;
          e(i.body);
        } catch {
        }
      };
      t.addEventListener("load", r, { once: true });
    }
  } catch {
  }
};
var au = (t, e) => {
  t.forEach((n) => {
    n.type === "childList" && n.addedNodes.forEach((r) => {
      r.nodeType === 1 && r.tagName === "IFRAME" && e(r);
    });
  });
};
var cu = ({
  getTarget: t,
  onInserted: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let i = [];
  const o = () => {
    i.forEach((p) => p()), i = [];
  }, s = () => {
    const p = t();
    return p.length === 1 ? (e(p[0]), o(), true) : false;
  };
  if (s())
    return () => {
    };
  const c = (p) => {
    p.some((h) => h.addedNodes.length > 0) && (au(p, (h) => {
      lo(
        h,
        (g) => i.push(Be(g, c)),
        s
      );
    }), s());
  };
  i.push(Be(r.body, c));
  let l;
  const v = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (p) => p.shadowRoot && p.nodeName !== Nn && p.nodeName !== Pn ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (l = v.nextNode()) !== null; )
    i.push(Be(l.shadowRoot, c));
  let f;
  const u = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (p) => p.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (f = u.nextNode()) !== null; )
    lo(
      f,
      // eslint-disable-next-line no-loop-func
      (p) => i.push(Be(p, c)),
      s
    );
  return () => o();
};
var Ri = ({
  getTarget: t,
  onRemoved: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let [i] = t(), o;
  const s = (a) => {
    if (!a.some((v) => v.removedNodes.length > 0))
      return;
    const c = t(), l = i ? c[0] !== i : false;
    [i] = c, (c.length === 0 || l || !i.isConnected) && (e(), o());
  };
  return o = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Be(i.getRootNode(), s) : Be(r.body, s), () => o();
};
var lu = (t) => {
  let e = 0;
  for (let n = 0; n < t.length && !(t[n].nodeName !== Nn || t[n].nodeName !== Pn); n++)
    e = n;
  return t.slice(e + 1);
};
var uu = (t, e = document) => {
  try {
    const n = /^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i, r = t.match(n), i = e.body.firstChild?.nodeName === Nn || e.body.firstChild?.nodeName === Pn;
    if (!r || !i) return [];
    const { tagName: o, index: s, remainingSelector: a } = r.groups, c = Number.parseInt(s, 10) - 1, l = lu([
      ...e.body.children
    ]), v = l[c]?.nodeName === o.toUpperCase() ? l[c] : null;
    return a ? (
      // adding * here to the string because
      // the remaining selector can be something like
      // > p:nth-of-type(1).
      // But selectors starting with > without a parent sentence first or *
      // would fail, because it is not a valid css selector.
      // * means the parentElement, which is the element
      // we are applying the querySelectorAll.
      v ? Ze(`* ${a}`, v) : []
    ) : [v];
  } catch {
    return [];
  }
};
var Us = (t, { step: e, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
  const o = Ie(e.id);
  let s = [];
  if (r) {
    const c = i().document, l = uu(t, c), v = l.length > 0 ? l : Ze(t, c.documentElement);
    v.length > 0 && (s = [...s, ...v]);
  }
  if (!n)
    return s;
  let a = su(
    `[${js}=${o}]`,
    n
  );
  return a && (a = Ze(t, a)), a = a ?? [], a.length > 0 && (s = [...s, ...a]), s;
};
var fu = [
  "keypress",
  "keydown",
  "keyup",
  "click",
  "dblclick",
  "input",
  "change",
  "submit"
];
var Bs = ({
  accountId: t,
  id: e,
  theme: n,
  getWindowReference: r
}) => {
  const o = r().document.createElement(Tn);
  return n && o.setAttribute("themeId", n), o.setAttribute("accountId", t), o.setAttribute("id", Ie(e)), ou(o, ...fu), o;
};
var du = (t) => ({ experience: e }) => {
  const { theme: n, themeSystem: r, accountId: i, id: o } = e;
  if (!i) return;
  const s = t("getWindowReference"), a = s().document, c = Bs({
    accountId: i,
    id: o,
    // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
    ...!r && { theme: n },
    getWindowReference: s
  });
  a.body.append(c);
};
var pu = (t) => ({ experience: e }) => {
  const r = t("getWindowReference")().document, i = Ie(e.id);
  Ze(
    `#${i}`,
    r.documentElement
  ).forEach((s) => r.body.removeChild(s));
};
var hu = ({ getRoot: t }) => {
  const e = t();
  e.parentElement && e.remove();
};
var vu = ({ getRoot: t }) => vs([
  {
    cond: "hasCustomContainer",
    actions: [
      () => {
        hu({ getRoot: t });
      }
    ]
  }
]);
var gu = (t) => ({ experience: e }) => (n, r) => {
  r(({ type: i }) => {
    if (i !== xi) return;
    const o = t("getWindowReference"), s = o().document, a = Ie(e.id);
    Ri({
      getTarget: () => Ze(
        `#${a}`,
        s.documentElement
      ),
      onRemoved: () => {
        n(nu);
      },
      getWindowReference: o
    });
  });
};
var yu = ({ getRoot: t, getWindowReference: e }) => () => (
  // eslint-disable-next-line unicorn/consistent-function-scoping
  ((n, r) => {
    let i;
    r(({ type: o }) => {
      if (o === Hs && i) {
        i();
        return;
      }
      o === xi && (i && i(), i = Ri({
        getTarget: () => [t()],
        onRemoved: () => {
          n(_i);
        },
        getWindowReference: e
      }));
    });
  })
);
var zs = Tr(xi, {
  to: "themeRemovalService"
});
var mu = Tr(Hs, {
  to: "themeRemovalService"
});
var Hr = { exports: {} };
var uo;
function Eu() {
  return uo || (uo = 1, (function(t) {
    (function() {
      function e(d, x, P) {
        return d.call.apply(d.bind, arguments);
      }
      function n(d, x, P) {
        if (!d) throw Error();
        if (2 < arguments.length) {
          var N = Array.prototype.slice.call(arguments, 2);
          return function() {
            var k = Array.prototype.slice.call(arguments);
            return Array.prototype.unshift.apply(k, N), d.apply(x, k);
          };
        }
        return function() {
          return d.apply(x, arguments);
        };
      }
      function r(d, x, P) {
        return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
      }
      var i = Date.now || function() {
        return +/* @__PURE__ */ new Date();
      };
      function o(d, x) {
        this.a = d, this.o = x || d, this.c = this.o.document;
      }
      var s = !!window.FontFace;
      function a(d, x, P, N) {
        if (x = d.c.createElement(x), P) for (var k in P) P.hasOwnProperty(k) && (k == "style" ? x.style.cssText = P[k] : x.setAttribute(k, P[k]));
        return N && x.appendChild(d.c.createTextNode(N)), x;
      }
      function c(d, x, P) {
        d = d.c.getElementsByTagName(x)[0], d || (d = document.documentElement), d.insertBefore(P, d.lastChild);
      }
      function l(d) {
        d.parentNode && d.parentNode.removeChild(d);
      }
      function v(d, x, P) {
        x = x || [], P = P || [];
        for (var N = d.className.split(/\s+/), k = 0; k < x.length; k += 1) {
          for (var U = false, z = 0; z < N.length; z += 1) if (x[k] === N[z]) {
            U = true;
            break;
          }
          U || N.push(x[k]);
        }
        for (x = [], k = 0; k < N.length; k += 1) {
          for (U = false, z = 0; z < P.length; z += 1) if (N[k] === P[z]) {
            U = true;
            break;
          }
          U || x.push(N[k]);
        }
        d.className = x.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
      }
      function f(d, x) {
        for (var P = d.className.split(/\s+/), N = 0, k = P.length; N < k; N++) if (P[N] == x) return true;
        return false;
      }
      function u(d) {
        return d.o.location.hostname || d.a.location.hostname;
      }
      function p(d, x, P) {
        function N() {
          G && k && U && (G(z), G = null);
        }
        x = a(d, "link", { rel: "stylesheet", href: x, media: "all" });
        var k = false, U = true, z = null, G = P || null;
        s ? (x.onload = function() {
          k = true, N();
        }, x.onerror = function() {
          k = true, z = Error("Stylesheet failed to load"), N();
        }) : setTimeout(function() {
          k = true, N();
        }, 0), c(d, "head", x);
      }
      function h(d, x, P, N) {
        var k = d.c.getElementsByTagName("head")[0];
        if (k) {
          var U = a(d, "script", { src: x }), z = false;
          return U.onload = U.onreadystatechange = function() {
            z || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (z = true, P && P(null), U.onload = U.onreadystatechange = null, U.parentNode.tagName == "HEAD" && k.removeChild(U));
          }, k.appendChild(U), setTimeout(function() {
            z || (z = true, P && P(Error("Script load timeout")));
          }, N || 5e3), U;
        }
        return null;
      }
      function g() {
        this.a = 0, this.c = null;
      }
      function E(d) {
        return d.a++, function() {
          d.a--, y(d);
        };
      }
      function S(d, x) {
        d.c = x, y(d);
      }
      function y(d) {
        d.a == 0 && d.c && (d.c(), d.c = null);
      }
      function b(d) {
        this.a = d || "-";
      }
      b.prototype.c = function(d) {
        for (var x = [], P = 0; P < arguments.length; P++) x.push(arguments[P].replace(/[\W_]+/g, "").toLowerCase());
        return x.join(this.a);
      };
      function _(d, x) {
        this.c = d, this.f = 4, this.a = "n";
        var P = (x || "n4").match(/^([nio])([1-9])$/i);
        P && (this.a = P[1], this.f = parseInt(P[2], 10));
      }
      function w(d) {
        return C(d) + " " + (d.f + "00") + " 300px " + A(d.c);
      }
      function A(d) {
        var x = [];
        d = d.split(/,\s*/);
        for (var P = 0; P < d.length; P++) {
          var N = d[P].replace(/['"]/g, "");
          N.indexOf(" ") != -1 || /^\d/.test(N) ? x.push("'" + N + "'") : x.push(N);
        }
        return x.join(",");
      }
      function O(d) {
        return d.a + d.f;
      }
      function C(d) {
        var x = "normal";
        return d.a === "o" ? x = "oblique" : d.a === "i" && (x = "italic"), x;
      }
      function I(d) {
        var x = 4, P = "n", N = null;
        return d && ((N = d.match(/(normal|oblique|italic)/i)) && N[1] && (P = N[1].substr(0, 1).toLowerCase()), (N = d.match(/([1-9]00|normal|bold)/i)) && N[1] && (/bold/i.test(N[1]) ? x = 7 : /[1-9]00/.test(N[1]) && (x = parseInt(N[1].substr(0, 1), 10)))), P + x;
      }
      function D(d, x) {
        this.c = d, this.f = d.o.document.documentElement, this.h = x, this.a = new b("-"), this.j = x.events !== false, this.g = x.classes !== false;
      }
      function $(d) {
        d.g && v(d.f, [d.a.c("wf", "loading")]), q(d, "loading");
      }
      function j(d) {
        if (d.g) {
          var x = f(d.f, d.a.c("wf", "active")), P = [], N = [d.a.c("wf", "loading")];
          x || P.push(d.a.c("wf", "inactive")), v(d.f, P, N);
        }
        q(d, "inactive");
      }
      function q(d, x, P) {
        d.j && d.h[x] && (P ? d.h[x](P.c, O(P)) : d.h[x]());
      }
      function Z() {
        this.c = {};
      }
      function K(d, x, P) {
        var N = [], k;
        for (k in x) if (x.hasOwnProperty(k)) {
          var U = d.c[k];
          U && N.push(U(x[k], P));
        }
        return N;
      }
      function rt(d, x) {
        this.c = d, this.f = x, this.a = a(this.c, "span", { "aria-hidden": "true" }, this.f);
      }
      function ct(d) {
        c(d.c, "body", d.a);
      }
      function V(d) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + A(d.c) + ";" + ("font-style:" + C(d) + ";font-weight:" + (d.f + "00") + ";");
      }
      function ft(d, x, P, N, k, U) {
        this.g = d, this.j = x, this.a = N, this.c = P, this.f = k || 3e3, this.h = U || void 0;
      }
      ft.prototype.start = function() {
        var d = this.c.o.document, x = this, P = i(), N = new Promise(function(z, G) {
          function Y() {
            i() - P >= x.f ? G() : d.fonts.load(w(x.a), x.h).then(function(ot) {
              1 <= ot.length ? z() : setTimeout(Y, 25);
            }, function() {
              G();
            });
          }
          Y();
        }), k = null, U = new Promise(function(z, G) {
          k = setTimeout(G, x.f);
        });
        Promise.race([U, N]).then(function() {
          k && (clearTimeout(k), k = null), x.g(x.a);
        }, function() {
          x.j(x.a);
        });
      };
      function tt(d, x, P, N, k, U, z) {
        this.v = d, this.B = x, this.c = P, this.a = N, this.s = z || "BESbswy", this.f = {}, this.w = k || 3e3, this.u = U || null, this.m = this.j = this.h = this.g = null, this.g = new rt(this.c, this.s), this.h = new rt(this.c, this.s), this.j = new rt(this.c, this.s), this.m = new rt(this.c, this.s), d = new _(this.a.c + ",serif", O(this.a)), d = V(d), this.g.a.style.cssText = d, d = new _(this.a.c + ",sans-serif", O(this.a)), d = V(d), this.h.a.style.cssText = d, d = new _("serif", O(this.a)), d = V(d), this.j.a.style.cssText = d, d = new _("sans-serif", O(this.a)), d = V(d), this.m.a.style.cssText = d, ct(this.g), ct(this.h), ct(this.j), ct(this.m);
      }
      var et = { D: "serif", C: "sans-serif" }, Q = null;
      function gt() {
        if (Q === null) {
          var d = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
          Q = !!d && (536 > parseInt(d[1], 10) || parseInt(d[1], 10) === 536 && 11 >= parseInt(d[2], 10));
        }
        return Q;
      }
      tt.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), F(this);
      };
      function W(d, x, P) {
        for (var N in et) if (et.hasOwnProperty(N) && x === d.f[et[N]] && P === d.f[et[N]]) return true;
        return false;
      }
      function F(d) {
        var x = d.g.a.offsetWidth, P = d.h.a.offsetWidth, N;
        (N = x === d.f.serif && P === d.f["sans-serif"]) || (N = gt() && W(d, x, P)), N ? i() - d.A >= d.w ? gt() && W(d, x, P) && (d.u === null || d.u.hasOwnProperty(d.a.c)) ? J(d, d.v) : J(d, d.B) : xt(d) : J(d, d.v);
      }
      function xt(d) {
        setTimeout(r(function() {
          F(this);
        }, d), 50);
      }
      function J(d, x) {
        setTimeout(r(function() {
          l(this.g.a), l(this.h.a), l(this.j.a), l(this.m.a), x(this.a);
        }, d), 0);
      }
      function dt(d, x, P) {
        this.c = d, this.a = x, this.f = 0, this.m = this.j = false, this.s = P;
      }
      var _t = null;
      dt.prototype.g = function(d) {
        var x = this.a;
        x.g && v(x.f, [x.a.c("wf", d.c, O(d).toString(), "active")], [x.a.c("wf", d.c, O(d).toString(), "loading"), x.a.c("wf", d.c, O(d).toString(), "inactive")]), q(x, "fontactive", d), this.m = true, Dt(this);
      }, dt.prototype.h = function(d) {
        var x = this.a;
        if (x.g) {
          var P = f(x.f, x.a.c("wf", d.c, O(d).toString(), "active")), N = [], k = [x.a.c("wf", d.c, O(d).toString(), "loading")];
          P || N.push(x.a.c("wf", d.c, O(d).toString(), "inactive")), v(x.f, N, k);
        }
        q(x, "fontinactive", d), Dt(this);
      };
      function Dt(d) {
        --d.f == 0 && d.j && (d.m ? (d = d.a, d.g && v(d.f, [d.a.c("wf", "active")], [d.a.c("wf", "loading"), d.a.c("wf", "inactive")]), q(d, "active")) : j(d.a));
      }
      function Zt(d) {
        this.j = d, this.a = new Z(), this.h = 0, this.f = this.g = true;
      }
      Zt.prototype.load = function(d) {
        this.c = new o(this.j, d.context || this.j), this.g = d.events !== false, this.f = d.classes !== false, Lt(this, new D(this.c, d), d);
      };
      function Nt(d, x, P, N, k) {
        var U = --d.h == 0;
        (d.f || d.g) && setTimeout(function() {
          var z = k || null, G = N || null || {};
          if (P.length === 0 && U) j(x.a);
          else {
            x.f += P.length, U && (x.j = U);
            var Y, ot = [];
            for (Y = 0; Y < P.length; Y++) {
              var ut = P[Y], St = G[ut.c], Tt = x.a, Gt = ut;
              if (Tt.g && v(Tt.f, [Tt.a.c("wf", Gt.c, O(Gt).toString(), "loading")]), q(Tt, "fontloading", Gt), Tt = null, _t === null) if (window.FontFace) {
                var Gt = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), dn = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                _t = Gt ? 42 < parseInt(Gt[1], 10) : !dn;
              } else _t = false;
              _t ? Tt = new ft(r(x.g, x), r(x.h, x), x.c, ut, x.s, St) : Tt = new tt(r(x.g, x), r(x.h, x), x.c, ut, x.s, z, St), ot.push(Tt);
            }
            for (Y = 0; Y < ot.length; Y++) ot[Y].start();
          }
        }, 0);
      }
      function Lt(d, x, P) {
        var k = [], N = P.timeout;
        $(x);
        var k = K(d.a, P, d.c), U = new dt(d.c, x, N);
        for (d.h = k.length, x = 0, P = k.length; x < P; x++) k[x].load(function(z, G, Y) {
          Nt(d, U, z, G, Y);
        });
      }
      function Jt(d, x) {
        this.c = d, this.a = x;
      }
      Jt.prototype.load = function(d) {
        function x() {
          if (U["__mti_fntLst" + N]) {
            var z = U["__mti_fntLst" + N](), G = [], Y;
            if (z) for (var ot = 0; ot < z.length; ot++) {
              var ut = z[ot].fontfamily;
              z[ot].fontStyle != null && z[ot].fontWeight != null ? (Y = z[ot].fontStyle + z[ot].fontWeight, G.push(new _(ut, Y))) : G.push(new _(ut));
            }
            d(G);
          } else setTimeout(function() {
            x();
          }, 50);
        }
        var P = this, N = P.a.projectId, k = P.a.version;
        if (N) {
          var U = P.c.o;
          h(this.c, (P.a.api || "https://fast.fonts.net/jsapi") + "/" + N + ".js" + (k ? "?v=" + k : ""), function(z) {
            z ? d([]) : (U["__MonotypeConfiguration__" + N] = function() {
              return P.a;
            }, x());
          }).id = "__MonotypeAPIScript__" + N;
        } else d([]);
      };
      function De(d, x) {
        this.c = d, this.a = x;
      }
      De.prototype.load = function(d) {
        var x, P, N = this.a.urls || [], k = this.a.families || [], U = this.a.testStrings || {}, z = new g();
        for (x = 0, P = N.length; x < P; x++) p(this.c, N[x], E(z));
        var G = [];
        for (x = 0, P = k.length; x < P; x++) if (N = k[x].split(":"), N[1]) for (var Y = N[1].split(","), ot = 0; ot < Y.length; ot += 1) G.push(new _(N[0], Y[ot]));
        else G.push(new _(N[0]));
        S(z, function() {
          d(G, U);
        });
      };
      function ue(d, x) {
        d ? this.c = d : this.c = on, this.a = [], this.f = [], this.g = x || "";
      }
      var on = "https://fonts.googleapis.com/css";
      function sn(d, x) {
        for (var P = x.length, N = 0; N < P; N++) {
          var k = x[N].split(":");
          k.length == 3 && d.f.push(k.pop());
          var U = "";
          k.length == 2 && k[1] != "" && (U = ":"), d.a.push(k.join(U));
        }
      }
      function an(d) {
        if (d.a.length == 0) throw Error("No fonts to load!");
        if (d.c.indexOf("kit=") != -1) return d.c;
        for (var x = d.a.length, P = [], N = 0; N < x; N++) P.push(d.a[N].replace(/ /g, "+"));
        return x = d.c + "?family=" + P.join("%7C"), 0 < d.f.length && (x += "&subset=" + d.f.join(",")), 0 < d.g.length && (x += "&text=" + encodeURIComponent(d.g)), x;
      }
      function fe(d) {
        this.f = d, this.a = [], this.c = {};
      }
      var de = { latin: "BESbswy", "latin-ext": "\xE7\xF6\xFC\u011F\u015F", cyrillic: "\u0439\u044F\u0416", greek: "\u03B1\u03B2\u03A3", khmer: "\u1780\u1781\u1782", Hanuman: "\u1780\u1781\u1782" }, cn = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, ln = { i: "i", italic: "i", n: "n", normal: "n" }, un = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
      function fn(d) {
        for (var x = d.f.length, P = 0; P < x; P++) {
          var N = d.f[P].split(":"), k = N[0].replace(/\+/g, " "), U = ["n4"];
          if (2 <= N.length) {
            var z, G = N[1];
            if (z = [], G) for (var G = G.split(","), Y = G.length, ot = 0; ot < Y; ot++) {
              var ut;
              if (ut = G[ot], ut.match(/^[\w-]+$/)) {
                var St = un.exec(ut.toLowerCase());
                if (St == null) ut = "";
                else {
                  if (ut = St[2], ut = ut == null || ut == "" ? "n" : ln[ut], St = St[1], St == null || St == "") St = "4";
                  else var Tt = cn[St], St = Tt || (isNaN(St) ? "4" : St.substr(0, 1));
                  ut = [ut, St].join("");
                }
              } else ut = "";
              ut && z.push(ut);
            }
            0 < z.length && (U = z), N.length == 3 && (N = N[2], z = [], N = N ? N.split(",") : z, 0 < N.length && (N = de[N[0]]) && (d.c[k] = N));
          }
          for (d.c[k] || (N = de[k]) && (d.c[k] = N), N = 0; N < U.length; N += 1) d.a.push(new _(k, U[N]));
        }
      }
      function Le(d, x) {
        this.c = d, this.a = x;
      }
      var pe = { Arimo: true, Cousine: true, Tinos: true };
      Le.prototype.load = function(d) {
        var x = new g(), P = this.c, N = new ue(this.a.api, this.a.text), k = this.a.families;
        sn(N, k);
        var U = new fe(k);
        fn(U), p(P, an(N), E(x)), S(x, function() {
          d(U.a, U.c, pe);
        });
      };
      function Qt(d, x) {
        this.c = d, this.a = x;
      }
      Qt.prototype.load = function(d) {
        var x = this.a.id, P = this.c.o;
        x ? h(this.c, (this.a.api || "https://use.typekit.net") + "/" + x + ".js", function(N) {
          if (N) d([]);
          else if (P.Typekit && P.Typekit.config && P.Typekit.config.fn) {
            N = P.Typekit.config.fn;
            for (var k = [], U = 0; U < N.length; U += 2) for (var z = N[U], G = N[U + 1], Y = 0; Y < G.length; Y++) k.push(new _(z, G[Y]));
            try {
              P.Typekit.load({ events: false, classes: false, async: true });
            } catch {
            }
            d(k);
          }
        }, 2e3) : d([]);
      };
      function we(d, x) {
        this.c = d, this.f = x, this.a = [];
      }
      we.prototype.load = function(d) {
        var x = this.f.id, P = this.c.o, N = this;
        x ? (P.__webfontfontdeckmodule__ || (P.__webfontfontdeckmodule__ = {}), P.__webfontfontdeckmodule__[x] = function(k, U) {
          for (var z = 0, G = U.fonts.length; z < G; ++z) {
            var Y = U.fonts[z];
            N.a.push(new _(Y.name, I("font-weight:" + Y.weight + ";font-style:" + Y.style)));
          }
          d(N.a);
        }, h(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + u(this.c) + "/" + x + ".js", function(k) {
          k && d([]);
        })) : d([]);
      };
      var R = new Zt(window);
      R.a.c.custom = function(d, x) {
        return new De(x, d);
      }, R.a.c.fontdeck = function(d, x) {
        return new we(x, d);
      }, R.a.c.monotype = function(d, x) {
        return new Jt(x, d);
      }, R.a.c.typekit = function(d, x) {
        return new Qt(x, d);
      }, R.a.c.google = function(d, x) {
        return new Le(x, d);
      };
      var H = { load: r(R.load, R) };
      t.exports ? t.exports = H : (window.WebFont = H, window.WebFontConfig && R.load(window.WebFontConfig));
    })();
  })(Hr)), Hr.exports;
}
var Su = Eu();
var bu = /* @__PURE__ */ Pe(Su);
var Gn = { exports: {} };
var fo;
function wu() {
  if (fo) return Gn.exports;
  fo = 1;
  function t(f, u) {
    var p = u && u.cache ? u.cache : v, h = u && u.serializer ? u.serializer : c, g = u && u.strategy ? u.strategy : o;
    return g(f, {
      cache: p,
      serializer: h
    });
  }
  function e(f) {
    return f == null || typeof f == "number" || typeof f == "boolean";
  }
  function n(f, u, p, h) {
    var g = e(h) ? h : p(h), E = u.get(g);
    return typeof E > "u" && (E = f.call(this, h), u.set(g, E)), E;
  }
  function r(f, u, p) {
    var h = Array.prototype.slice.call(arguments, 3), g = p(h), E = u.get(g);
    return typeof E > "u" && (E = f.apply(this, h), u.set(g, E)), E;
  }
  function i(f, u, p, h, g) {
    return p.bind(
      u,
      f,
      h,
      g
    );
  }
  function o(f, u) {
    var p = f.length === 1 ? n : r;
    return i(
      f,
      this,
      p,
      u.cache.create(),
      u.serializer
    );
  }
  function s(f, u) {
    var p = r;
    return i(
      f,
      this,
      p,
      u.cache.create(),
      u.serializer
    );
  }
  function a(f, u) {
    var p = n;
    return i(
      f,
      this,
      p,
      u.cache.create(),
      u.serializer
    );
  }
  function c() {
    return JSON.stringify(arguments);
  }
  function l() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  l.prototype.has = function(f) {
    return f in this.cache;
  }, l.prototype.get = function(f) {
    return this.cache[f];
  }, l.prototype.set = function(f, u) {
    this.cache[f] = u;
  };
  var v = {
    create: function() {
      return new l();
    }
  };
  return Gn.exports = t, Gn.exports.strategies = {
    variadic: s,
    monadic: a
  }, Gn.exports;
}
var xu = wu();
var _u = /* @__PURE__ */ Pe(xu);
var Tu = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1";
var Ru = 9999;
var hr = {
  fastBaseUrl: null,
  // null means use default
  useAssetsPath: false
  // when true, use simplified theme path format
};
var Cu = (t = {}) => {
  hr = { ...hr, ...t };
};
var Ou = () => hr.fastBaseUrl ?? Tu;
var po = () => hr.useAssetsPath;
function Au(t) {
  return t.replace(/\/+$/, "");
}
var Nu = _u(
  (t, e) => {
    const n = Ou();
    if (po()) {
      const r = Au(n);
      return fetch(
        `${r}/themes/${encodeURIComponent(t)}.json`
      ).then((i) => i.json());
    }
    return fetch(`${n}/accounts/${e}/styles/${t}`).then(
      (r) => r.json()
    );
  },
  {
    serializer: ([t, e]) => `${t}:${e}:${po()}`
  }
);
var Pu = (t, e) => {
  const n = {
    classes: false
  };
  e != null && (n.custom = {
    urls: [e.general.headerFontUrl, e.general.bodyFontUrl]
  }), t && (n.typekit = {
    id: t
  }), Object.keys(n).length > 1 && bu.load(n);
};
var ho = (t, e, n) => {
  if (!t) return;
  const i = (n.ownerDocument || document).createElement("style");
  i.innerHTML = `${t}`, e && i.classList.add(`theme-${e}`), n.shadowRoot.prepend(i);
};
var qs = async (t) => {
  const e = t.getAttribute("themeId"), n = t.getAttribute("accountId"), r = await Nu(e, n).catch(() => {
  }), { globalStyling: i, theme: o, typekitId: s } = r ?? {
    globalStyling: "",
    theme: {},
    typekitId: ""
  }, a = o?.json?.typekitId ?? s;
  Pu(a, o?.json), ho(o?.css, e, t), ho(i, e, t);
};
var Iu = async (t, e) => {
  await qs(t), e && t.shadowRoot.querySelectorAll(
    `.theme-${e}`
  ).forEach((r) => r.remove());
};
var Du = Et({
  step: ({ step: t }, e) => ({
    ...t,
    virtualizedContent: e.virtualizedContent
  })
});
var Lu = (t) => Et({
  step: (e, n) => ({
    stepConfig: n.stepConfig,
    virtualizedContent: t(n.stepConfig)
  })
});
var $u = Et({
  experience: (t, e) => e.experience,
  step: ({ step: t }, e) => ({
    ...t,
    ...e.stepConfig
  })
});
var ku = Ft(Ul);
var Mu = Ft(({ step: t }) => ({
  type: As,
  id: t.id
}));
var Hu = (t, { styles: e, getRoot: n }) => {
  const r = n();
  r && Object.entries(e).forEach(([i, o]) => {
    i.startsWith("--") ? r.style.setProperty(i, o) : r.style[i] = o;
  });
};
var ju = (t) => (e) => {
  const { theme: n, themeSystem: r, id: i } = e.experience;
  if (r || !n) return;
  const a = t("getWindowReference")().document.documentElement.querySelector(
    `#${Ie(i)}`
  ), c = a.getAttribute("themeId");
  a?.setAttribute("themeId", n), Iu(a, c);
};
var Fu = (t) => Et({
  step: ({ step: e }) => {
    if (e.type !== "tooltip" || e.contentType === "application/json")
      return e;
    const n = Object.entries(e.actions).filter(
      ([, i]) => i.find((o) => o.on === "click")
    ).map(([i]) => i), r = e.traits.filter(({ config: i }) => i.targetId).map(({ config: i }) => i.targetId);
    return {
      ...e,
      virtualizedContent: t(e, {
        interactiveEls: n,
        focusableEls: r
      })
    };
  }
});
var Uu = vs([
  {
    cond: (t, e) => e.errorEvent?.type === _i,
    actions: [
      hs({
        type: ql,
        isAutoRecoverEvent: true
      })
    ]
  }
]);
var Bu = Et({
  actionsRunning: true
});
var zu = Et({
  actionsRunning: false
});
var qu = (t, e) => {
  const n = e.changedExperienceTraits && e.changedExperienceTraits.changedTraits.length > 0, r = e.changedExperienceTraits && (e.changedExperienceTraits.addedTraits.length > 0 || e.changedExperienceTraits.removedTraits.length > 0), i = e.changedStepTraits && e.changedStepTraits.changedTraits.length > 0, o = e.changedStepTraits && (e.changedStepTraits.addedTraits.length > 0 || e.changedStepTraits.removedTraits.length > 0);
  return r || o ? false : !!(n || i);
};
var Vu = "Key name should be string and callback a valid function";
var Vs = () => {
  const t = /* @__PURE__ */ new Map(), e = (r) => t.get(r);
  return {
    getCallback: e,
    registerCallback: (r, i) => {
      if (e(r), typeof r != "string" || typeof i != "function")
        throw new TypeError(Vu);
      t.set(r, i);
    }
  };
};
var Ws = ({ getTrait: t, trait: e, ...n }) => {
  const r = t(e.type);
  r && r(n, e.config ?? {});
};
var { getCallback: Gs, registerCallback: bt } = Vs();
var Wu = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
var Gu = ({
  experience: t,
  callback: e,
  step: n,
  findId: r,
  getContainer: i,
  getWindowReference: o
}) => {
  const s = (c, { forwardToParent: l = false } = {}) => {
    const v = ({ type: f, ...u }) => e(l ? {
      ...u,
      eventType: f,
      type: Jl
    } : { type: f, ...u });
    return {
      querySelector: (f) => Us(f, {
        step: n,
        checkOutsideContainer: false,
        stepContainer: i(),
        getWindowReference: o
      }),
      start: () => v({
        type: _s,
        id: c.id
      }),
      stop: (f) => {
        v({
          type: bi,
          id: c.id,
          onStopped: f
        });
      },
      setStepContainerTarget: (f) => {
        v({
          type: Rs,
          id: c.id,
          container: f
        });
      },
      recover: ({ errorId: f }) => {
        v({
          type: zl,
          id: c.id,
          errorId: f
        });
      },
      dismissExperience: () => v({
        type: Yl
      }),
      snoozeExperience: () => v({
        type: Zl
      }),
      seen: () => v({
        type: Kl,
        id: c.id
      }),
      getConfig: () => c,
      interaction: (f, u) => v({
        type: Gl,
        id: c.id,
        interactionType: f,
        interactionData: u
      }),
      extendedEvent: (f, u) => v({
        type: Bl,
        id: c.id,
        name: f,
        ...u
      })
    };
  }, a = t.steps.map(
    (c) => s(c, { forwardToParent: !!n })
  );
  return n ? {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a,
    step: s(n, { forwardToParent: false })
  } : {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a
  };
};
var Ci = ({
  experience: t,
  step: e,
  overrideStyle: n,
  getContainer: r,
  getRoot: i,
  callback: o,
  get: s,
  getAction: a = () => null
}) => {
  const { findId: c } = s("vNodeHandlers"), l = s("getWindowReference"), v = Gu({
    experience: t,
    step: e,
    callback: o,
    findId: c,
    getContainer: r,
    getWindowReference: l
  }), h = {
    getContainer: r,
    querySelector: (g) => Us(g, {
      step: e,
      checkOutsideContainer: true,
      stepContainer: r(),
      getWindowReference: l
    }),
    reportError: (g) => {
      const E = Wu();
      return o({
        type: Wl,
        message: g,
        errorId: E
      }), E;
    },
    onElementInserted: (g) => cu({ ...g, getWindowReference: l }),
    onElementRemoved: (g) => Ri({ ...g, getWindowReference: l }),
    ...v,
    stopExperience: () => o(Ce),
    getExperienceId: () => t.id,
    getWindowReference: l,
    sendEvent: s("sendEvent"),
    sendCustomEvent: s("sendCustomEvent"),
    showFlow: s("showFlow"),
    updateUserProfile: s("updateUserProfile"),
    getAction: (g) => a(`${t.id}.${g}`) ?? a(`${e.id}.${g}`) ?? a(g)
  };
  return n ? {
    updateStyle: (S, y) => {
      n(S, y), o({
        type: Ts,
        id: e.id
      });
    },
    updateRootStyle: (S, y = {}) => {
      o({
        type: Os,
        styles: S,
        options: y,
        getRoot: i
      });
    },
    ...h
  } : h;
};
var vo = "formData.";
var Ku = "a, button, video, input, textarea, select, form";
var Xu = (t, e) => {
  if (e.startsWith(vo)) {
    const n = e.replace(vo, "");
    return new FormData(t.target).get(n);
  }
  return Il(t, e);
};
var { getCallback: re, registerCallback: ce } = Vs();
var Ks = (t, e, n) => {
  const r = {
    target: e.target,
    detail: e.detail
  };
  return Object.entries(t).reduce(
    (i, [o, s]) => {
      const a = Xu(r, o);
      return a ? Pl(i, s, a) : i;
    },
    n
  );
};
var Yu = ({
  step: t,
  experience: e,
  overrideStyle: n,
  getContainer: r,
  callback: i,
  get: o
}) => {
  const s = o("getWindowReference"), a = [];
  return Object.entries(t.actions ?? {}).forEach(([c, l]) => {
    if (!l.some((u) => u.config?.external)) return;
    let v;
    try {
      v = Array.from(
        s().document.querySelectorAll(c)
      );
    } catch {
      return;
    }
    if (v.length === 0) return;
    const f = {};
    l.forEach(
      ({ on: u, type: p, config: h, allowedKeys: g, mapEventToConfig: E }) => {
        if (!h?.external || u.startsWith("hooks/")) return;
        const S = re(`${e.id}.${p}`) ?? re(`${t.id}.${p}`) ?? re(p);
        f[u] || (f[u] = []), S && f[u].push([
          S,
          h,
          g,
          E
        ]);
      }
    ), Object.entries(f).forEach(([u, p]) => {
      const h = (g) => {
        i({ type: Ps });
        const E = Ci({
          experience: e,
          step: t,
          overrideStyle: n,
          getContainer: r,
          callback: i,
          get: o,
          getAction: re
        });
        try {
          p.forEach(([S, y, b, _]) => {
            if (!(b && !b.includes(g.code)))
              if (_) {
                const w = {
                  ...y,
                  ...Ks(_, g, y)
                };
                S(w, E);
              } else
                S(y, E);
          });
        } catch {
          E.reportError(
            "something bad happened while running an action."
          );
        } finally {
          i({ type: Is });
        }
      };
      v.forEach((g) => {
        g.addEventListener(u, h), a.push({ el: g, event: u, handler: h });
      });
    });
  }), () => {
    a.forEach(
      ({ el: c, event: l, handler: v }) => c.removeEventListener(l, v)
    );
  };
};
var Zu = ({ overrideStyle: t, getContainer: e }, n) => ({ experience: r, step: i }) => (o, s) => {
  let a = () => {
  };
  return s(({ type: c }) => {
    if (c === Ti) {
      a();
      try {
        const { findId: l, traverseTree: v, injectHandlers: f } = n("vNodeHandlers"), u = JSON.parse(
          JSON.stringify(i.virtualizedContent)
        );
        v(u, (h) => {
          const g = l(h);
          if (!i.actions[g]) return;
          const E = {}, S = (_, w) => {
            o({
              type: Ps
            });
            const A = Ci({
              experience: r,
              step: i,
              overrideStyle: t,
              getContainer: e,
              callback: o,
              get: n,
              getAction: re
            });
            try {
              E[_].forEach(([O, C, I]) => {
                if (I && w) {
                  const D = {
                    ...C,
                    ...Ks(
                      I,
                      w,
                      C
                    )
                  };
                  O(D, A);
                } else
                  O(C, A);
              });
            } catch {
              A.reportError(
                "something bad happened while running an action."
              );
            } finally {
              o({
                type: Is
              });
            }
          }, y = {}, b = i.actions[g].reduce(
            (_, {
              on: w,
              type: A,
              config: O,
              allowedKeys: C,
              mapEventToConfig: I,
              guardInteractiveChildren: D
            }) => {
              D && (y[w] = true);
              const $ = re(`${r.id}.${A}`) ?? re(`${i.id}.${A}`) ?? re(A);
              return E[w] || (E[w] = []), $ && E[w].push([$, O, I]), w.startsWith("hooks/") ? _.hook[w.replace("hooks/", "")] = () => S(w) : _.on[w] = (j) => {
                if (!(C && !C.includes(j.code))) {
                  if (y[w]) {
                    const q = j.target.closest(
                      Ku
                    );
                    if (q && q !== j.currentTarget)
                      return;
                  }
                  j.preventDefault(), j.stopPropagation(), S(w, j);
                }
              }, _;
            },
            {
              on: {},
              hook: {}
            }
          );
          h = f(h, b);
        }), o({
          type: Cs,
          virtualizedContent: u
        }), a = Yu({
          step: i,
          experience: r,
          overrideStyle: t,
          getContainer: e,
          callback: o,
          get: n
        });
      } catch {
        o(ru);
      }
    }
  }), () => a();
};
var Ju = ({ addHook: t }) => (e) => (n) => {
  const { step: r } = e;
  try {
    r.traits.forEach(
      (i) => Ws({
        getTrait: Gs,
        addHook: (o, s) => {
          t(o, { callback: s, traitId: i.id });
        },
        registerAction: (o, s) => {
          ce(`${r.id}.${i.type}.${o}`, s);
        },
        trait: i
      })
    ), n(Ti);
  } catch {
    n(Fs);
  }
};
var Qu = ({ applyOverridesToVnode: t }) => {
  let e = {};
  const n = (s) => (a, c) => {
    e[a] || (e[a] = {}), e[a][s] || (e[a][s] = {}), e[a][s] = {
      ...e[a][s],
      ...c
    };
  }, r = (s) => e[s], i = () => {
    e = {};
  }, o = Et(({ step: s }) => ({
    step: {
      ...s,
      virtualizedContent: t(
        s.virtualizedContent,
        r
      )
    }
  }));
  return {
    createOverrideCallback: n,
    getOverrides: r,
    applyOverrides: o,
    clearOverrides: i
  };
};
function tf(t, e) {
  return document.createElement(t, e);
}
function ef(t, e, n) {
  return document.createElementNS(t, e, n);
}
function nf() {
  return Oe(document.createDocumentFragment());
}
function rf(t) {
  return document.createTextNode(t);
}
function of(t) {
  return document.createComment(t);
}
function sf(t, e, n) {
  if (ie(t)) {
    let r = t;
    for (; r && ie(r); )
      r = Oe(r).parent;
    t = r ?? t;
  }
  ie(e) && (e = Oe(e, t)), n && ie(n) && (n = Oe(n).firstChildNode), t.insertBefore(e, n);
}
function af(t, e) {
  t.removeChild(e);
}
function cf(t, e) {
  ie(e) && (e = Oe(e, t)), t.appendChild(e);
}
function Xs(t) {
  if (ie(t)) {
    for (; t && ie(t); )
      t = Oe(t).parent;
    return t ?? null;
  }
  return t.parentNode;
}
function lf(t) {
  var e;
  if (ie(t)) {
    const n = Oe(t), r = Xs(n);
    if (r && n.lastChildNode) {
      const i = Array.from(r.childNodes), o = i.indexOf(n.lastChildNode);
      return (e = i[o + 1]) !== null && e !== void 0 ? e : null;
    }
    return null;
  }
  return t.nextSibling;
}
function uf(t) {
  return t.tagName;
}
function ff(t, e) {
  t.textContent = e;
}
function df(t) {
  return t.textContent;
}
function pf(t) {
  return t.nodeType === 1;
}
function hf(t) {
  return t.nodeType === 3;
}
function vf(t) {
  return t.nodeType === 8;
}
function ie(t) {
  return t.nodeType === 11;
}
function Oe(t, e) {
  var n, r, i;
  const o = t;
  return (n = o.parent) !== null && n !== void 0 || (o.parent = e ?? null), (r = o.firstChildNode) !== null && r !== void 0 || (o.firstChildNode = t.firstChild), (i = o.lastChildNode) !== null && i !== void 0 || (o.lastChildNode = t.lastChild), o;
}
var Oi = {
  createElement: tf,
  createElementNS: ef,
  createTextNode: rf,
  createDocumentFragment: nf,
  createComment: of,
  insertBefore: sf,
  removeChild: af,
  appendChild: cf,
  parentNode: Xs,
  nextSibling: lf,
  tagName: uf,
  setTextContent: ff,
  getTextContent: df,
  isElement: pf,
  isText: hf,
  isComment: vf,
  isDocumentFragment: ie
};
function It(t, e, n, r, i) {
  const o = e === void 0 ? void 0 : e.key;
  return { sel: t, data: e, children: n, text: r, elm: i, key: o };
}
var Je = Array.isArray;
function Ae(t) {
  return typeof t == "string" || typeof t == "number" || t instanceof String || t instanceof Number;
}
var jr = It("", {}, [], void 0, void 0);
function gn(t, e) {
  var n, r;
  const i = t.key === e.key, o = ((n = t.data) === null || n === void 0 ? void 0 : n.is) === ((r = e.data) === null || r === void 0 ? void 0 : r.is), s = t.sel === e.sel, a = !t.sel && t.sel === e.sel ? typeof t.text == typeof e.text : true;
  return s && i && o && a;
}
function gf() {
  throw new Error("The document fragment is not supported on this platform.");
}
function yf(t, e) {
  return t.isElement(e);
}
function mf(t, e) {
  return t.isDocumentFragment(e);
}
function Ef(t, e, n) {
  var r;
  const i = {};
  for (let o = e; o <= n; ++o) {
    const s = (r = t[o]) === null || r === void 0 ? void 0 : r.key;
    s !== void 0 && (i[s] = o);
  }
  return i;
}
var Sf = [
  "create",
  "update",
  "remove",
  "destroy",
  "pre",
  "post"
];
function Ys(t, e, n) {
  const r = {
    create: [],
    update: [],
    remove: [],
    destroy: [],
    pre: [],
    post: []
  }, i = e !== void 0 ? e : Oi;
  for (const h of Sf)
    for (const g of t) {
      const E = g[h];
      E !== void 0 && r[h].push(E);
    }
  function o(h) {
    const g = h.id ? "#" + h.id : "", E = h.getAttribute("class"), S = E ? "." + E.split(" ").join(".") : "";
    return It(i.tagName(h).toLowerCase() + g + S, {}, [], void 0, h);
  }
  function s(h) {
    return It(void 0, {}, [], void 0, h);
  }
  function a(h, g) {
    return function() {
      if (--g === 0) {
        const S = i.parentNode(h);
        S !== null && i.removeChild(S, h);
      }
    };
  }
  function c(h, g) {
    var E, S, y, b, _;
    let w;
    const A = h.data, O = A?.hook;
    (E = O?.init) === null || E === void 0 || E.call(O, h);
    const C = h.children, I = h.sel;
    if (I === "!")
      (S = h.text) !== null && S !== void 0 || (h.text = ""), h.elm = i.createComment(h.text);
    else if (I === "")
      h.elm = i.createTextNode(h.text);
    else if (I !== void 0) {
      const D = I.indexOf("#"), $ = I.indexOf(".", D), j = D > 0 ? D : I.length, q = $ > 0 ? $ : I.length, Z = D !== -1 || $ !== -1 ? I.slice(0, Math.min(j, q)) : I, K = A?.ns, rt = K === void 0 ? i.createElement(Z, A) : i.createElementNS(K, Z, A);
      for (h.elm = rt, j < q && rt.setAttribute("id", I.slice(j + 1, q)), $ > 0 && rt.setAttribute("class", I.slice(q + 1).replace(/\./g, " ")), w = 0; w < r.create.length; ++w)
        r.create[w](jr, h);
      if (Ae(h.text) && (!Je(C) || C.length === 0) && i.appendChild(rt, i.createTextNode(h.text)), Je(C))
        for (w = 0; w < C.length; ++w) {
          const ct = C[w];
          ct != null && i.appendChild(rt, c(ct, g));
        }
      O !== void 0 && ((y = O.create) === null || y === void 0 || y.call(O, jr, h), O.insert !== void 0 && g.push(h));
    } else if (!((b = n?.experimental) === null || b === void 0) && b.fragments && h.children) {
      for (h.elm = ((_ = i.createDocumentFragment) !== null && _ !== void 0 ? _ : gf)(), w = 0; w < r.create.length; ++w)
        r.create[w](jr, h);
      for (w = 0; w < h.children.length; ++w) {
        const D = h.children[w];
        D != null && i.appendChild(h.elm, c(D, g));
      }
    } else
      h.elm = i.createTextNode(h.text);
    return h.elm;
  }
  function l(h, g, E, S, y, b) {
    for (; S <= y; ++S) {
      const _ = E[S];
      _ != null && i.insertBefore(h, c(_, b), g);
    }
  }
  function v(h) {
    var g, E;
    const S = h.data;
    if (S !== void 0) {
      (E = (g = S?.hook) === null || g === void 0 ? void 0 : g.destroy) === null || E === void 0 || E.call(g, h);
      for (let y = 0; y < r.destroy.length; ++y)
        r.destroy[y](h);
      if (h.children !== void 0)
        for (let y = 0; y < h.children.length; ++y) {
          const b = h.children[y];
          b != null && typeof b != "string" && v(b);
        }
    }
  }
  function f(h, g, E, S) {
    for (var y, b; E <= S; ++E) {
      let _;
      const w = g[E];
      if (w != null)
        if (w.sel !== void 0) {
          v(w), _ = r.remove.length + 1;
          const A = a(w.elm, _);
          for (let C = 0; C < r.remove.length; ++C)
            r.remove[C](w, A);
          const O = (b = (y = w?.data) === null || y === void 0 ? void 0 : y.hook) === null || b === void 0 ? void 0 : b.remove;
          O !== void 0 ? O(w, A) : A();
        } else w.children ? (v(w), f(h, w.children, 0, w.children.length - 1)) : i.removeChild(h, w.elm);
    }
  }
  function u(h, g, E, S) {
    let y = 0, b = 0, _ = g.length - 1, w = g[0], A = g[_], O = E.length - 1, C = E[0], I = E[O], D, $, j, q;
    for (; y <= _ && b <= O; )
      w == null ? w = g[++y] : A == null ? A = g[--_] : C == null ? C = E[++b] : I == null ? I = E[--O] : gn(w, C) ? (p(w, C, S), w = g[++y], C = E[++b]) : gn(A, I) ? (p(A, I, S), A = g[--_], I = E[--O]) : gn(w, I) ? (p(w, I, S), i.insertBefore(h, w.elm, i.nextSibling(A.elm)), w = g[++y], I = E[--O]) : gn(A, C) ? (p(A, C, S), i.insertBefore(h, A.elm, w.elm), A = g[--_], C = E[++b]) : (D === void 0 && (D = Ef(g, y, _)), $ = D[C.key], $ === void 0 ? (i.insertBefore(h, c(C, S), w.elm), C = E[++b]) : D[I.key] === void 0 ? (i.insertBefore(h, c(I, S), i.nextSibling(A.elm)), I = E[--O]) : (j = g[$], j.sel !== C.sel ? i.insertBefore(h, c(C, S), w.elm) : (p(j, C, S), g[$] = void 0, i.insertBefore(h, j.elm, w.elm)), C = E[++b]));
    b <= O && (q = E[O + 1] == null ? null : E[O + 1].elm, l(h, q, E, b, O, S)), y <= _ && f(h, g, y, _);
  }
  function p(h, g, E) {
    var S, y, b, _, w, A, O, C;
    const I = (S = g.data) === null || S === void 0 ? void 0 : S.hook;
    (y = I?.prepatch) === null || y === void 0 || y.call(I, h, g);
    const D = g.elm = h.elm;
    if (h === g)
      return;
    if (g.data !== void 0 || g.text !== void 0 && g.text !== h.text) {
      (b = g.data) !== null && b !== void 0 || (g.data = {}), (_ = h.data) !== null && _ !== void 0 || (h.data = {});
      for (let q = 0; q < r.update.length; ++q)
        r.update[q](h, g);
      (O = (A = (w = g.data) === null || w === void 0 ? void 0 : w.hook) === null || A === void 0 ? void 0 : A.update) === null || O === void 0 || O.call(A, h, g);
    }
    const $ = h.children, j = g.children;
    g.text === void 0 ? $ !== void 0 && j !== void 0 ? $ !== j && u(D, $, j, E) : j !== void 0 ? (h.text !== void 0 && i.setTextContent(D, ""), l(D, null, j, 0, j.length - 1, E)) : $ !== void 0 ? f(D, $, 0, $.length - 1) : h.text !== void 0 && i.setTextContent(D, "") : h.text !== g.text && ($ !== void 0 && f(D, $, 0, $.length - 1), i.setTextContent(D, g.text)), (C = I?.postpatch) === null || C === void 0 || C.call(I, h, g);
  }
  return function(g, E) {
    let S, y, b;
    const _ = [];
    for (S = 0; S < r.pre.length; ++S)
      r.pre[S]();
    for (yf(i, g) ? g = o(g) : mf(i, g) && (g = s(g)), gn(g, E) ? p(g, E, _) : (y = g.elm, b = i.parentNode(y), c(E, _), b !== null && (i.insertBefore(b, E.elm, i.nextSibling(y)), f(b, [g], 0, 0))), S = 0; S < _.length; ++S)
      _[S].data.hook.insert(_[S]);
    for (S = 0; S < r.post.length; ++S)
      r.post[S]();
    return E;
  };
}
function Rr(t, e, n) {
  if (t.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && e !== void 0)
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      if (typeof i == "string")
        continue;
      const o = i.data;
      o !== void 0 && Rr(o, i.children, i.sel);
    }
}
function ae(t, e, n) {
  let r = {}, i, o, s;
  if (n !== void 0 ? (e !== null && (r = e), Je(n) ? i = n : Ae(n) ? o = n.toString() : n && n.sel && (i = [n])) : e != null && (Je(e) ? i = e : Ae(e) ? o = e.toString() : e && e.sel ? i = [e] : r = e), i !== void 0)
    for (s = 0; s < i.length; ++s)
      Ae(i[s]) && (i[s] = It(void 0, void 0, void 0, i[s], void 0));
  return t.startsWith("svg") && (t.length === 3 || t[3] === "." || t[3] === "#") && Rr(r, i, t), It(t, r, i, o, void 0);
}
function ui(t) {
  let e, n;
  if (Je(t) ? e = t : Ae(e) ? n = t : e && e.sel && (e = [t]), e !== void 0)
    for (let r = 0; r < e.length; ++r)
      Ae(e[r]) && (e[r] = It(void 0, void 0, void 0, e[r], void 0));
  return It(void 0, {}, e, n, void 0);
}
function rr(t, e) {
  var n;
  const r = (n = e.data) === null || n === void 0 ? void 0 : n.ns;
  t.data.fn = e.data.fn, t.data.args = e.data.args, e.data = t.data, e.children = t.children, e.text = t.text, e.elm = t.elm, r && Rr(e.data, e.children, e.sel);
}
function bf(t) {
  const e = t.data, n = e.fn(...e.args);
  rr(n, t);
}
function wf(t, e) {
  let n;
  const r = t.data, i = e.data, o = r.args, s = i.args;
  if (r.fn !== i.fn || o.length !== s.length) {
    rr(i.fn(...s), e);
    return;
  }
  for (n = 0; n < s.length; ++n)
    if (o[n] !== s[n]) {
      rr(i.fn(...s), e);
      return;
    }
  rr(t, e);
}
var xf = function(e, n, r, i) {
  return i === void 0 && (i = r, r = n, n = void 0), ae(e, {
    key: n,
    hook: { init: bf, prepatch: wf },
    fn: r,
    args: i
  });
};
function _f(t, e) {
  const n = t.data.attachData;
  e.data.attachData.placeholder = n.placeholder, e.data.attachData.real = n.real, t.elm = t.data.attachData.real;
}
function Tf(t, e) {
  e.elm = e.data.attachData.placeholder;
}
function Rf(t) {
  t.elm !== void 0 && t.elm.parentNode.removeChild(t.elm), t.elm = t.data.attachData.real;
}
function Cf(t, e) {
  const n = e.elm, r = e.data.attachData, i = document.createElement("span");
  e.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function Of(t, e) {
  e.data === void 0 && (e.data = {}), e.data.hook === void 0 && (e.data.hook = {});
  const n = e.data, r = e.data.hook;
  return n.attachData = { target: t, placeholder: void 0, real: void 0 }, r.create = Cf, r.prepatch = _f, r.postpatch = Tf, r.destroy = Rf, e;
}
function Af(t) {
  return t.slice(5).replace(/-([a-z])/g, (e, n) => n.toUpperCase());
}
function Zs(t, e) {
  var n;
  const r = e !== void 0 ? e : Oi;
  let i;
  if (r.isElement(t)) {
    const o = t.id ? "#" + t.id : "", s = (n = t.getAttribute("class")) === null || n === void 0 ? void 0 : n.match(/[^\t\r\n\f ]+/g), a = s ? "." + s.join(".") : "", c = r.tagName(t).toLowerCase() + o + a, l = {}, v = {}, f = {}, u = [];
    let p, h, g;
    const E = t.attributes, S = t.childNodes;
    for (h = 0, g = E.length; h < g; h++)
      p = E[h].nodeName, p.startsWith("data-") ? v[Af(p)] = E[h].nodeValue || "" : p !== "id" && p !== "class" && (l[p] = E[h].nodeValue);
    for (h = 0, g = S.length; h < g; h++)
      u.push(Zs(S[h], e));
    return Object.keys(l).length > 0 && (f.attrs = l), Object.keys(v).length > 0 && (f.dataset = v), c.startsWith("svg") && (c.length === 3 || c[3] === "." || c[3] === "#") && Rr(f, u, c), It(c, f, u, void 0, t);
  } else return r.isText(t) ? (i = r.getTextContent(t), It(void 0, void 0, void 0, i, t)) : r.isComment(t) ? (i = r.getTextContent(t), It("!", {}, [], i, t)) : It("", {}, [], void 0, t);
}
var Nf = "http://www.w3.org/1999/xlink";
var Pf = "http://www.w3.org/2000/xmlns/";
var If = "http://www.w3.org/XML/1998/namespace";
var go = 58;
var Df = 120;
var Lf = 109;
function yo(t, e) {
  let n;
  const r = e.elm;
  let i = t.data.attrs, o = e.data.attrs;
  if (!(!i && !o) && i !== o) {
    i = i || {}, o = o || {};
    for (n in o) {
      const s = o[n];
      i[n] !== s && (s === true ? r.setAttribute(n, "") : s === false ? r.removeAttribute(n) : n.charCodeAt(0) !== Df ? r.setAttribute(n, s) : n.charCodeAt(3) === go ? r.setAttributeNS(If, n, s) : n.charCodeAt(5) === go ? n.charCodeAt(1) === Lf ? r.setAttributeNS(Pf, n, s) : r.setAttributeNS(Nf, n, s) : r.setAttribute(n, s));
    }
    for (n in i)
      n in o || r.removeAttribute(n);
  }
}
var Js = {
  create: yo,
  update: yo
};
function mo(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.class, s = e.data.class;
  if (!(!o && !s) && o !== s) {
    o = o || {}, s = s || {};
    for (r in o)
      o[r] && !Object.prototype.hasOwnProperty.call(s, r) && i.classList.remove(r);
    for (r in s)
      n = s[r], n !== o[r] && i.classList[n ? "add" : "remove"](r);
  }
}
var Qs = { create: mo, update: mo };
var Eo = /[A-Z]/g;
function So(t, e) {
  const n = e.elm;
  let r = t.data.dataset, i = e.data.dataset, o;
  if (!r && !i || r === i)
    return;
  r = r || {}, i = i || {};
  const s = n.dataset;
  for (o in r)
    o in i || (s ? o in s && delete s[o] : n.removeAttribute("data-" + o.replace(Eo, "-$&").toLowerCase()));
  for (o in i)
    r[o] !== i[o] && (s ? s[o] = i[o] : n.setAttribute("data-" + o.replace(Eo, "-$&").toLowerCase(), i[o]));
}
var $f = {
  create: So,
  update: So
};
function ta(t, e, n) {
  if (typeof t == "function")
    t.call(e, n, e);
  else if (typeof t == "object")
    for (let r = 0; r < t.length; r++)
      ta(t[r], e, n);
}
function kf(t, e) {
  const n = t.type, r = e.data.on;
  r && r[n] && ta(r[n], e, t);
}
function Mf() {
  return function t(e) {
    kf(e, t.vnode);
  };
}
function Fr(t, e) {
  const n = t.data.on, r = t.listener, i = t.elm, o = e && e.data.on, s = e && e.elm;
  let a;
  if (n !== o) {
    if (n && r)
      if (o)
        for (a in n)
          o[a] || i.removeEventListener(a, r, false);
      else
        for (a in n)
          i.removeEventListener(a, r, false);
    if (o) {
      const c = e.listener = t.listener || Mf();
      if (c.vnode = e, n)
        for (a in o)
          n[a] || s.addEventListener(a, c, false);
      else
        for (a in o)
          s.addEventListener(a, c, false);
    }
  }
}
var ea = {
  create: Fr,
  update: Fr,
  destroy: Fr
};
function bo(t, e) {
  let n, r, i;
  const o = e.elm;
  let s = t.data.props, a = e.data.props;
  if (!(!s && !a) && s !== a) {
    s = s || {}, a = a || {};
    for (n in a)
      r = a[n], i = s[n], i !== r && (n !== "value" || o[n] !== r) && (o[n] = r);
  }
}
var na = { create: bo, update: bo };
var wo = typeof window?.requestAnimationFrame == "function" ? window.requestAnimationFrame.bind(window) : setTimeout;
var Hf = (t) => {
  wo(() => {
    wo(t);
  });
};
var fi = false;
function jf(t, e, n) {
  Hf(() => {
    t[e] = n;
  });
}
function xo(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.style, s = e.data.style;
  if (!o && !s || o === s)
    return;
  o = o || {}, s = s || {};
  const a = "delayed" in o;
  for (r in o)
    r in s || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
  for (r in s)
    if (n = s[r], r === "delayed" && s.delayed)
      for (const c in s.delayed)
        n = s.delayed[c], (!a || n !== o.delayed[c]) && jf(i.style, c, n);
    else r !== "remove" && n !== o[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function Ff(t) {
  let e, n;
  const r = t.elm, i = t.data.style;
  if (!(!i || !(e = i.destroy)))
    for (n in e)
      r.style[n] = e[n];
}
function Uf(t, e) {
  const n = t.data.style;
  if (!n || !n.remove) {
    e();
    return;
  }
  fi || (t.elm.offsetLeft, fi = true);
  let r;
  const i = t.elm;
  let o = 0;
  const s = n.remove;
  let a = 0;
  const c = [];
  for (r in s)
    c.push(r), i.style[r] = s[r];
  const v = getComputedStyle(i)["transition-property"].split(", ");
  for (; o < v.length; ++o)
    c.indexOf(v[o]) !== -1 && a++;
  i.addEventListener("transitionend", (f) => {
    f.target === i && --a, a === 0 && e();
  });
}
function Bf() {
  fi = false;
}
var ra = {
  pre: Bf,
  create: xo,
  update: xo,
  destroy: Ff,
  remove: Uf
};
function zf(t, ...e) {
  const n = Ai(e, []);
  return n.length === 1 && !n[0].sel && n[0].text ? It(void 0, void 0, void 0, n[0].text, void 0) : It(void 0, t ?? {}, n, void 0, void 0);
}
function Ai(t, e) {
  for (const n of t)
    n != null && n !== false && n !== "" && (Array.isArray(n) ? Ai(n, e) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? e.push(It(void 0, void 0, void 0, String(n), void 0)) : e.push(n));
  return e;
}
function qf(t, e, ...n) {
  const r = Ai(n, []);
  return typeof t == "function" ? t(e, r) : r.length === 1 && !r[0].sel && r[0].text ? ae(t, e, r[0].text) : ae(t, e, r);
}
var Vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Fragment: zf,
  array: Je,
  attachTo: Of,
  attributesModule: Js,
  classModule: Qs,
  datasetModule: $f,
  eventListenersModule: ea,
  fragment: ui,
  h: ae,
  htmlDomApi: Oi,
  init: Ys,
  jsx: qf,
  primitive: Ae,
  propsModule: na,
  styleModule: ra,
  thunk: xf,
  toVNode: Zs,
  vnode: It
}, Symbol.toStringTag, { value: "Module" }));
var Wf = (...t) => (e) => t.reduce((n, r) => r(n), e);
var _o = (t) => t.reduce(
  (e, { callback: n, context: r }) => e.then(() => n(r)),
  Promise.resolve()
);
var Gf = ({
  experience: t,
  onRender: e,
  onRenderReset: n,
  wrapContent: r,
  getWindowReference: i = () => window
}) => {
  let o = null, s = null;
  const a = () => {
    const b = i().document, _ = Ie(t.id);
    return b.documentElement.querySelector(`#${_}`);
  }, c = () => s ? s.shadowRoot : null, l = () => o ? o.shadowRoot : null, f = Wf(
    (b) => (l() !== null || c() !== null || (o = a()), b),
    r,
    ({ step: { virtualizedContent: b } }) => {
      e(
        c() ?? l(),
        b
      );
    }
  );
  return {
    render: async (b) => new Promise((_) => {
      _(f(b));
    }),
    unmount: () => e(null, ae("!")),
    setContainer: (b, { container: _ }) => {
      const { theme: w, themeSystem: A, accountId: O } = b.experience, { id: C } = b.step;
      s && s.remove(), s = Bs({
        accountId: O,
        id: C,
        // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
        ...!A && { theme: w },
        getWindowReference: i
      }), _.parentNode.replaceChild(s, _);
    },
    resetRender: () => {
      o = null, s && s.remove(), s = null, n();
    },
    getContainer: () => c() ?? l() ?? a().shadowRoot,
    getRoot: () => s ?? a(),
    hasCustomContainer: (b, _) => _.type === Os && _.options?.forceUpdate || !!c()
  };
};
var Kf = ({ container: t, nodes: e }, n = 0) => t.replace(/<% node %>/, e[n]);
var Xf = (t) => t.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/");
var Yf = (t) => t.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
var zt = ({ experience: t, experienceInstanceId: e }, n) => ({
  experienceId: t.id,
  experienceName: t.name,
  experienceType: t.type,
  isCoreEvent: true,
  localeName: t.context?.localeName || "default",
  localeId: t.context?.localeId || "default",
  timestamp: Date.now(),
  version: t.version,
  name: Yf(n),
  experienceInstanceId: e
});
var ye = ({ step: t }) => ({
  stepId: t.id,
  stepName: t.name,
  stepType: t.type
});
var Zf = (t, e) => !t.blockedEvents[e.type];
var ia = (t) => {
  const e = (p) => {
    const h = "experience_started", g = zt(p, h);
    t("sendEvent")(h, g);
  }, n = (p) => {
    const h = "experience_completed", g = zt(p, h);
    t("sendEvent")(h, g);
  }, r = (p, { message: h }) => {
    const g = "experience_error", E = zt(p, g);
    t("sendEvent")(g, { ...E, message: h });
  }, i = (p) => {
    const h = "experience_dismissed", g = zt(p, h), E = ye(p);
    t("sendEvent")(h, {
      ...g,
      ...E
    });
  }, o = (p) => {
    const h = "experience_snoozed", g = zt(p, h), E = ye(p);
    t("sendEvent")(h, {
      ...g,
      ...E
    });
  }, s = (p) => {
    const h = "step_seen", g = zt(p, h), E = ye(p);
    t("sendEvent")(h, {
      ...g,
      ...E
    });
  }, a = (p) => {
    const h = "step_completed", g = zt(p, h), E = ye(p);
    t("sendEvent")(h, {
      ...g,
      ...E
    });
  }, c = (p, h) => {
    const g = zt(p, h.name), E = ye(p), S = t("sendEvent"), { name: y, ...b } = h;
    S(y, {
      ...g,
      ...E,
      ...b
    });
  }, l = (p, { interactionType: h, interactionData: g }) => {
    const E = "step_interaction", S = zt(p, E), y = ye(p);
    t("sendEvent")(E, {
      ...S,
      ...y,
      interactionType: h,
      interactionData: g
    });
  }, v = (p, { message: h, errorId: g }) => {
    const E = "step_error", S = zt(p, E), y = ye(p);
    t("sendEvent")(E, {
      ...S,
      ...y,
      message: h,
      errorId: g
    });
  }, f = (p, { errorId: h }) => {
    const g = "step_recovered", E = zt(p, g), S = ye(p);
    t("sendEvent")(g, {
      ...E,
      ...S,
      errorId: h
    });
  }, u = Et((p, { type: h, name: g = "" }) => {
    const E = h === "EXTENDED_EVENT" ? g : h;
    return {
      blockedEvents: {
        ...p.blockedEvents,
        [E]: true
      }
    };
  });
  return {
    experienceActions: {
      experienceStarted: e,
      experienceError: r,
      experienceCompleted: n
    },
    stepActions: {
      // NOTE: see above why this "experience" event is included in stepActions
      experienceDismissed: i,
      experienceSnoozed: o,
      stepSeen: s,
      stepInteraction: l,
      stepError: v,
      stepRecovered: f,
      stepExtendedEvent: c,
      stepCompleted: a
    },
    helpers: {
      blockEvent: u,
      isEventEnabled: Zf
    }
  };
};
var Jf = _r({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: false
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        UPDATE_STEP: "update_step",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "",
          actions: Et({
            runHooksDone: true
          })
        }
      }
    },
    update_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ft("RERENDER")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            Et({
              runHooksDone: true
            }),
            Ft("RERENDER")
          ]
        }
      }
    },
    error: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ft("FORCE_ERROR")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            Et({
              runHooksDone: true
            }),
            Ft("FORCE_ERROR")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
});
var Qf = _r({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: false
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        RECOVER_STEP: "recover_step",
        RUN_HOOKS_DONE: {
          target: "",
          actions: Et({
            runHooksDone: true
          })
        }
      }
    },
    recover_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ft("FORCE_RECOVER")]
        }
      ],
      on: {
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            Et({
              runHooksDone: true
            }),
            Ft("FORCE_RECOVER")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
});
var td = {
  initial: "waiting_to_render",
  on: {
    SET_STEP_CONTAINER_TARGET: {
      actions: ["setContainer", "runStepContainerChangeHooks"],
      target: ""
    },
    UPDATE_ROOT_STYLE: {
      actions: "updateRootStyle",
      target: "",
      // updateRootStyle should only be called if
      // step has custom container since otherwise,
      // it would affect the global appcues-container
      // where multiple steps may coexist.
      cond: "hasCustomContainer"
    },
    UPDATE_STEP_CONTENT: {
      actions: "setContent",
      target: ""
    },
    RUN_HOOKS_ERROR: "destroyed",
    BIND_ACTIONS_ERROR: "destroyed",
    STOP_STEP: [
      {
        cond: "hasPendingActions",
        target: "waitingPendingActions",
        actions: ["saveStopReason", "addStoppedCallback"],
        internal: true
      },
      {
        target: "running_end_hooks",
        actions: ["saveStopReason", "addStoppedCallback"]
      }
    ],
    // Transitions by default are internal: false
    // meaning it will run entry, exit actions and also invoked services.
    // In this case we can't let it be false, otherwise the service instance (hooks and actions)
    // will not be the same and the sync callback calls will stop working
    // since the current callback instance was stopped to start a new one.
    // letting internal:true the service will be started just one time.
    // check https://xstate.js.org/docs/guides/transitions.html#internal-transitions
    // to understand better about internal config.
    PARENT_RECOVER_STEP: {
      actions: ["stepRecovered"],
      target: "rendering",
      internal: true
    },
    EXPERIENCE_DISMISSED: {
      target: "",
      actions: [
        "experienceDismissed",
        Ft({ type: Ce, reason: Ee.DISMISSED })
      ]
    },
    EXPERIENCE_SNOOZED: {
      target: "",
      actions: [
        "experienceSnoozed",
        Ft({ type: Ce, reason: Ee.DISMISSED })
      ]
    },
    STEP_SEEN: {
      target: "",
      actions: ["stepSeen", "blockEvent"],
      cond: "isEventEnabled"
    },
    STEP_INTERACTION: {
      target: "",
      actions: ["stepInteraction"]
    },
    EXTENDED_EVENT: {
      actions: ["stepExtendedEvent", "blockEvent"],
      cond: "isEventEnabled"
    },
    RELOAD: [
      {
        target: "reload",
        actions: ["updateTheme", "updateStepContext"],
        cond: "didThemeChange"
      },
      {
        target: "reloading_traits",
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "shouldOnlyReloadTraits"
      },
      {
        target: "reload",
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "shouldStepReload"
      },
      {
        target: "rendering",
        internal: true,
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "didContentChanged"
      }
    ],
    [Ce]: {
      actions: [Ft(Ce)]
    },
    FORWARD_TO_PARENT: [
      {
        actions: [
          Ft((t, { eventType: e, ...n }) => ({
            ...n,
            type: e
          }))
        ],
        internal: true
      }
    ],
    ACTIONS_STARTED: {
      target: "",
      actions: "setActionsRunning",
      internal: true
    },
    ACTIONS_FINISHED: {
      target: "",
      actions: "setActionsFinished",
      internal: true
    }
  },
  invoke: [
    {
      id: "hooksService",
      src: "hooksService"
    },
    {
      id: "actionsService",
      src: "actionsService"
    },
    {
      id: "themeRemovalService",
      src: "themeRemovalService"
    }
  ],
  states: {
    waiting_to_render: {
      on: {
        START_STEP: "running_traits"
      }
    },
    reload: {
      entry: [
        "removeCustomContainer",
        "unmount",
        "resetRender",
        "clearOverrides",
        "runStepEndHooks"
      ],
      exit: ["removeStepHooks"],
      on: {
        RUN_HOOKS_DONE: {
          target: "running_traits"
        }
      }
    },
    reloading_traits: {
      entry: ["runStepEndHooks", "runStepBeginHooks"],
      // Only run for the changed traits
      on: {
        // Certain traits can dispatch errors while in begin state
        // like inline traits, in this case we still need to catch these errors
        // and we send it directly to error state, since the rendering flow didn't started.
        ERROR: {
          target: "error",
          internal: true,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "rendering",
          actions: "ensuresElementsAreAccessible",
          cond: "isHooksDoneEventBeginType"
        }
      }
    },
    running_traits: {
      invoke: {
        src: "runStepTraits"
      },
      on: {
        RUN_TRAITS_DONE: {
          target: "begin",
          // We can only bind actions' callbacks after running the traits
          // because traits can register actions.
          // so the action service will only do something after receiving
          // the confirmation that the traits are done with its execution.
          actions: je("actionsService")
        },
        RUN_TRAITS_ERROR: "destroyed"
      }
    },
    begin: {
      entry: ["runStepBeginHooks"],
      on: {
        // Certain traits can dispatch errors while in begin state
        // like inline traits, in this case we still need to catch these errors
        // and we send it directly to error state, since the rendering flow didn't started.
        ERROR: {
          target: "error",
          internal: true,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "rendering",
          actions: "ensuresElementsAreAccessible",
          cond: "isHooksDoneEventBeginType"
        }
      }
    },
    rendering: {
      initial: "pre-render",
      on: {
        STEP_CONTAINER_REMOVED: {
          target: "error",
          internal: false
        }
      },
      states: {
        "pre-render": {
          entry: ["runStepPreRenderHooks"],
          on: {
            RUN_HOOKS_DONE: [
              {
                target: "render",
                actions: ["applyOverrides"],
                cond: "isHooksDoneEventPreRenderType"
              }
            ]
          }
        },
        render: {
          invoke: {
            src: "render",
            onDone: [
              {
                target: "post-render",
                cond: "hasCustomContainer",
                actions: "startThemeRemovalListener"
              },
              {
                target: "post-render"
              }
            ]
          }
        },
        "post-render": {
          invoke: {
            id: "postRenderAsyncEventsHandler",
            src: Jf
          },
          entry: ["runStepPostRenderHooks"],
          on: {
            FORCE_ERROR: "#error",
            RERENDER: "pre-render",
            UPDATE_STEP: {
              target: "",
              actions: [je("postRenderAsyncEventsHandler")]
            },
            ERROR: {
              target: "",
              actions: [je("postRenderAsyncEventsHandler"), "stepError"]
            },
            RUN_HOOKS_DONE: {
              target: "",
              cond: "isHooksDoneEventPostRenderType",
              actions: [
                "notifyExperienceStarted",
                je("postRenderAsyncEventsHandler")
              ]
            }
          }
        }
      }
    },
    running_end_hooks: {
      entry: ["runStepEndHooks"],
      on: {
        RUN_HOOKS_DONE: [
          {
            cond: "shouldFireStepCompletedEvent",
            target: "calling_stopped_callbacks",
            actions: [
              "removeCustomContainer",
              "unmount",
              "stepCompleted",
              "removeStepHooks"
            ]
          },
          {
            cond: "isHooksDoneEventEndType",
            target: "calling_stopped_callbacks",
            actions: ["removeCustomContainer", "unmount", "removeStepHooks"]
          }
        ],
        RUN_HOOKS_ERROR: {
          target: "destroyed",
          actions: ["callStoppedCallbacks"]
        }
      }
    },
    calling_stopped_callbacks: {
      entry: ["callStoppedCallbacks", "deferTransitionToEnd"],
      on: {
        [Ns]: "end"
      }
    },
    end: {
      type: "final",
      entry: ["notifyStepStopped"]
    },
    error: {
      id: "error",
      invoke: [
        {
          id: "errorAsyncEventsHandler",
          src: Qf
        }
      ],
      entry: ["unmount", "runStepErrorHooks", "stopThemeRemovalListener"],
      on: {
        RUN_HOOKS_DONE: {
          target: "",
          cond: "isHooksDoneEventErrorType",
          actions: [je("errorAsyncEventsHandler"), "autoRecover"]
        },
        RECOVER_STEP: {
          target: "",
          actions: [je("errorAsyncEventsHandler")]
        },
        FORCE_RECOVER: {
          target: "begin",
          actions: ["resetRender", "stepRecovered"]
        },
        AUTO_RECOVER_STEP: {
          target: "begin",
          actions: "resetRender",
          cond: "isAutoRecoverEvent"
        }
      }
    },
    destroyed: {
      entry: ["stepError", "unmount"]
    },
    waitingPendingActions: {
      on: {
        ACTIONS_FINISHED: {
          target: "running_end_hooks",
          actions: "setActionsFinished"
        }
      }
    }
  }
};
var oa = (t, { createStepHooks: e, createHooksService: n, experience: r, get: i, experienceInstanceId: o }) => {
  const {
    virtualizeContent: s,
    createVnodeTree: a,
    wrapContent: c,
    applyOverridesToVnode: l
  } = i("vNodeHandlers"), { makeElementsAccessible: v } = i("accessibilityHandlers"), { applyOverrides: f, createOverrideCallback: u, clearOverrides: p } = Qu({
    applyOverridesToVnode: l
  }), h = u("style"), g = i("getWindowReference"), { onRender: E, onRenderReset: S } = i("createRenderListener")(), {
    render: y,
    unmount: b,
    setContainer: _,
    resetRender: w,
    getContainer: A,
    hasCustomContainer: O,
    getRoot: C
  } = Gf({
    experience: r,
    onRender: E,
    onRenderReset: S,
    wrapContent: c,
    getWindowReference: g
  }), {
    addHook: I,
    runStepBeginHooks: D,
    runStepPreRenderHooks: $,
    runStepPostRenderHooks: j,
    runStepEndHooks: q,
    runStepErrorHooks: Z,
    removeStepHooks: K,
    runStepContainerChangeHooks: rt
  } = e({
    step: t,
    overrideStyle: h
  }), ct = Ju({
    addHook: I
  }), V = Zu(
    {
      overrideStyle: h,
      getContainer: A
    },
    i
  ), ft = n(
    {
      overrideStyle: h,
      getContainer: A,
      getRoot: C
    },
    i
  ), tt = yu({
    getRoot: C,
    getWindowReference: g
  }), et = ju(i), Q = ia(i), gt = (W) => W.contentType === "text/html" ? s(Xf(Kf(W.content))) : a(W.content);
  return _r(
    {
      ...td,
      context: {
        id: `step-machine-${t.id}`,
        step: {
          ...t,
          /**
           * Even though we receive an step content as HTML
           * the first thing even before running the step is parsing it to a vnode tree
           *
           * The virtualizeContent lib, returns a vnode tree in the format that snabdom
           * understands. But it helps not only for rendering, but also to attach actions to an element for example,
           * since we use a tree traversal technique to find and match the element id with the actions callbacks.
           *
           */
          activeNodeIndex: 0,
          virtualizedContent: gt(t)
        },
        experience: r,
        blockedEvents: {},
        actionsRunning: false,
        experienceInstanceId: o,
        stopReason: null,
        stoppedCallbacks: []
      }
    },
    {
      actions: {
        // injecting action coming from step level
        setContent: Du,
        updateRootStyle: Hu,
        // injecting action coming from render
        unmount: b,
        setContainer: _,
        updateTheme: et,
        resetRender: w,
        // injecting action coming from hooks
        runStepBeginHooks: D,
        runStepPreRenderHooks: $,
        runStepPostRenderHooks: j,
        runStepEndHooks: q,
        runStepErrorHooks: Z,
        runStepContainerChangeHooks: rt,
        updateStepContext: $u,
        removeStepHooks: () => K(),
        clearOverrides: () => p(),
        setVirtualizedContent: Lu(
          gt
        ),
        // injecting action coming from overrides
        applyOverrides: f,
        // injecting actions coming from dom
        startThemeRemovalListener: zs,
        stopThemeRemovalListener: mu,
        removeCustomContainer: vu({ getRoot: C }),
        ensuresElementsAreAccessible: Fu(
          v
        ),
        notifyExperienceStarted: ku,
        notifyStepStopped: Mu,
        // core events
        ...Q.stepActions,
        blockEvent: Q.helpers.blockEvent,
        autoRecover: Uu,
        setActionsRunning: Bu,
        setActionsFinished: zu,
        // stop reason handling
        saveStopReason: Et({
          stopReason: (W, F) => F.reason
        }),
        addStoppedCallback: Et({
          stoppedCallbacks: (W, F) => F.onStopped ? [...W.stoppedCallbacks, F.onStopped] : W.stoppedCallbacks
        }),
        callStoppedCallbacks: (W) => W.stoppedCallbacks.forEach((F) => {
          try {
            F();
          } catch {
          }
        }),
        deferTransitionToEnd: Tr({ type: Ns }, { delay: 0 })
      },
      services: {
        // injecting services coming from step level
        runStepTraits: ct,
        // injecting services coming from render
        render: y,
        // injecting services coming from hooks
        hooksService: ft,
        // injecting services coming from steps
        actionsService: V,
        // injecting services coming from dom
        themeRemovalService: tt
      },
      guards: {
        hasCustomContainer: O,
        isAutoRecoverEvent: (W, F) => F.isAutoRecoverEvent,
        isEventEnabled: Q.helpers.isEventEnabled,
        didContentChanged: (W, F) => !wn(W.step.content, F.stepConfig.content),
        shouldOnlyReloadTraits: qu,
        shouldStepReload: (W, F) => !wn(W.step.traits, F.stepConfig.traits) || !wn(W.step.actions, F.stepConfig.actions) || !wn(W.experience.traits, F.experience.traits),
        didThemeChange: (W, F) => W.experience.theme !== F.experience.theme,
        isHooksDoneEventPostRenderType: (W, F) => F.hookType === Ls,
        isHooksDoneEventPreRenderType: (W, F) => F.hookType === Ds,
        isHooksDoneEventBeginType: (W, F) => F.hookType === wi,
        isHooksDoneEventErrorType: (W, F) => F.hookType === $s,
        isHooksDoneEventEndType: (W, F) => F.hookType === pr,
        hasPendingActions: (W) => W.actionsRunning,
        shouldFireStepCompletedEvent: (W, F) => F.hookType === pr && // Require that the step has been seen, otherwise it cannot be completed
        W.blockedEvents.STEP_SEEN && W.stopReason !== Ee.NAVIGATION && W.stopReason !== Ee.DISMISSED
      }
    }
  );
};
var ed = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => Et({
  stepMachines: ({ experience: r, experienceInstanceId: i }) => {
    const o = {
      experience: r,
      experienceInstanceId: i,
      createStepHooks: t,
      createHooksService: e,
      get: n
    };
    return r.steps.reduce((s, a) => (s[`${a.id}`] = bs(
      oa(a, o),
      `step-machine - ${a.id}`
    ), s), {});
  }
});
var nd = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => Et({
  stepMachines: ({ experience: r, stepMachines: i }, o) => {
    const s = {
      experience: r,
      createStepHooks: t,
      createHooksService: e,
      get: n
    }, a = r.steps.find(
      (c) => c.id === o.id
    );
    return a ? {
      ...i,
      [`${o.id}`]: bs(
        oa(a, s),
        `step-machine - ${o.id}`
      )
    } : i;
  }
});
var In = (t) => (e, { id: n, ...r }) => {
  e.stepMachines[n]?.send({
    ...r,
    type: t
  });
};
var rd = In(_s);
var id = (t, e) => {
  const n = t.stepMachines[e.id];
  n && (n.state.done && e.onStopped ? e.onStopped() : n.send({
    ...e,
    type: bi
  }));
};
var od = In(Ts);
var sd = In(
  Rs
);
var ad = In(Vl);
var cd = In(Cs);
var ld = (t, e) => {
  Object.values(t.stepMachines).forEach((n) => {
    n.send({
      type: bi,
      reason: e.reason
    });
  });
};
var To = (t = [], e = []) => {
  const n = new Map(
    t.map((a) => [a.id, a])
  ), r = new Map(e.map((a) => [a.id, a])), i = e.filter((a) => {
    const c = n.get(a.id);
    return !c || c.type !== a.type;
  }), o = t.filter((a) => {
    const c = r.get(a.id);
    return !c || c.type !== a.type;
  }), s = e.filter((a) => {
    const c = n.get(a.id);
    if (!c || c.type !== a.type) return false;
    const l = c.config || {}, v = a.config || {};
    return !wn(l, v);
  });
  return {
    addedTraits: i,
    removedTraits: o,
    changedTraits: s
  };
};
var ud = Et((t, e) => {
  const n = To(
    t.experience.traits,
    e.experience.traits
  );
  return Object.entries(t.stepMachines).forEach(([r, i]) => {
    const o = t.experience.steps.find(
      (c) => c.id === r
    ), s = e.experience.steps.find((c) => c.id === r);
    if (!o || !s)
      return;
    const a = To(
      o.traits,
      s.traits
    );
    i.send({
      type: Xl,
      stepConfig: s,
      experience: e.experience,
      changedExperienceTraits: n,
      changedStepTraits: a
    });
  }), {
    experience: e.experience
  };
});
var fd = (t) => {
  Object.values(t.stepMachines).forEach((e) => {
    e.send({
      type: _i
    });
  });
};
var dd = Et({
  experienceInstanceId: () => Hl()
});
var pd = Et({
  stepMachines: (t, e) => Object.entries(t.stepMachines).reduce(
    (n, [r, i]) => (r !== e.id && (n[r] = i), n),
    {}
  )
});
var hd = Et({
  experience: ({ experience: t }, e) => {
    const n = t.steps.findIndex((r) => r.id === e.id);
    return n === -1 ? t : nr(
      t,
      `steps.${n}.traits`,
      (r) => r.filter(({ once: i = false }) => !i)
    );
  }
});
var vd = ({ addHook: t }) => ({ experience: e }) => (n) => {
  try {
    e.traits.forEach(
      (r) => Ws({
        getTrait: Gs,
        trait: r,
        addHook: (i, o) => {
          t(i, { callback: o, traitId: r.id });
        },
        registerAction: (i, o) => ce(
          `${e.id}.${r.type}.${i}`,
          o
        )
      })
    ), n(Ti);
  } catch {
    n(Fs);
  }
};
var Ro = (t, e) => (n, { callback: r, traitId: i }) => {
  const o = t();
  o.get(n) || o.set(n, []);
  const s = o.get(n);
  e(n, [...s, { callback: r, traitId: i }]);
};
var be = (t, e) => Tr(
  (n, r) => {
    let i = e;
    return r.changedExperienceTraits && (i = {
      ...i,
      onlyExperienceTraits: r.changedExperienceTraits.changedTraits.filter((o) => o.id != null).map(({ id: o }) => o)
    }), r.changedStepTraits && (i = {
      ...i,
      onlyStepTraits: r.changedStepTraits.changedTraits.filter((o) => o.id != null).map(({ id: o }) => o)
    }), {
      type: Ms,
      hookType: t,
      experience: n.experience,
      step: n.step,
      ...i
    };
  },
  { to: "hooksService" }
);
var gd = be(Ql);
var yd = be(tu);
var md = be(wi);
var Ed = be(Ds);
var Sd = be(Ls);
var bd = be(pr);
var wd = rl(
  (t, e) => be($s, { errorEvent: e })
);
var xd = be(ks);
var _d = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (i = {}, o) => () => (
    // eslint-disable-next-line unicorn/consistent-function-scoping
    ((s, a) => {
      a(async ({ type: c, hookType: l, experience: v, step: f, ...u }) => {
        if (c !== Ms) return;
        let p = {
          experience: v,
          step: f,
          callback: s,
          get: o,
          getContainer: i.getContainer
        };
        [wi, ks, pr].includes(l) && (p = { ...p, ...i });
        const h = ({ callback: E, trait: S }) => {
          const y = {
            ...Ci({
              ...p,
              getAction: re
            }),
            getTraitConfig: () => S.config
          };
          return {
            callback: E,
            context: y
          };
        }, g = (t.get(l) ?? []).filter(
          ({ traitId: E }) => !u.onlyExperienceTraits || u.onlyExperienceTraits && u.onlyExperienceTraits.includes(E)
        ).map(
          (E) => h({
            ...E,
            trait: (v.traits ?? []).find(
              (S) => S.id === E.traitId
            )
          })
        );
        try {
          if (await _o(g), f) {
            const E = (e.get(f.id)?.get(l) ?? []).filter(
              ({ traitId: S }) => !u.onlyStepTraits || u.onlyStepTraits && u.onlyStepTraits.includes(S)
            ).map(
              (S) => h({
                ...S,
                trait: (f.traits ?? []).find(
                  (y) => y.id === S.traitId
                )
              })
            );
            await _o(E);
          }
          s({ type: eu, hookType: l, ...u });
        } catch {
          s("RUN_HOOKS_ERROR");
        }
      });
    })
  ), r = ({ step: i }) => (e.get(i.id) || e.set(i.id, /* @__PURE__ */ new Map()), {
    addHook: Ro(
      () => e.get(i.id),
      (o, s) => e.get(i.id).set(o, s)
    ),
    removeStepHooks: () => e.set(i.id, /* @__PURE__ */ new Map()),
    runStepBeginHooks: md,
    runStepPreRenderHooks: Ed,
    runStepPostRenderHooks: Sd,
    runStepEndHooks: bd,
    runStepErrorHooks: wd,
    runStepContainerChangeHooks: xd
  });
  return {
    addHook: Ro(
      () => t,
      (i, o) => t.set(i, o)
    ),
    createStepHooks: r,
    createHooksService: n,
    runExperienceBeginHooks: gd,
    runExperienceEndHooks: yd
  };
};
var Td = {
  id: "experience",
  initial: "idle",
  invoke: [
    {
      src: "hooksService",
      id: "hooksService"
    },
    {
      id: "themeRemovalService",
      src: "globalThemeRemovalService"
    }
  ],
  on: {
    RUN_HOOKS_ERROR: "destroyed",
    EXPERIENCE_STARTED: {
      target: "",
      actions: ["experienceStarted", "blockEvent"],
      cond: "isEventEnabled"
    },
    SHOW: "running-traits"
  },
  states: {
    idle: {
      on: {
        SHOW: [
          {
            target: "running-traits",
            actions: ["updateExperienceInstanceId"]
          },
          {
            target: "destroyed"
          }
        ]
      }
    },
    "running-traits": {
      invoke: {
        src: "runGlobalExperienceTraits"
      },
      on: {
        RUN_TRAITS_ERROR: "destroyed",
        RUN_TRAITS_DONE: "rendering-steps"
      }
    },
    "rendering-steps": {
      on: {
        STOP_EXPERIENCE: [
          {
            target: "end",
            actions: ["experienceCompleted", "stopSteps"],
            cond: "shouldFireCompletedEvent"
          },
          {
            target: "end",
            actions: ["stopSteps"]
          }
        ],
        START_STEP: [
          {
            target: "",
            cond: "doesStepInstanceExist",
            actions: "startStep"
          },
          {
            target: "",
            actions: ["startStepMachine", "startStep"]
          }
        ],
        STOP_STEP: {
          target: "",
          actions: "stopStep"
        },
        UPDATE_STEP: {
          target: "",
          actions: "updateStep"
        },
        SET_STEP_CONTAINER_TARGET: {
          target: "",
          actions: "setStepContainerTarget"
        },
        RECOVER_STEP: {
          target: "",
          actions: "recoverStep"
        },
        GLOBAL_CONTAINER_REMOVED: {
          target: "",
          actions: [
            "createGlobalThemeComponent",
            "startThemeRemovalListener",
            "notifyStepsContainerRemoved"
          ]
        },
        UPDATE_STEP_CONTENT: {
          target: "",
          actions: "updateStepContent"
        },
        SHOW: {
          target: "",
          actions: ["reloadSteps"]
        },
        STEP_STOPPED: [
          {
            target: "end-final",
            cond: "areAllStepsStopped",
            actions: [
              "experienceCompleted",
              "removeGlobalThemeComponent",
              "runExperienceEndHooks"
            ]
          },
          {
            target: "",
            actions: ["cleanStepMachines", "cleanRunOnceTraits"]
          }
        ]
      },
      entry: [
        "createGlobalThemeComponent",
        "startStepMachines",
        "runExperienceBeginHooks",
        "startThemeRemovalListener"
      ]
    },
    end: {
      entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
      on: {
        [As]: { target: "end-final", cond: "areAllStepsStopped" }
      }
    },
    "end-final": {
      final: true
    },
    destroyed: {
      entry: "experienceError",
      type: "final"
    }
  }
};
var Rd = (t, e) => {
  const {
    addHook: n,
    createStepHooks: r,
    createHooksService: i,
    runExperienceBeginHooks: o,
    runExperienceEndHooks: s
  } = _d(), a = i({}, e), c = ed({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), l = nd({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), v = vd({
    addHook: n
  }), f = ia(e), u = du(e), p = pu(e), h = gu(e);
  return _r(
    {
      ...Td,
      context: {
        experience: t,
        blockedEvents: {},
        experienceInstanceId: null
      }
    },
    {
      actions: {
        // experience
        startStep: rd,
        stopStep: id,
        updateStep: od,
        setStepContainerTarget: sd,
        recoverStep: ad,
        startStepMachines: c,
        stopSteps: ld,
        notifyStepsContainerRemoved: fd,
        updateStepContent: cd,
        reloadSteps: ud,
        updateExperienceInstanceId: dd,
        cleanStepMachines: pd,
        startStepMachine: l,
        // hooks
        runExperienceBeginHooks: o,
        runExperienceEndHooks: s,
        // dom
        createGlobalThemeComponent: u,
        removeGlobalThemeComponent: p,
        startThemeRemovalListener: zs,
        // traits
        cleanRunOnceTraits: hd,
        // core events
        ...f.experienceActions,
        blockEvent: f.helpers.blockEvent
      },
      services: {
        // experiences
        runGlobalExperienceTraits: v,
        // hooks
        hooksService: a,
        // dom
        globalThemeRemovalService: h
      },
      guards: {
        isEventEnabled: f.helpers.isEventEnabled,
        areAllStepsStopped: (g) => Object.values(g.stepMachines).every(
          (E) => E.state.done
        ),
        doesStepInstanceExist: (g, E) => g.stepMachines?.[E.id] !== void 0,
        shouldFireCompletedEvent: (g, E) => E.reason !== Ee.NAVIGATION && E.reason !== Ee.DISMISSED
      }
    }
  );
};
var sa = Ys(
  [
    Qs,
    na,
    ra,
    ea,
    Js
  ],
  void 0,
  {
    experimental: {
      fragments: true
    }
  }
);
function Cd(t) {
  const n = (t.ownerDocument || document).createElement("div");
  return t.append(n), sa(n, ae("div"));
}
var Od = () => {
  let t = null;
  return {
    onRender: (e, n) => {
      !t && !e || (t || (t = Cd(e)), t = sa(t, n));
    },
    onRenderReset: () => {
      t = null;
    }
  };
};
var Kn = {};
var Ur;
var Co;
function Ad() {
  return Co || (Co = 1, Ur = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    menuitem: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
  }), Ur;
}
var Br;
var Oo;
function Nd() {
  if (Oo) return Br;
  Oo = 1;
  var t = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, e = Ad();
  return Br = function(n) {
    var r = 0, i, o = true, s = {
      type: "tag",
      name: "",
      voidElement: false,
      attrs: {},
      children: []
    };
    return n.replace(t, function(a) {
      if (a === "=") {
        o = true, r++;
        return;
      }
      o ? r === 0 ? ((e[a] || n.charAt(n.length - 2) === "/") && (s.voidElement = true), s.name = a) : (s.attrs[i] = a.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (s.attrs[i] = i), i = a), r++, o = false;
    }), s;
  }, Br;
}
var zr;
var Ao;
function Pd() {
  if (Ao) return zr;
  Ao = 1;
  var t = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, e = Nd(), n = Object.create ? /* @__PURE__ */ Object.create(null) : {};
  function r(i, o, s, a, c) {
    var l = o.indexOf("<", a), v = o.slice(a, l === -1 ? void 0 : l);
    /^\s*$/.test(v) && (v = " "), (!c && l > -1 && s + i.length >= 0 || v !== " ") && i.push({
      type: "text",
      content: v
    });
  }
  return zr = function(o, s) {
    s || (s = {}), s.components || (s.components = n);
    var a = [], c, l = -1, v = [], f = {}, u = false;
    return o.replace(t, function(p, h) {
      if (u) {
        if (p !== "</" + c.name + ">")
          return;
        u = false;
      }
      var g = p.charAt(1) !== "/", E = p.indexOf("<!--") === 0, S = h + p.length, y = o.charAt(S), b;
      g && !E && (l++, c = e(p), c.type === "tag" && s.components[c.name] && (c.type = "component", u = true), !c.voidElement && !u && y && y !== "<" && r(c.children, o, l, S, s.ignoreWhitespace), f[c.tagName] = c, l === 0 && a.push(c), b = v[l - 1], b && b.children.push(c), v[l] = c), (E || !g || c.voidElement) && (E || l--, !u && y !== "<" && y && (b = l === -1 ? a : v[l].children, r(b, o, l, S, s.ignoreWhitespace)));
    }), !a.length && o.length && r(a, o, 0, 0, s.ignoreWhitespace), a;
  }, zr;
}
var aa = /* @__PURE__ */ Tl(Vf);
var Fe = {};
var No;
function Id() {
  if (No) return Fe;
  No = 1, Object.defineProperty(Fe, "__esModule", {
    value: true
  }), Fe.createTextVNode = e, Fe.transformName = n, Fe.unescapeEntities = o;
  var t = aa;
  function e(s, a) {
    return (0, t.vnode)(void 0, void 0, void 0, o(s, a));
  }
  function n(s) {
    s = s.replace(/-(\w)/g, function(l, v) {
      return v.toUpperCase();
    });
    var a = s.charAt(0).toLowerCase();
    return "" + a + s.substring(1);
  }
  var r = new RegExp("&[a-z0-9#]+;", "gi"), i = null;
  function o(s, a) {
    return i || (i = a.createElement("div")), s.replace(r, function(c) {
      return i.innerHTML = c, i.textContent;
    });
  }
  return Fe;
}
var Po;
function Dd() {
  if (Po) return Kn;
  Po = 1, Object.defineProperty(Kn, "__esModule", {
    value: true
  }), Kn.default = function(f) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = u.context || document;
    if (!f)
      return null;
    var h = [], g = s((0, e.default)(f), h, p), E = void 0;
    return g ? g.length === 1 ? E = g[0] : E = g : E = a({ type: "text", content: f }, h, p), u.hooks && u.hooks.create && h.forEach(function(S) {
      u.hooks.create(S);
    }), E;
  };
  var t = Pd(), e = i(t), n = aa, r = Id();
  function i(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function o(f, u, p) {
    return u in f ? Object.defineProperty(f, u, { value: p, enumerable: true, configurable: true, writable: true }) : f[u] = p, f;
  }
  function s(f, u, p) {
    if (f instanceof Array && f.length > 0)
      return f.map(function(h) {
        return a(h, u, p);
      });
  }
  function a(f, u, p) {
    var h = void 0;
    return f.type === "text" ? h = (0, r.createTextVNode)(f.content, p) : h = (0, n.h)(f.name, c(f, p), s(f.children, u, p)), u.push(h), h;
  }
  function c(f, u) {
    var p = {};
    if (!f.attrs)
      return p;
    var h = Object.keys(f.attrs).reduce(function(S, y) {
      if (y !== "style" && y !== "class") {
        var b = (0, r.unescapeEntities)(f.attrs[y], u);
        S ? S[y] = b : S = o({}, y, b);
      }
      return S;
    }, null);
    h && (p.attrs = h);
    var g = l(f);
    g && (p.style = g);
    var E = v(f);
    return E && (p.class = E), p;
  }
  function l(f) {
    try {
      return f.attrs.style.split(";").reduce(function(u, p) {
        var h = p.split(":"), g = (0, r.transformName)(h[0].trim());
        if (g) {
          var E = h[1].replace("!important", "").trim();
          u ? u[g] = E : u = o({}, g, E);
        }
        return u;
      }, null);
    } catch {
      return null;
    }
  }
  function v(f) {
    try {
      return f.attrs.class.split(" ").reduce(function(u, p) {
        return p = p.trim(), p && (u ? u[p] = true : u = o({}, p, true)), u;
      }, null);
    } catch {
      return null;
    }
  }
  return Kn;
}
var qr;
var Io;
function Ld() {
  return Io || (Io = 1, qr = Dd()), qr;
}
var $d = Ld();
var kd = /* @__PURE__ */ Pe($d);
var ca = "data-interaction-style";
var Md = (t) => t.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`);
var la = (t) => t.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, '"');
var ua = ({ nodeId: t, interactionId: e, state: n }) => {
  const r = e ? `[${ca}="${e}"]` : `#${t}`;
  return Object.keys(n).map((i) => `${r}:${i} {
        ${Object.entries(n[i]).map(([o, s]) => {
    const a = la(String(s));
    return `${Md(
      o
    )}:${a} !important`;
  }).join(";")}
      }`).join(" ");
};
var fa = (t) => t.data && t.data.attrs ? t.data.attrs.id : void 0;
var da = (t, e) => Object.keys(e).reduce(
  (n, r) => ({
    ...n,
    [r]: {
      ...n[r],
      ...e[r]
    }
  }),
  t.data || {}
);
var Ni = (t, e) => {
  t && (e(t), t.children && t.children.forEach((n) => Ni(n, e)));
};
var pa = (t) => {
  if (typeof t == "string")
    return la(t);
  if (t == null)
    return ui([]);
  const {
    is: e = "div",
    children: n = [],
    style: r,
    behaviors: i,
    ...o
  } = t.props, { state: s, ...a } = r ?? {}, c = t.props.id, l = t.props[ca], v = {
    ...Object.keys(a).length > 0 && { style: a },
    ...Object.keys(o).length > 0 && { attrs: o }
  }, f = ae(e, v, n.map(pa));
  return s ? ui([
    ae("style", ua({ nodeId: c, interactionId: l, state: s })),
    f
  ]) : f;
};
var ha = (t, e) => {
  const n = fa(t), r = e(n) ?? {};
  return {
    ...t,
    data: da(t, r),
    children: t.children?.map(
      (i) => ha(i, e)
    )
  };
};
var Hd = ({ step: t }) => {
  const e = Ie(t.id), n = ae(
    "div",
    {
      attrs: {
        [js]: e
      },
      style: {
        // this solution can adding extra height to the page, so we need a way to avoid this scenario
        // display: 'inline-block',
        // position: 'relative',
        width: "100%",
        display: "contents"
      }
    },
    [t.virtualizedContent]
  );
  return {
    step: {
      ...t,
      virtualizedContent: n
    }
  };
};
var jd = (t, e) => (t.data = {
  ...t.data,
  on: e.on,
  hook: e.hook
}, t);
var Fd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyOverridesToVnode: ha,
  createStyleState: ua,
  createVnodeTree: pa,
  findId: fa,
  injectHandlers: jd,
  mergeVnodeData: da,
  traverseTree: Ni,
  virtualizeContent: kd,
  wrapContent: Hd
}, Symbol.toStringTag, { value: "Module" }));
var Do = (t, e) => e.includes(t.data?.attrs?.id) && typeof t.data?.attrs?.tabindex != "string" && typeof t.data?.attrs?.tabIndex != "number";
var Ud = (t) => {
  t.data.attrs.tabindex = 0, t.sel = "button", t.data.style = {
    ...t.data.style,
    border: t.data?.style?.border ?? "none",
    ...t?.children?.length > 0 && {
      backgroundColor: t.data?.style?.backgroundColor ?? "transparent"
    }
  };
};
var Bd = ({ virtualizedContent: t, index: e }, { interactiveEls: n = [], focusableEls: r = [] }) => (Ni(t, (i) => {
  Do(i, n) ? Ud(i) : Do(i, r) && (i.data.attrs = {
    ...i.data.attrs,
    tabindex: 0,
    role: "dialog",
    "aria-labelledby": `content-${e}`,
    "aria-describedby": `content-${e}`
  }), i.data?.class?.canvas && (i.data.attrs = {
    ...i.data.attrs,
    id: `content-${e}`
  });
}), t);
var zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  makeElementsAccessible: Bd
}, Symbol.toStringTag, { value: "Module" }));
var qd = "@appcues/close";
var Lo = {
  markComplete: true
};
var Vd = ({ markComplete: t = Lo.markComplete } = Lo, { stopExperience: e, step: n }) => {
  t ? e() : n.dismissExperience();
};
ce(qd, Vd);
var Wd = "@appcues/redirectTo";
function Gd(t, e) {
  if (/^https?:\/\//i.test(e))
    return e;
  try {
    return new URL(e, t.location.origin).href;
  } catch {
    return e;
  }
}
var Kd = ({ url: t = "", openInNewWindow: e = false } = {}, { reportError: n, getWindowReference: r }) => {
  if (!t) {
    n("Can't redirect to undefined URL");
    return;
  }
  const i = r(), o = Gd(i, t);
  i.open(o, e ? "_blank" : "_self", "noopener");
};
ce(Wd, Kd);
var Xd = "@appcues/trackEvent";
var Yd = ({ name: t, properties: e = {} }, { sendCustomEvent: n }) => {
  n(t, e);
};
ce(Xd, Yd);
var Zd = "@appcues/triggerFlow";
var Jd = ({ flowId: t, url: e, prefetch: n = false } = {}, { showFlow: r }) => {
  r({ flowId: t, url: e, prefetch: n });
};
ce(Zd, Jd);
var Qd = (t) => Object.keys(t).length === 0;
var tp = (t) => t === "date.now" ? Date.now() : null;
var ep = (t) => typeof t == "string" && t.startsWith("{") && t.endsWith("}");
var np = (t) => Object.entries(t).reduce((e, [n, r]) => {
  if (ep(r)) {
    const i = r.slice(1, -1), o = tp(i);
    return { ...e, [n]: o ?? r };
  }
  return { ...e, [n]: r };
}, {});
var rp = "@appcues/setUserProperties";
var ip = (t, { updateUserProfile: e }) => {
  if (!Qd(t)) {
    const n = np(t);
    e(n);
  }
};
ce(rp, ip);
var op = "@appcues/toggleActions";
var sp = ({ actions: t = [], target: e } = {}, n) => {
  const r = n.querySelector(e.selector);
  r.length !== 0 && t.forEach((i) => {
    const o = `toggleActions_${i.id}`, s = n.getAction(i.type), [a] = r, c = !a.getAttribute(o);
    s && c && (s(i.config, n), a.setAttribute(o, true)), c || a.removeAttribute(o);
  });
};
ce(op, sp);
var ap = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g;
var $o = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/;
var Ne = class _Ne {
  // eslint-disable-line consistent-this
  /**
   * @param {string} locale
   */
  constructor(e) {
    if (typeof e != "string")
      throw new TypeError("A string argument is expected");
    if (!$o.test(e))
      throw new RangeError("A proper locale must be provided");
    this._locale = e;
  }
  // Private functions - star
  /**
   * @param {null|undefined|string} [str]
   * @returns {null|undefined|string}
   */
  static _escapeRegExpPattern(e) {
    return typeof e != "string" ? e : e.replace(ap, "\\$1");
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toLowerCase(e, n) {
    return typeof e != "string" ? n && e : e.toLowerCase();
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toUpperCase(e, n) {
    return typeof e != "string" ? n && e : e.toUpperCase();
  }
  /**
   * @param {string|null} [str]
   * @param {string|null|string[]|boolean} [delimiter]
   * @param {boolean} [reserveReturnValue]
   */
  static _trim(e, n, r) {
    const i = [];
    let o;
    const s = function(c) {
      i.push("^" + c + "+|" + c + "+$");
    };
    if (typeof n == "boolean" && (r = n, n = null), typeof e != "string")
      return r ? e : void 0;
    if (Array.isArray(n) && n.map((c) => {
      const l = this._escapeRegExpPattern(c);
      s(l);
    }), typeof n == "string") {
      const c = this._escapeRegExpPattern(n);
      s(c);
    }
    n || s("\\s");
    const a = "(" + i.join("|") + ")";
    for (o = new RegExp(a, "g"); e.match(o); )
      e = e.replace(o, "");
    return e;
  }
  /**
   * @typedef {{
   *   lang: string,
   *   script: string|undefined,
   *   countryCode: string|undefined
   * }} LocaleInfo
   */
  /**
   * @param {string|null} [strLocale]
   * @returns {undefined|LocaleInfo}
   */
  static _parseLocale(e) {
    if (typeof e != "string")
      return;
    const n = $o.exec(e);
    let r, i, o;
    if (!e || !n)
      return;
    const s = this._trim(n[2], ["-", "_"]), a = this._trim(n[3], ["-", "_"]);
    return r = /** @type {string} */
    this._toLowerCase(n[1]), i = this._toLowerCase(s) || i, o = this._toUpperCase(a) || o, {
      lang: r,
      script: i,
      countryCode: o
    };
  }
  // Private functions - End
  _isRtlLang() {
    const { lang: e, script: n } = (
      /** @type {LocaleInfo} */
      _Ne._parseLocale(this._locale)
    );
    return n ? _Ne._RTL_SCRIPTS.indexOf(n) >= 0 : _Ne._BIDI_RTL_LANGS.indexOf(e) >= 0;
  }
  // Public functions - star
  get textInfo() {
    return { direction: this._isRtlLang() ? "rtl" : "ltr" };
  }
  // Public functions - End
};
Ne._RTL_SCRIPTS = [
  "adlm",
  "arab",
  "armi",
  "avst",
  "chrs",
  "cprt",
  "elym",
  "hatr",
  "hebr",
  "hung",
  "khar",
  "lydi",
  "mand",
  "mani",
  "mend",
  "merc",
  "mero",
  "narb",
  "nbat",
  "nkoo",
  "orkh",
  "ougr",
  "palm",
  "phli",
  "phlp",
  "phnx",
  "prti",
  "rohg",
  "samr",
  "sarb",
  "sogd",
  "sogo",
  "syrc",
  "thaa",
  "yezi"
];
Ne._BIDI_RTL_LANGS = [
  // Const BIDI_RTL_LANGS Array
  // BIDI_RTL_LANGS ref: http://en.wikipedia.org/wiki/Right-to-left
  // Table of scripts in Unicode: https://en.wikipedia.org/wiki/Script_(Unicode)
  "ae",
  // Avestan
  "aeb",
  // Tunisian Arabic
  "ajt",
  // Tunisian Arabic (old)
  "apc",
  // Levantine Arabic
  "apd",
  // Sudanese Arabic
  "ar",
  // 'العربية', Arabic
  "ara",
  // Arabic
  "arb",
  // Standard Arabic
  "arc",
  // Aramaic
  "arq",
  // Algerian Arabic
  "ars",
  // Najdi Arabic
  "ary",
  // Moroccan Arabic
  "arz",
  // Egyptian Arabic
  "ave",
  // Avestan
  "avl",
  // Eastern Egyptian Bedawi Arabic
  "bal",
  // Baluchi
  "bcc",
  // 'بلوچی مکرانی', Southern Balochi
  "bej",
  // Beja; Bedawiyet
  "bft",
  // Balti
  "bgn",
  // Western Balochi
  "bqi",
  // 'بختياري', Bakthiari
  "brh",
  // Brahui
  "cja",
  // Cham, Western
  "ckb",
  // 'Soranî / کوردی', Sorani
  "cld",
  // Chaldean Neo-Aramaic
  "dcc",
  // Deccan
  "dgl",
  // Andaandi
  "div",
  // Divehi
  "drw",
  // Darwazi (old)
  "dv",
  // Dhivehi
  "fa",
  // 'فارسی', Persian
  "fas",
  // Persian
  "fia",
  // Nobiin
  "fub",
  // Fulfulde (Adamawa)
  "gbz",
  // Dari, Zoroastrian
  "gjk",
  // Koli, Kachi
  "gju",
  // Gujari
  "glk",
  // 'گیلکی', Gilaki
  "grc",
  // Greek, Ancient (to 1453)
  "gwc",
  // Kalami
  "gwt",
  // Gawar-Bati
  "haz",
  // Hazaragi
  "he",
  // 'עברית', Hebrew
  "heb",
  // Hebrew
  "hnd",
  // Hindko, Southern
  "hno",
  // Hindko, Northern
  "iw",
  // Hebrew (old)
  "ji",
  // Yiddish (old)
  "kas",
  // Kashmiri
  "kby",
  // Kanuri, Manga
  "khw",
  // Khowar
  "ks",
  // Kashmiri
  "kvx",
  // Koli, Parkari
  "kxp",
  // Koli, Wadiyara
  "kzh",
  // Kenuzi-Dongola (old)
  "lad",
  // Ladino
  "lah",
  // Lahnda
  "lki",
  // Laki
  "lrc",
  // Luri, Northern
  "luz",
  // Luri, Southern
  "mde",
  // Maba (Chad)
  "mfa",
  // Malay, Pattani
  "mki",
  // Dhatki
  "mvy",
  // Kohistani, Indus
  "myz",
  // Mandaic, Classical
  "mzn",
  // 'مازِرونی', Mazanderani
  "nqo",
  // N'Ko
  "oru",
  // Ormuri
  "ota",
  // Turkish, Ottoman (1500–1928)
  "otk",
  // Turkish, Old
  "oui",
  // Uighur, Old
  "pal",
  // Pahlavi
  "pbu",
  // Pashto, Northern
  "per",
  // Persian
  "pes",
  // Western Farsi
  "phl",
  // Phalura
  "phn",
  // Phoenician
  "pnb",
  // 'پنجابی', Western Punjabi
  "pra",
  // Prakrit languages
  "prd",
  // Dari (Persian)
  "prs",
  // 'دری', Darī
  "ps",
  // 'پښتو', Pashto,
  "pus",
  // Pushto
  "rhg",
  // Rohingya
  "rmt",
  // Domari
  "scl",
  // Shina
  "sd",
  // 'سنڌي', Sindhi
  "sdh",
  // Kurdish, Southern
  "shu",
  // Arabic (Chadian)
  "skr",
  // Saraiki
  "smp",
  // Samaritan
  "snd",
  // Sindhi
  "sog",
  // Sogdian
  "swb",
  // Comorian
  "syr",
  // Syriac
  "tnf",
  // Tangshewi (old)
  "trw",
  // Torwali
  "ug",
  // 'Uyghurche / ئۇيغۇرچە', Uyghur
  "uig",
  // Uighur
  "ur",
  // 'اردو', Urdu
  "urd",
  // Urdu
  "wni",
  // Comorian, Ndzwani
  "xco",
  // Chorasmian
  "xld",
  // Lydian
  "xmn",
  // Manichaean Middle Persian
  "xmr",
  // Meroitic
  "xna",
  // North Arabian, Ancient
  "xpr",
  // Parthian
  "xsa",
  // Sabaean
  "ydd",
  // Yiddish, Eastern
  "yi",
  // 'ייִדיש', Yiddish
  "yid",
  // Yiddish
  "zdj"
  // Comorian, Ngazidja
];
var cp = "@appcues/content-direction";
function lp(t) {
  try {
    return new Ne(t).textInfo;
  } catch {
    return { direction: "ltr" };
  }
}
var ko = ({ updateRootStyle: t, getTraitConfig: e }) => {
  const n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = e(), o = lp(r);
  t(
    {
      direction: i ?? o.direction
    },
    { forceUpdate: true }
  );
};
var up = ({ addHook: t }) => {
  t("step.begin", ko), t("step.container_change", ko);
};
bt(cp, up);
var va = ["top", "right", "bottom", "left"];
var Mo = ["start", "end"];
var Ho = /* @__PURE__ */ va.reduce((t, e) => t.concat(e, e + "-" + Mo[0], e + "-" + Mo[1]), []);
var Cn = Math.min;
var qe = Math.max;
var vr = Math.round;
var Kt = (t) => ({
  x: t,
  y: t
});
var fp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var dp = {
  start: "end",
  end: "start"
};
function di(t, e, n) {
  return qe(t, Cn(e, n));
}
function en(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function nn(t) {
  return t.split("-")[0];
}
function oe(t) {
  return t.split("-")[1];
}
function ga(t) {
  return t === "x" ? "y" : "x";
}
function Pi(t) {
  return t === "y" ? "height" : "width";
}
var pp = /* @__PURE__ */ new Set(["top", "bottom"]);
function Cr(t) {
  return pp.has(nn(t)) ? "y" : "x";
}
function Ii(t) {
  return ga(Cr(t));
}
function hp(t, e, n) {
  n === void 0 && (n = false);
  const r = oe(t), i = Ii(t), o = Pi(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = jo(s)), [s, jo(s)];
}
function vp(t) {
  return t.replace(/start|end/g, (e) => dp[e]);
}
function jo(t) {
  return t.replace(/left|right|bottom|top/g, (e) => fp[e]);
}
function gp(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ya(t) {
  return typeof t != "number" ? gp(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function gr(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Fo(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = Cr(e), s = Ii(e), a = Pi(s), c = nn(e), l = o === "y", v = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, u = r[a] / 2 - i[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: v,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (oe(e)) {
    case "start":
      p[s] -= u * (n && l ? -1 : 1);
      break;
    case "end":
      p[s] += u * (n && l ? -1 : 1);
      break;
  }
  return p;
}
var yp = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: v,
    y: f
  } = Fo(l, r, c), u = r, p = {}, h = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: E,
      fn: S
    } = a[g], {
      x: y,
      y: b,
      data: _,
      reset: w
    } = await S({
      x: v,
      y: f,
      initialPlacement: r,
      placement: u,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    v = y ?? v, f = b ?? f, p = {
      ...p,
      [E]: {
        ...p[E],
        ..._
      }
    }, w && h <= 50 && (h++, typeof w == "object" && (w.placement && (u = w.placement), w.rects && (l = w.rects === true ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : w.rects), {
      x: v,
      y: f
    } = Fo(l, u, c)), g = -1);
  }
  return {
    x: v,
    y: f,
    placement: u,
    strategy: i,
    middlewareData: p
  };
};
async function yr(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: f = "floating",
    altBoundary: u = false,
    padding: p = 0
  } = en(e, t), h = ya(p), E = a[u ? f === "floating" ? "reference" : "floating" : f], S = gr(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(E))) == null || n ? E : E.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: v,
    strategy: c
  })), y = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = gr(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: b,
    strategy: c
  }) : y);
  return {
    top: (S.top - w.top + h.top) / _.y,
    bottom: (w.bottom - S.bottom + h.bottom) / _.y,
    left: (S.left - w.left + h.left) / _.x,
    right: (w.right - S.right + h.right) / _.x
  };
}
var mp = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = e, {
      element: l,
      padding: v = 0
    } = en(t, e) || {};
    if (l == null)
      return {};
    const f = ya(v), u = {
      x: n,
      y: r
    }, p = Ii(i), h = Pi(p), g = await s.getDimensions(l), E = p === "y", S = E ? "top" : "left", y = E ? "bottom" : "right", b = E ? "clientHeight" : "clientWidth", _ = o.reference[h] + o.reference[p] - u[p] - o.floating[h], w = u[p] - o.reference[p], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let O = A ? A[b] : 0;
    (!O || !await (s.isElement == null ? void 0 : s.isElement(A))) && (O = a.floating[b] || o.floating[h]);
    const C = _ / 2 - w / 2, I = O / 2 - g[h] / 2 - 1, D = Cn(f[S], I), $ = Cn(f[y], I), j = D, q = O - g[h] - $, Z = O / 2 - g[h] / 2 + C, K = di(j, Z, q), rt = !c.arrow && oe(i) != null && Z !== K && o.reference[h] / 2 - (Z < j ? D : $) - g[h] / 2 < 0, ct = rt ? Z < j ? Z - j : Z - q : 0;
    return {
      [p]: u[p] + ct,
      data: {
        [p]: K,
        centerOffset: Z - K - ct,
        ...rt && {
          alignmentOffset: ct
        }
      },
      reset: rt
    };
  }
});
function Ep(t, e, n) {
  return (t ? [...n.filter((i) => oe(i) === t), ...n.filter((i) => oe(i) !== t)] : n.filter((i) => nn(i) === i)).filter((i) => t ? oe(i) === t || (e ? vp(i) !== i : false) : true);
}
var Sp = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var n, r, i;
      const {
        rects: o,
        middlewareData: s,
        placement: a,
        platform: c,
        elements: l
      } = e, {
        crossAxis: v = false,
        alignment: f,
        allowedPlacements: u = Ho,
        autoAlignment: p = true,
        ...h
      } = en(t, e), g = f !== void 0 || u === Ho ? Ep(f || null, p, u) : u, E = await yr(e, h), S = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, y = g[S];
      if (y == null)
        return {};
      const b = hp(y, o, await (c.isRTL == null ? void 0 : c.isRTL(l.floating)));
      if (a !== y)
        return {
          reset: {
            placement: g[0]
          }
        };
      const _ = [E[nn(y)], E[b[0]], E[b[1]]], w = [...((r = s.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: y,
        overflows: _
      }], A = g[S + 1];
      if (A)
        return {
          data: {
            index: S + 1,
            overflows: w
          },
          reset: {
            placement: A
          }
        };
      const O = w.map((D) => {
        const $ = oe(D.placement);
        return [D.placement, $ && v ? (
          // Check along the mainAxis and main crossAxis side.
          D.overflows.slice(0, 2).reduce((j, q) => j + q, 0)
        ) : (
          // Check only the mainAxis.
          D.overflows[0]
        ), D.overflows];
      }).sort((D, $) => D[1] - $[1]), I = ((i = O.filter((D) => D[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        oe(D[0]) ? 2 : 3
      ).every(($) => $ <= 0))[0]) == null ? void 0 : i[0]) || O[0][0];
      return I !== a ? {
        data: {
          index: S + 1,
          overflows: w
        },
        reset: {
          placement: I
        }
      } : {};
    }
  };
};
function Uo(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Bo(t) {
  return va.some((e) => t[e] >= 0);
}
var bp = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = en(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await yr(e, {
            ...i,
            elementContext: "reference"
          }), s = Uo(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Bo(s)
            }
          };
        }
        case "escaped": {
          const o = await yr(e, {
            ...i,
            altBoundary: true
          }), s = Uo(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Bo(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
var wp = /* @__PURE__ */ new Set(["left", "top"]);
async function xp(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = nn(n), a = oe(n), c = Cr(n) === "y", l = wp.has(s) ? -1 : 1, v = o && c ? -1 : 1, f = en(e, t);
  let {
    mainAxis: u,
    crossAxis: p,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof h == "number" && (p = a === "end" ? h * -1 : h), c ? {
    x: p * v,
    y: u * l
  } : {
    x: u * l,
    y: p * v
  };
}
var _p = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = e, c = await xp(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
};
var Tp = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = true,
        crossAxis: s = false,
        limiter: a = {
          fn: (E) => {
            let {
              x: S,
              y
            } = E;
            return {
              x: S,
              y
            };
          }
        },
        ...c
      } = en(t, e), l = {
        x: n,
        y: r
      }, v = await yr(e, c), f = Cr(nn(i)), u = ga(f);
      let p = l[u], h = l[f];
      if (o) {
        const E = u === "y" ? "top" : "left", S = u === "y" ? "bottom" : "right", y = p + v[E], b = p - v[S];
        p = di(y, p, b);
      }
      if (s) {
        const E = f === "y" ? "top" : "left", S = f === "y" ? "bottom" : "right", y = h + v[E], b = h - v[S];
        h = di(y, h, b);
      }
      const g = a.fn({
        ...e,
        [u]: p,
        [f]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [u]: o,
            [f]: s
          }
        }
      };
    }
  };
};
function Or() {
  return typeof window < "u";
}
function rn(t) {
  return ma(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Mt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function le(t) {
  var e;
  return (e = (ma(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ma(t) {
  return Or() ? t instanceof Node || t instanceof Mt(t).Node : false;
}
function Vt(t) {
  return Or() ? t instanceof Element || t instanceof Mt(t).Element : false;
}
function Yt(t) {
  return Or() ? t instanceof HTMLElement || t instanceof Mt(t).HTMLElement : false;
}
function zo(t) {
  return !Or() || typeof ShadowRoot > "u" ? false : t instanceof ShadowRoot || t instanceof Mt(t).ShadowRoot;
}
var Rp = /* @__PURE__ */ new Set(["inline", "contents"]);
function Dn(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Wt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !Rp.has(i);
}
var Cp = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Op(t) {
  return Cp.has(rn(t));
}
var Ap = [":popover-open", ":modal"];
function Ar(t) {
  return Ap.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return false;
    }
  });
}
var Np = ["transform", "translate", "scale", "rotate", "perspective"];
var Pp = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
var Ip = ["paint", "layout", "strict", "content"];
function Di(t) {
  const e = Li(), n = Vt(t) ? Wt(t) : t;
  return Np.some((r) => n[r] ? n[r] !== "none" : false) || (n.containerType ? n.containerType !== "normal" : false) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : false) || !e && (n.filter ? n.filter !== "none" : false) || Pp.some((r) => (n.willChange || "").includes(r)) || Ip.some((r) => (n.contain || "").includes(r));
}
function Dp(t) {
  let e = Se(t);
  for (; Yt(e) && !Qe(e); ) {
    if (Di(e))
      return e;
    if (Ar(e))
      return null;
    e = Se(e);
  }
  return null;
}
function Li() {
  return typeof CSS > "u" || !CSS.supports ? false : CSS.supports("-webkit-backdrop-filter", "none");
}
var Lp = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Qe(t) {
  return Lp.has(rn(t));
}
function Wt(t) {
  return Mt(t).getComputedStyle(t);
}
function Nr(t) {
  return Vt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Se(t) {
  if (rn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    zo(t) && t.host || // Fallback.
    le(t)
  );
  return zo(e) ? e.host : e;
}
function Ea(t) {
  const e = Se(t);
  return Qe(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Yt(e) && Dn(e) ? e : Ea(e);
}
function mr(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = true);
  const i = Ea(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = Mt(i);
  if (o) {
    const a = pi(s);
    return e.concat(s, s.visualViewport || [], Dn(i) ? i : [], a && n ? mr(a) : []);
  }
  return e.concat(i, mr(i, [], n));
}
function pi(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Sa(t) {
  const e = Wt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = Yt(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = vr(n) !== o || vr(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function ba(t) {
  return Vt(t) ? t : t.contextElement;
}
function Ve(t) {
  const e = ba(t);
  if (!Yt(e))
    return Kt(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = Sa(e);
  let s = (o ? vr(n.width) : n.width) / r, a = (o ? vr(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
var $p = /* @__PURE__ */ Kt(0);
function wa(t) {
  const e = Mt(t);
  return !Li() || !e.visualViewport ? $p : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function kp(t, e, n) {
  return e === void 0 && (e = false), !n || e && n !== Mt(t) ? false : e;
}
function On(t, e, n, r) {
  e === void 0 && (e = false), n === void 0 && (n = false);
  const i = t.getBoundingClientRect(), o = ba(t);
  let s = Kt(1);
  e && (r ? Vt(r) && (s = Ve(r)) : s = Ve(t));
  const a = kp(o, n, r) ? wa(o) : Kt(0);
  let c = (i.left + a.x) / s.x, l = (i.top + a.y) / s.y, v = i.width / s.x, f = i.height / s.y;
  if (o) {
    const u = Mt(o), p = r && Vt(r) ? Mt(r) : r;
    let h = u, g = pi(h);
    for (; g && r && p !== h; ) {
      const E = Ve(g), S = g.getBoundingClientRect(), y = Wt(g), b = S.left + (g.clientLeft + parseFloat(y.paddingLeft)) * E.x, _ = S.top + (g.clientTop + parseFloat(y.paddingTop)) * E.y;
      c *= E.x, l *= E.y, v *= E.x, f *= E.y, c += b, l += _, h = Mt(g), g = pi(h);
    }
  }
  return gr({
    width: v,
    height: f,
    x: c,
    y: l
  });
}
function Pr(t, e) {
  const n = Nr(t).scrollLeft;
  return e ? e.left + n : On(le(t)).left + n;
}
function xa(t, e) {
  const n = t.getBoundingClientRect(), r = n.left + e.scrollLeft - Pr(t, n), i = n.top + e.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Mp(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const o = i === "fixed", s = le(r), a = e ? Ar(e.floating) : false;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Kt(1);
  const v = Kt(0), f = Yt(r);
  if ((f || !f && !o) && ((rn(r) !== "body" || Dn(s)) && (c = Nr(r)), Yt(r))) {
    const p = On(r);
    l = Ve(r), v.x = p.x + r.clientLeft, v.y = p.y + r.clientTop;
  }
  const u = s && !f && !o ? xa(s, c) : Kt(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + v.x + u.x,
    y: n.y * l.y - c.scrollTop * l.y + v.y + u.y
  };
}
function Hp(t) {
  return Array.from(t.getClientRects());
}
function jp(t) {
  const e = le(t), n = Nr(t), r = t.ownerDocument.body, i = qe(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = qe(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Pr(t);
  const a = -n.scrollTop;
  return Wt(r).direction === "rtl" && (s += qe(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
var qo = 25;
function Fp(t, e) {
  const n = Mt(t), r = le(t), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const v = Li();
    (!v || v && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const l = Pr(r);
  if (l <= 0) {
    const v = r.ownerDocument, f = v.body, u = getComputedStyle(f), p = v.compatMode === "CSS1Compat" && parseFloat(u.marginLeft) + parseFloat(u.marginRight) || 0, h = Math.abs(r.clientWidth - f.clientWidth - p);
    h <= qo && (o -= h);
  } else l <= qo && (o += l);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
var Up = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Bp(t, e) {
  const n = On(t, true, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = Yt(t) ? Ve(t) : Kt(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, c = i * o.x, l = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function Vo(t, e, n) {
  let r;
  if (e === "viewport")
    r = Fp(t, n);
  else if (e === "document")
    r = jp(le(t));
  else if (Vt(e))
    r = Bp(e, n);
  else {
    const i = wa(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return gr(r);
}
function _a(t, e) {
  const n = Se(t);
  return n === e || !Vt(n) || Qe(n) ? false : Wt(n).position === "fixed" || _a(n, e);
}
function zp(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = mr(t, [], false).filter((a) => Vt(a) && rn(a) !== "body"), i = null;
  const o = Wt(t).position === "fixed";
  let s = o ? Se(t) : t;
  for (; Vt(s) && !Qe(s); ) {
    const a = Wt(s), c = Di(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && Up.has(i.position) || Dn(s) && !c && _a(t, s)) ? r = r.filter((v) => v !== s) : i = a, s = Se(s);
  }
  return e.set(t, r), r;
}
function qp(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? Ar(e) ? [] : zp(e, this._c) : [].concat(n), r], a = s[0], c = s.reduce((l, v) => {
    const f = Vo(e, v, i);
    return l.top = qe(f.top, l.top), l.right = Cn(f.right, l.right), l.bottom = Cn(f.bottom, l.bottom), l.left = qe(f.left, l.left), l;
  }, Vo(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Vp(t) {
  const {
    width: e,
    height: n
  } = Sa(t);
  return {
    width: e,
    height: n
  };
}
function Wp(t, e, n) {
  const r = Yt(e), i = le(e), o = n === "fixed", s = On(t, true, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Kt(0);
  function l() {
    c.x = Pr(i);
  }
  if (r || !r && !o)
    if ((rn(e) !== "body" || Dn(i)) && (a = Nr(e)), r) {
      const p = On(e, true, o, e);
      c.x = p.x + e.clientLeft, c.y = p.y + e.clientTop;
    } else i && l();
  o && !r && i && l();
  const v = i && !r && !o ? xa(i, a) : Kt(0), f = s.left + a.scrollLeft - c.x - v.x, u = s.top + a.scrollTop - c.y - v.y;
  return {
    x: f,
    y: u,
    width: s.width,
    height: s.height
  };
}
function Vr(t) {
  return Wt(t).position === "static";
}
function Wo(t, e) {
  if (!Yt(t) || Wt(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return le(t) === n && (n = n.ownerDocument.body), n;
}
function Ta(t, e) {
  const n = Mt(t);
  if (Ar(t))
    return n;
  if (!Yt(t)) {
    let i = Se(t);
    for (; i && !Qe(i); ) {
      if (Vt(i) && !Vr(i))
        return i;
      i = Se(i);
    }
    return n;
  }
  let r = Wo(t, e);
  for (; r && Op(r) && Vr(r); )
    r = Wo(r, e);
  return r && Qe(r) && Vr(r) && !Di(r) ? n : r || Dp(t) || n;
}
var Gp = async function(t) {
  const e = this.getOffsetParent || Ta, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Wp(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Kp(t) {
  return Wt(t).direction === "rtl";
}
var Xp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Mp,
  getDocumentElement: le,
  getClippingRect: qp,
  getOffsetParent: Ta,
  getElementRects: Gp,
  getClientRects: Hp,
  getDimensions: Vp,
  getScale: Ve,
  isElement: Vt,
  isRTL: Kp
};
var Yp = _p;
var Zp = Sp;
var Jp = Tp;
var Qp = bp;
var th = mp;
var eh = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Xp,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return yp(t, e, {
    ...i,
    platform: o
  });
};
var Wr;
var Go;
function nh() {
  if (Go) return Wr;
  Go = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, c = typeof Ut == "object" && Ut && Ut.Object === Object && Ut, l = typeof self == "object" && self && self.Object === Object && self, v = c || l || Function("return this")(), f = Object.prototype, u = f.toString, p = Math.max, h = Math.min, g = function() {
    return v.Date.now();
  };
  function E(w, A, O) {
    var C, I, D, $, j, q, Z = 0, K = false, rt = false, ct = true;
    if (typeof w != "function")
      throw new TypeError(t);
    A = _(A) || 0, S(O) && (K = !!O.leading, rt = "maxWait" in O, D = rt ? p(_(O.maxWait) || 0, A) : D, ct = "trailing" in O ? !!O.trailing : ct);
    function V(J) {
      var dt = C, _t = I;
      return C = I = void 0, Z = J, $ = w.apply(_t, dt), $;
    }
    function ft(J) {
      return Z = J, j = setTimeout(Q, A), K ? V(J) : $;
    }
    function tt(J) {
      var dt = J - q, _t = J - Z, Dt = A - dt;
      return rt ? h(Dt, D - _t) : Dt;
    }
    function et(J) {
      var dt = J - q, _t = J - Z;
      return q === void 0 || dt >= A || dt < 0 || rt && _t >= D;
    }
    function Q() {
      var J = g();
      if (et(J))
        return gt(J);
      j = setTimeout(Q, tt(J));
    }
    function gt(J) {
      return j = void 0, ct && C ? V(J) : (C = I = void 0, $);
    }
    function W() {
      j !== void 0 && clearTimeout(j), Z = 0, C = q = I = j = void 0;
    }
    function F() {
      return j === void 0 ? $ : gt(g());
    }
    function xt() {
      var J = g(), dt = et(J);
      if (C = arguments, I = this, q = J, dt) {
        if (j === void 0)
          return ft(q);
        if (rt)
          return j = setTimeout(Q, A), V(q);
      }
      return j === void 0 && (j = setTimeout(Q, A)), $;
    }
    return xt.cancel = W, xt.flush = F, xt;
  }
  function S(w) {
    var A = typeof w;
    return !!w && (A == "object" || A == "function");
  }
  function y(w) {
    return !!w && typeof w == "object";
  }
  function b(w) {
    return typeof w == "symbol" || y(w) && u.call(w) == n;
  }
  function _(w) {
    if (typeof w == "number")
      return w;
    if (b(w))
      return e;
    if (S(w)) {
      var A = typeof w.valueOf == "function" ? w.valueOf() : w;
      w = S(A) ? A + "" : A;
    }
    if (typeof w != "string")
      return w === 0 ? w : +w;
    w = w.replace(r, "");
    var O = o.test(w);
    return O || s.test(w) ? a(w.slice(2), O ? 2 : 8) : i.test(w) ? e : +w;
  }
  return Wr = E, Wr;
}
var rh = nh();
var Ra = /* @__PURE__ */ Pe(rh);
var Gr;
var Ko;
function ih() {
  if (Ko) return Gr;
  Ko = 1;
  var t = 200, e = "__lodash_hash_undefined__", n = 1 / 0, r = "[object Function]", i = "[object GeneratorFunction]", o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, a = typeof Ut == "object" && Ut && Ut.Object === Object && Ut, c = typeof self == "object" && self && self.Object === Object && self, l = a || c || Function("return this")();
  function v(R, H) {
    var d = R ? R.length : 0;
    return !!d && u(R, H, 0) > -1;
  }
  function f(R, H, d, x) {
    for (var P = R.length, N = d + -1; ++N < P; )
      if (H(R[N], N, R))
        return N;
    return -1;
  }
  function u(R, H, d) {
    if (H !== H)
      return f(R, p, d);
    for (var x = d - 1, P = R.length; ++x < P; )
      if (R[x] === H)
        return x;
    return -1;
  }
  function p(R) {
    return R !== R;
  }
  function h(R, H) {
    return R.has(H);
  }
  function g(R, H) {
    return R?.[H];
  }
  function E(R) {
    var H = false;
    if (R != null && typeof R.toString != "function")
      try {
        H = !!(R + "");
      } catch {
      }
    return H;
  }
  function S(R) {
    var H = -1, d = Array(R.size);
    return R.forEach(function(x) {
      d[++H] = x;
    }), d;
  }
  var y = Array.prototype, b = Function.prototype, _ = Object.prototype, w = l["__core-js_shared__"], A = (function() {
    var R = /[^.]+$/.exec(w && w.keys && w.keys.IE_PROTO || "");
    return R ? "Symbol(src)_1." + R : "";
  })(), O = b.toString, C = _.hasOwnProperty, I = _.toString, D = RegExp(
    "^" + O.call(C).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), $ = y.splice, j = de(l, "Map"), q = de(l, "Set"), Z = de(Object, "create");
  function K(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var x = R[H];
      this.set(x[0], x[1]);
    }
  }
  function rt() {
    this.__data__ = Z ? Z(null) : {};
  }
  function ct(R) {
    return this.has(R) && delete this.__data__[R];
  }
  function V(R) {
    var H = this.__data__;
    if (Z) {
      var d = H[R];
      return d === e ? void 0 : d;
    }
    return C.call(H, R) ? H[R] : void 0;
  }
  function ft(R) {
    var H = this.__data__;
    return Z ? H[R] !== void 0 : C.call(H, R);
  }
  function tt(R, H) {
    var d = this.__data__;
    return d[R] = Z && H === void 0 ? e : H, this;
  }
  K.prototype.clear = rt, K.prototype.delete = ct, K.prototype.get = V, K.prototype.has = ft, K.prototype.set = tt;
  function et(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var x = R[H];
      this.set(x[0], x[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function gt(R) {
    var H = this.__data__, d = ue(H, R);
    if (d < 0)
      return false;
    var x = H.length - 1;
    return d == x ? H.pop() : $.call(H, d, 1), true;
  }
  function W(R) {
    var H = this.__data__, d = ue(H, R);
    return d < 0 ? void 0 : H[d][1];
  }
  function F(R) {
    return ue(this.__data__, R) > -1;
  }
  function xt(R, H) {
    var d = this.__data__, x = ue(d, R);
    return x < 0 ? d.push([R, H]) : d[x][1] = H, this;
  }
  et.prototype.clear = Q, et.prototype.delete = gt, et.prototype.get = W, et.prototype.has = F, et.prototype.set = xt;
  function J(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var x = R[H];
      this.set(x[0], x[1]);
    }
  }
  function dt() {
    this.__data__ = {
      hash: new K(),
      map: new (j || et)(),
      string: new K()
    };
  }
  function _t(R) {
    return fe(this, R).delete(R);
  }
  function Dt(R) {
    return fe(this, R).get(R);
  }
  function Zt(R) {
    return fe(this, R).has(R);
  }
  function Nt(R, H) {
    return fe(this, R).set(R, H), this;
  }
  J.prototype.clear = dt, J.prototype.delete = _t, J.prototype.get = Dt, J.prototype.has = Zt, J.prototype.set = Nt;
  function Lt(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.__data__ = new J(); ++H < d; )
      this.add(R[H]);
  }
  function Jt(R) {
    return this.__data__.set(R, e), this;
  }
  function De(R) {
    return this.__data__.has(R);
  }
  Lt.prototype.add = Lt.prototype.push = Jt, Lt.prototype.has = De;
  function ue(R, H) {
    for (var d = R.length; d--; )
      if (Le(R[d][0], H))
        return d;
    return -1;
  }
  function on(R) {
    if (!Qt(R) || ln(R))
      return false;
    var H = pe(R) || E(R) ? D : s;
    return H.test(un(R));
  }
  function sn(R, H, d) {
    var x = -1, P = v, N = R.length, k = true, U = [], z = U;
    if (N >= t) {
      var G = an(R);
      if (G)
        return S(G);
      k = false, P = h, z = new Lt();
    } else
      z = U;
    t:
      for (; ++x < N; ) {
        var Y = R[x], ot = Y;
        if (Y = Y !== 0 ? Y : 0, k && ot === ot) {
          for (var ut = z.length; ut--; )
            if (z[ut] === ot)
              continue t;
          U.push(Y);
        } else P(z, ot, d) || (z !== U && z.push(ot), U.push(Y));
      }
    return U;
  }
  var an = q && 1 / S(new q([, -0]))[1] == n ? function(R) {
    return new q(R);
  } : we;
  function fe(R, H) {
    var d = R.__data__;
    return cn(H) ? d[typeof H == "string" ? "string" : "hash"] : d.map;
  }
  function de(R, H) {
    var d = g(R, H);
    return on(d) ? d : void 0;
  }
  function cn(R) {
    var H = typeof R;
    return H == "string" || H == "number" || H == "symbol" || H == "boolean" ? R !== "__proto__" : R === null;
  }
  function ln(R) {
    return !!A && A in R;
  }
  function un(R) {
    if (R != null) {
      try {
        return O.call(R);
      } catch {
      }
      try {
        return R + "";
      } catch {
      }
    }
    return "";
  }
  function fn(R) {
    return R && R.length ? sn(R) : [];
  }
  function Le(R, H) {
    return R === H || R !== R && H !== H;
  }
  function pe(R) {
    var H = Qt(R) ? I.call(R) : "";
    return H == r || H == i;
  }
  function Qt(R) {
    var H = typeof R;
    return !!R && (H == "object" || H == "function");
  }
  function we() {
  }
  return Gr = fn, Gr;
}
var oh = ih();
var sh = /* @__PURE__ */ Pe(oh);
var Ca = 10;
var Oa = 15;
var ah = (t, e, n, r) => {
  const i = `-${Oa / 2}px`, { staticSide: o, rotation: s, shadowOpacity: a } = {
    top: {
      staticSide: "bottom",
      rotation: 45,
      shadowOpacity: 40
    },
    bottom: {
      staticSide: "top",
      rotation: 225,
      shadowOpacity: 7
    },
    right: {
      staticSide: "left",
      rotation: 135,
      shadowOpacity: 7
    },
    left: {
      staticSide: "right",
      rotation: -45,
      shadowOpacity: 40
    }
  }[t.split("-")[0]];
  return {
    boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${a}%)`,
    transform: `rotate(${s}deg)`,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%)",
    left: e != null ? `${e}px` : "",
    top: n != null ? `${n}px` : "",
    right: "",
    bottom: "",
    [o]: i,
    zIndex: r
  };
};
var Xo = (t, e) => {
  const n = t.slice(1);
  return e.find(
    ({ config: r, type: i }) => i === "@appcues/overlay" && n === r.rootId
  );
};
var ch = (t, e) => {
  const n = Ca + Oa / 2;
  return e.includes("start") ? t - n : t + n;
};
var lh = ({
  placementUnit: t,
  distance: e,
  skidding: n,
  placement: r,
  targetEl: i
}) => {
  const o = r.startsWith("left") || r.startsWith("right"), s = o ? e : n, a = o ? n : e;
  if (t !== "percentage" || !i)
    return {
      mainAxis: e,
      crossAxis: n
    };
  const { width: c, height: l } = i.getBoundingClientRect(), v = o ? c * s / 100 : l * a / 100, f = o ? l * a / 100 : c * s / 100;
  return {
    mainAxis: v,
    crossAxis: f
  };
};
var Er = (t, e) => {
  try {
    const n = e(), r = n.document, i = n.getComputedStyle(t), { overflow: o, overflowY: s, overflowX: a } = i, c = /* @__PURE__ */ new Set([o, s, a]);
    if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden"))
      return true;
    const { host: l = null } = t?.getRootNode() ?? {}, v = l?.tagName?.includes(Nn) || l?.tagName?.includes(Pn);
    return t.parentElement === null && l && !v ? Er(l.parentElement, e) : t.parentElement !== null && t.parentElement !== r.body ? Er(t.parentElement, e) : false;
  } catch {
    return false;
  }
};
function Yo(t) {
  return t === "fixed" || t === "relative" || t === "absolute" || t === "sticky";
}
function Zo(t) {
  return t.display === "flex" || t.display === "inline-flex";
}
function Aa(t, e, n, r, i) {
  let o = i, s = e.zIndex;
  const a = e.position, c = t.parentElement, l = c ? r.getComputedStyle(c) : {};
  if (s !== "" && s !== "auto" && !Yo(a) && !Zo(l) && (s = "auto"), (!o || s !== "" && s !== "auto" && (Yo(a) || Zo(l))) && (o = s), c && c !== n.body && c !== n.documentElement)
    return Aa(c, l, n, r, o);
  if (/^\d+$/.test(o)) {
    let v = Number.parseInt(o, 10);
    v += 1, o = v;
  }
  return o;
}
var uh = (t, e) => {
  const n = e(), r = n.document, i = n.getComputedStyle(t);
  return Aa(t, i, r, n);
};
var fh = ({
  targetEl: t,
  rootStyle: e,
  shouldAutoCalculateZIndex: n,
  getWindowReference: r
}) => {
  let i = e;
  if (n) {
    const o = uh(t, r);
    i = { ...e, zIndex: o };
  }
  return i;
};
var dh = () => {
  const t = /* @__PURE__ */ new Map();
  function e(i) {
    i.composedPath().forEach((o) => {
      (t.get(o) ?? {})[i.type]?.map((a) => a(i));
    });
  }
  return {
    addEventListener: (i, o, s) => {
      t.get(i) || t.set(i, {});
      const a = t.get(i);
      a[o] || (a[o] = []), a[o].includes(s) || (a[o] = [...a[o], s], t.set(i, a)), a[o].length === 1 && i.addEventListener(o, e, true);
    },
    removeEventListener: (i, o, s) => {
      const a = t.get(i);
      if (!a)
        return;
      const c = (a[o] ?? []).filter(
        (l) => l !== s
      );
      a[o] = c, t.set(i, a), a[o].length === 0 && i.removeEventListener(o, e, true);
    }
  };
};
var { addEventListener: Sr, removeEventListener: br } = dh();
var ph = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (o) => {
    if (e.has(o)) return;
    const s = setInterval(() => {
      t.get(o).forEach((c) => c());
    }, o);
    e.set(o, s);
  }, r = (o, s) => {
    const a = t.get(s);
    if (a) {
      const c = a.filter((v) => v !== o);
      if (c.length > 0) {
        t.set(s, c);
        return;
      }
      const l = e.get(s);
      clearInterval(l), t.delete(s), e.delete(s);
    }
  };
  return (o, s) => {
    const a = t.get(s) ?? [];
    return t.set(s, [...a, o]), n(s), () => r(o, s);
  };
};
var hh = ph();
var We = (t, e) => {
  if (!e) return t;
  const { order: n, text: r } = e;
  let i = [...t];
  return r && r !== "" && (i = i.filter(
    (o) => o.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim()
  )), n != null ? i.length > n ? [i[n]] : [] : i;
};
var vh = "@appcues/overlay";
var gh = {
  top: "top",
  "top-left": "top-start",
  "top-right": "top-end",
  right: "right",
  "right-top": "right-start",
  "right-bottom": "right-end",
  bottom: "bottom",
  "bottom-right": "bottom-end",
  "bottom-left": "bottom-start",
  left: "left",
  "left-bottom": "left-end",
  "left-top": "left-start",
  center: "top-start"
};
var yh = (t) => {
  let e, n, r, i = [], o, s = () => {
  }, a;
  function c() {
    t();
  }
  const l = Ra(c, 100);
  function v() {
    const f = e.getBoundingClientRect();
    a && (f.x !== a.x || f.y !== a.y || f.width !== a.width || f.height !== a.height) && l(), a = f;
  }
  return {
    setElements(f, u, p) {
      return e = f, n = u, r = p, i = [], this;
    },
    start() {
      r && (i = sh([...mr(r)])), i.forEach((f) => {
        Sr(f, "scroll", l), Sr(f, "resize", l);
      }), o = new ResizeObserver(l), o.observe(n), a = e.getBoundingClientRect(), s = hh(v, 200);
    },
    remove() {
      i.forEach((f) => {
        br(f, "scroll", l), br(f, "resize", l);
      }), o?.unobserve(n), s();
    }
  };
};
var mh = ({ addHook: t, registerAction: e }) => {
  let n, r = false, i = false, o, s, a, c, l, v, f = false, u = "absolute", p, h;
  t(
    "step.begin",
    ({
      onElementRemoved: g,
      querySelector: E,
      reportError: S,
      step: y,
      updateStyle: b,
      getWindowReference: _,
      getTraitConfig: w
    }) => {
      const { traits: A } = y.getConfig(), {
        arrowId: O = "arrow",
        target: C,
        rootId: I,
        placement: D = "auto",
        distance: $,
        skidding: j,
        placementUnit: q = "pixels",
        shouldAutoCalculateZIndex: Z = true
      } = w(), K = Xo(C.selector, A), ct = A.find((tt) => tt.type === "@appcues/toggle")?.config?.startHidden ?? true;
      ct || b(I, { position: "absolute" }), a = () => {
        const tt = y.querySelector(`#${I}`), et = y.querySelector(`#${O}`), Q = We(
          E(C.selector),
          C.filters
        );
        return {
          matchingElements: Q,
          targetEl: Q[0],
          rootEl: tt[0],
          arrowEl: et[0]
        };
      };
      const V = async () => {
        const { targetEl: tt, rootEl: et, arrowEl: Q } = a();
        if (!r && tt && et) {
          r = true;
          const gt = lh({
            placement: D,
            targetEl: tt,
            distance: $,
            skidding: j,
            placementUnit: q
          }), W = [
            Yp(({ placement: Lt }) => ({
              ...gt,
              crossAxis: Q && /start|end/gm.test(Lt) ? ch(j, Lt) : gt.crossAxis
            }))
          ];
          D === "auto" && W.push(
            Jp(),
            Zp({
              crossAxis: true
            })
          ), Q && W.push(th({ element: Q, padding: Ca })), W.push(Qp());
          const {
            middlewareData: F,
            strategy: xt,
            x: J,
            y: dt,
            placement: _t
          } = await eh(tt, et, {
            middleware: W,
            placement: gh[D] ?? "auto",
            strategy: u
          }), { referenceHidden: Dt } = F.hide;
          if (Q) {
            const { x: Lt, y: Jt } = F.arrow;
            b(O, {
              ...ah(_t, Lt, Jt),
              transition: "top 200ms, left 200ms, right 200ms, bottom 200ms"
            });
          }
          const Zt = {
            left: `${J}px`,
            position: xt,
            top: `${dt}px`
          }, Nt = fh({
            targetEl: tt,
            rootStyle: Zt,
            shouldAutoCalculateZIndex: Z,
            getWindowReference: _
          });
          tt.style.visibility === "hidden" && (Nt.visibility = "hidden", v = tt.style.visibility), Dt && et.style.visibility !== "hidden" && (l = et.style.visibility, f = true, Nt.visibility = "hidden"), !Dt && f && (Nt.visibility = l ?? "visible", f = false), !Dt && tt.style.visibility !== "hidden" && tt.style.visibility !== "" && v === "hidden" && (Nt.visibility = "visible"), D === "center" && (Nt.transform = "translate(-50%, 50%)"), Nt.transition = "top 200ms, left 200ms, right 200ms, bottom 200ms", b(I, Nt);
        }
      };
      p = () => {
        r = false, V();
      }, c = yh(p);
      const ft = () => We(E(C.selector), C.filters);
      n = async () => {
        o && o(), s && s();
        const { matchingElements: tt, rootEl: et } = a(), Q = tt.length === 1, gt = tt.length > 1, W = tt.length === 0, F = () => {
          K || (s = g({
            getTarget: ft,
            onRemoved: () => {
              r = false, h = S(`Target got removed => ${C.selector}`), c.remove();
            }
          }));
        };
        if (Q && !et) {
          h = S(
            `Could not find root element #${I} for overlay positioning.`
          );
          return;
        }
        if (Q) {
          const xt = K ? E(K.config.target.selector) : null;
          if (ct) {
            const J = xt != null ? Er(
              xt[0]?.parentElement,
              _
            ) : false;
            u = Er(
              tt[0]?.parentElement,
              _
            ) || J ? "fixed" : "absolute", b(I, { position: u });
          }
          await V(), F(), c.setElements(
            tt[0],
            et,
            xt ? xt[0] : null
          ).start();
          return;
        }
        gt && S(
          `Found ${tt.length} elements for selector ${C.selector}.`
        ), W && (h = S(
          `Could not find element for selector ${C.selector}.`
        ));
      };
    }
  ), t("step.postrender", async () => {
    i || (await n(), i = true);
  }), t("step.end", () => {
    o && o(), s && s(), c.remove(), r = false, i = false;
  }), t(
    "step.error",
    ({ step: g, getTraitConfig: E, onElementInserted: S, querySelector: y }) => {
      r = false, i = false;
      const { target: b } = E(), { traits: _ } = g.getConfig(), w = () => We(y(b.selector), b.filters);
      Xo(b.selector, _) || (o = S({
        getTarget: w,
        onInserted: () => {
          i = false, g.recover({ errorId: h });
        }
      }));
    }
  );
};
bt(vh, mh);
var Eh = "@appcues/persistent";
var Sh = ({ addHook: t }) => {
  t("experience.begin", ({ steps: e }) => {
    e.map((n) => n.start());
  });
};
bt(Eh, Sh);
var bh = {
  left: "beforebegin",
  "inner-left": "afterbegin",
  right: "afterend",
  "inner-right": "beforeend"
};
var wh = "@appcues/inline";
var ir = "appcues-hide";
var xh = `.${ir} { display: none !important; }`;
var _h = ({
  distanceUnit: t,
  yOffset: e,
  xOffset: n,
  targetEl: r
}) => {
  if (t !== "%" || !r)
    return {
      x: `${n}px`,
      y: `${e}px`
    };
  const { width: i, height: o } = r.getBoundingClientRect();
  return {
    x: `${i * n / 100}px`,
    y: `${o * e / 100}px`
  };
};
function Th({ addHook: t }) {
  let e, n, r, i = [], o = [], s = null, a = null;
  const c = (v) => {
    if (s) return;
    const { document: f } = v();
    s = f.createElement("style"), s.textContent = xh, f.head.append(s);
  }, l = () => {
    i.forEach((v) => v.classList.remove(ir)), i = [], o.forEach((v) => {
      const f = v.firstChild;
      f && v.replaceWith(f);
    }), o = [], s && (s.remove(), s = null);
  };
  t(
    "step.begin",
    ({
      step: v,
      getTraitConfig: f,
      reportError: u,
      onElementRemoved: p,
      updateRootStyle: h,
      querySelector: g,
      getWindowReference: E
    }) => {
      const {
        target: S,
        placement: y = "right",
        verticalAlignment: b = "bottom",
        allowOverlap: _ = false,
        xOffset: w = 0,
        yOffset: A = 0,
        distanceUnit: O = "px",
        sticky: C = false,
        rootDisplay: I = "inline-block",
        clearContainer: D = false
      } = f();
      e && e(), n && n();
      const $ = We(
        g(S.selector),
        S.filters
      ), j = $.length === 1, q = $.length > 1, Z = $.length === 0, K = (V) => {
        const ft = E().document.createElement("div");
        if (a && (a.remove(), a = null), l(), D && y.includes("inner"))
          if (D === "hide") {
            c(E);
            const { document: et } = E();
            Array.from(V.childNodes).forEach((Q) => {
              if (Q.nodeType === Node.ELEMENT_NODE)
                Q.classList.add(ir), i.push(Q);
              else if (Q.nodeType === Node.TEXT_NODE && Q.textContent.trim()) {
                const gt = et.createElement("span");
                gt.classList.add(ir), Q.replaceWith(gt), gt.append(Q), o.push(gt);
              }
            });
          } else
            for (; V.firstChild; )
              V.firstChild.remove();
        if (V.insertAdjacentElement(
          bh[y],
          ft
        ) == null) {
          u(`can't insert inline container on the ${y}`);
          return;
        }
        a = ft, v.setStepContainerTarget(ft);
      }, rt = () => We(g(S.selector), S.filters), ct = () => {
        n = p({
          getTarget: rt,
          onRemoved: () => {
            r = u(`Target got removed => ${S.selector}`);
          }
        });
      };
      if (j) {
        K($[0]);
        const V = {
          display: I,
          verticalAlign: b
        }, { x: ft, y: tt } = _h({
          distanceUnit: O,
          xOffset: w,
          yOffset: A,
          targetEl: $[0]
        });
        if (_)
          V.position = "absolute", V.transform = `translate(${ft}, ${tt})`;
        else {
          const et = y.includes("left") ? "right" : "left";
          V[`margin-${et}`] = ft, V[`margin-${b}`] = tt;
        }
        if (C) {
          V.position = "sticky";
          const et = y.includes("left") ? "top" : "bottom";
          V[et] = 0, V.zIndex = Ru;
        }
        h(V), ct();
        return;
      }
      q && u(
        `Found ${$.length} elements for selector ${S.selector}.`
      ), Z && (r = u(
        `Could not find element for selector ${S.selector}.`
      ));
    }
  ), t(
    "step.error",
    ({ step: v, getTraitConfig: f, onElementInserted: u, querySelector: p }) => {
      const { target: h } = f();
      e = u({
        getTarget: () => We(p(h.selector), h.filters),
        onInserted: () => {
          v.recover({ errorId: r });
        }
      });
    }
  ), t("step.end", () => {
    e && e(), n && n(), a && (a.remove(), a = null), l();
  });
}
bt(wh, Th);
var Rh = (t, e, n) => {
  const { height: r, width: i, left: o, top: s } = t.getBoundingClientRect();
  return Math.floor(
    Math.hypot(e - (o + i / 2), n - (s + r / 2)) / 2
  );
};
var Ch = (t, e) => {
  const { height: n, width: r } = t.getBoundingClientRect(), i = Math.floor(Math.hypot(n, r) / 4);
  return Math.max(e, 0) + i;
};
var Oh = (t) => t.key === "Escape";
var Ah = (t, e) => ![...t.composedPath()].filter((i) => i.nodeType === Node.ELEMENT_NODE).some((i) => i?.contains?.(e) ?? false);
var Xn = (t, e) => ({
  remove: () => {
    t.removeEventListener("keydown", e), t.removeEventListener("click", e, true);
  },
  start: () => {
    t.addEventListener("click", e, true), t.addEventListener("keydown", e);
  }
});
var Kr = (t, e, n) => e.length === 0 ? (n("Element not found"), false) : e.length > 1 ? (n(`More than one element found with id: ${t}`), false) : true;
var Nh = "@appcues/toggle.style";
var Na = ({ targetId: t, styles: e = {} }, { updateStyle: n }) => {
  n(t, e);
};
var Jo = {
  [Nh]: Na
};
var Ph = ({ addHook: t, registerAction: e }, {
  startHidden: n = true,
  targetId: r,
  transition: i,
  closeOnClickOutside: o = true,
  closeRadius: s
}) => {
  let a, c, l, v = false, f = [], u = null, p = [];
  const h = () => {
    f.forEach((S) => S.remove()), f = [];
  };
  n && t("step.begin", ({ updateStyle: S, getWindowReference: y }) => {
    S(r, {
      opacity: "0",
      visibility: "hidden",
      "pointer-events": "none"
    }), p = [...y().document.querySelectorAll("iframe")];
  }), t("step.end", () => {
    o && h(), u?.remove(), u = null;
  }), t("step.error", () => {
    o && h(), u?.remove(), u = null;
  });
  const g = ({ on: S } = {}, y) => {
    const { reportError: b, step: _, updateStyle: w, getWindowReference: A } = y, O = A().document, C = _.querySelector(`#${r}`);
    if (!Kr(r, C, b)) return;
    o && h();
    const I = {};
    i || (I.visibility = "hidden", I["pointer-events"] = "none"), w(r, {
      ...I,
      opacity: "0"
    }), i && setTimeout(() => {
      w(r, {
        visibility: "hidden",
        "pointer-events": "none"
      });
    }, i.duration * 1e3), s && v && (br(O, "mousemove", a), p.forEach((D) => {
      D.contentDocument?.body && br(
        D.contentDocument.body,
        "mousemove",
        a
      );
    }), v = false), S?.close?.forEach(
      (D) => Jo[D.type](D.config, y)
    );
  }, E = ({ on: S } = {}, y) => {
    const { reportError: b, step: _, updateStyle: w, getWindowReference: A } = y, O = A().document, C = _.querySelector(`#${r}`);
    if (!Kr(r, C, b)) return;
    const I = {};
    if (i && (I.transition = `opacity ${i.duration}s ${i.easing}`), w(r, {
      ...I,
      visibility: "visible",
      opacity: "1",
      "pointer-events": "auto"
    }), S?.open?.forEach(
      (D) => Jo[D.type](D.config, y)
    ), o && f.length === 0) {
      const D = _.querySelector(":first-child")[0];
      l = (j) => {
        (Oh(j) || Ah(j, C[0])) && g({ on: S }, y);
      };
      const $ = p.map((j) => j.contentDocument?.body ? Xn(
        j.contentDocument.body,
        l
      ) : null).filter(Boolean);
      f.push(
        Xn(O, l),
        Xn(D, l),
        ...$
      ), f.forEach((j) => j.start());
    }
    if (u || (c = (D) => {
      if (D.type === "keydown" && !["Enter", " "].includes(D.key))
        return;
      const $ = [...D.composedPath()];
      ["a", "button"].includes($[0].tagName.toLowerCase()) && g({ on: S }, y);
    }, u = Xn(C[0], c), u.start()), s && !v) {
      const D = Ch(C[0], s);
      a = Ra(($) => {
        Rh(
          C[0],
          $.clientX,
          $.clientY
        ) > D && g({ on: S }, { reportError: b, step: _, updateStyle: w, getWindowReference: A });
      }, 60), Sr(O, "mousemove", a), p.forEach(($) => {
        $.contentDocument?.body && Sr(
          $.contentDocument.body,
          "mousemove",
          a
        );
      }), v = true;
    }
  };
  e("run", ({ on: S } = {}, y) => {
    const { step: b, reportError: _, getWindowReference: w } = y, A = b.querySelector(`#${r}`);
    if (!Kr(r, A, _)) return;
    if (w().getComputedStyle(A[0]).visibility === "hidden") {
      E({ on: S }, y);
      return;
    }
    g({ on: S }, y);
  }), e("open", E), e("close", g), e("style", Na);
};
var Ih = "@appcues/toggle";
bt(Ih, Ph);
var Dh = "@appcues/coreEvents";
var Lh = ({ registerAction: t }) => {
  t("step_seen", (e, { step: n }) => {
    n.seen();
  }), t("extended_event", ({ name: e, ...n }, { step: r }) => {
    r.extendedEvent(e, n);
  }), t("step_interaction", (e, { step: n }) => {
    n.interaction(e.interactionType, e.interactionData);
  }), t("experience_dismissed", (e, { step: n }) => {
    n.dismissExperience();
  }), t("experience_snoozed", (e, { step: n }) => {
    n.snoozeExperience();
  });
};
bt(Dh, Lh);
var $h = (t, e = {}, n = () => window) => {
  let r = e;
  const i = [], o = n().document, s = (v) => {
    const { el: f, callbackFn: u } = v.detail;
    i.push([f, u]), f[u].apply(v.target, [r]);
  };
  return o.addEventListener(`${t}:connect`, s), {
    getState: () => r,
    setState: (v) => {
      r = { ...r, ...v }, i.forEach(([f, u]) => {
        f[u].apply(f, [r]);
      });
    },
    destroy: () => {
      o.removeEventListener(`${t}:connect`, s);
    }
  };
};
var kh = "@appcues/store";
var Mh = ({ addHook: t, registerAction: e }, { id: n, initialState: r = {} }) => {
  let i;
  t("step.begin", ({ getWindowReference: o }) => {
    i = $h(n, r, o);
  }), t("step.end", () => {
    i && i.destroy();
  }), e("setState", ({ stateKey: o }, s, a) => {
    i && i.setState({ [o]: a?.detail });
  });
};
bt(kh, Mh);
var Hh = {
  slide_in_down: [
    {
      transform: "translate3d(0, -100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  slide_out_down: [
    {
      transform: "translate3d(0, 0, 0)",
      offset: 0
    },
    {
      transform: "translate3d(0, 100%, 0)",
      offset: 0.99
    },
    {
      visibility: "hidden",
      offset: 1
    }
  ],
  slide_in_up: [
    {
      transform: "translate3d(0, 100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  pulse: [
    {
      transform: "scale3d(1, 1, 1)"
    },
    {
      transform: "scale3d(1.05, 1.05, 1.05)"
    },
    {
      transform: "scale3d(1, 1, 1)"
    }
  ]
};
var jh = "@appcues/animate";
var Fh = 500;
var Uh = "none";
var Xr = (t, e) => new Promise((n) => {
  const {
    keyframes: r,
    duration: i = Fh,
    iterations: o,
    effect: s,
    fill: a = Uh,
    easing: c = "linear"
  } = e, l = Hh[s] || r, v = {
    duration: i,
    iterations: o,
    fill: a,
    easing: c
  };
  if (!l) return;
  const f = t.animate(l, v);
  f?.addEventListener ? f.addEventListener("finish", n, { once: true }) : n();
});
var Bh = ({ addHook: t, registerAction: e }, n) => {
  t("step.postrender", ({ querySelector: r }) => {
    const { target: i } = n;
    if (!i) return;
    const o = r(i.selector);
    o.length !== 0 && Xr(o[0], n);
  }), e(
    "toggle",
    ({ toggleGroupId: r, target: i, animations: o }, { querySelector: s }) => {
      const a = s(i.selector);
      if (a.length === 0) return;
      const [c] = a, v = c.getAttribute(r) === o[0].id ? o[1] : o[0];
      Xr(c, v), v.id && c.setAttribute(r, v.id);
    }
  ), e("run", async (r, i) => {
    const { querySelector: o, getAction: s } = i, {
      toggleGroupId: a,
      target: c,
      animation: l,
      ignoreToggleGroup: v = false,
      onFinish: f = []
    } = r;
    if (!c) return;
    const u = o(c.selector);
    if (u.length === 0) return;
    const p = u[0], h = p.getAttribute(a);
    (!h || h === l.id) && !v || (await Xr(p, l ?? r), f.forEach((g) => {
      s(g.type)(g?.config ?? {}, i);
    }), v || p.setAttribute(a, l.id));
  });
};
bt(jh, Bh);
var Pa = {
  pixels: "px",
  percentage: "%"
};
function zh(t, e, n, r) {
  const i = Pa[n] || "px";
  switch (t) {
    case "left":
      return {
        left: 0,
        transform: `translateX(${e}${i})`,
        ...r && {
          right: "unset"
        }
      };
    case "center":
      return {
        left: "50%",
        transform: `translateX(calc(-50% + ${e}${i}))`,
        ...r && {
          right: "unset"
        }
      };
    default:
      return {
        right: 0,
        transform: `translateX(-${e}${i})`,
        ...r && {
          left: "unset"
        }
      };
  }
}
function qh(t, e, n, r) {
  const i = Pa[n] || "px";
  switch (t) {
    case "top":
      return {
        top: 0,
        transform: `translateY(${e}${i})`,
        ...r && {
          bottom: "unset"
        }
      };
    case "center":
      return {
        top: "50%",
        transform: `translateY(calc(-50% + ${e}${i}))`,
        ...r && {
          bottom: "unset"
        }
      };
    default:
      return {
        bottom: 0,
        transform: `translateY(-${e}${i})`,
        ...r && {
          top: "unset"
        }
      };
  }
}
var Vh = "@appcues/floating";
var Wh = ({ addHook: t }) => {
  t("step.begin", ({ getTraitConfig: e, updateStyle: n, updateRootStyle: r }) => {
    const {
      target: i,
      strategy: o = "fixed",
      xOffset: s = 0,
      yOffset: a = 0,
      xPosition: c = "left",
      yPosition: l = "top",
      placementUnit: v = "pixels",
      unsetOppositeDirection: f = false,
      applyToRoot: u = false
    } = e(), p = [
      zh(
        c,
        s,
        v,
        f
      ),
      qh(
        l,
        a,
        v,
        f
      )
    ].reduce((g, E) => {
      const { transform: S, ...y } = E;
      return S && (g.transform = g.transform ? `${g.transform} ${S}` : S), { ...g, ...y };
    }, {}), h = {
      position: o,
      ...p
    };
    if (u) {
      r(h, { forceUpdate: true });
      return;
    }
    n(i.selector, h);
  });
};
bt(Vh, Wh);
var Gh = "@appcues/dismissible";
function Qo(t) {
  return `_experience_dismissed_${t}`;
}
var Kh = ({ addHook: t, registerAction: e }, { strategy: n = "permanent" }) => {
  function r(i, o) {
    return n === "session" ? o().sessionStorage.getItem(Qo(i)) === "1" : false;
  }
  t(
    "experience.begin",
    ({ stopExperience: i, getExperienceId: o, getWindowReference: s }) => {
      r(o(), s) && i();
    }
  ), e(
    "dismiss",
    (i, { stopExperience: o, updateUserProfile: s, getExperienceId: a, getWindowReference: c }) => {
      const l = Qo(a());
      n === "session" ? c().sessionStorage.setItem(l, "1") : n === "permanent" && s({ [l]: "permanently_dismissed" }), o();
    }
  );
};
bt(Gh, Kh);
var Xh = "@appcues/experienceStyle";
var Yh = ({ addHook: t }) => {
  t("step.begin", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: true });
  }), t("step.container_change", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: true });
  }), t("step.end", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = Object.keys(n()).reduce((i, o) => (i[o] = null, i), {});
    e(r, { forceUpdate: true });
  });
};
bt(Xh, Yh);
var Zh = "@appcues/rootStyle";
var ts = ({ getTraitConfig: t, updateRootStyle: e }) => {
  const { forceUpdate: n = false, ...r } = t();
  e(r, { forceUpdate: n });
};
function Jh({ addHook: t }) {
  t("step.begin", ts), t("step.container_change", ts);
}
bt(Zh, Jh);
var Qh = "appcues:launchpad_close";
var tv = "appcues:launchpad_search";
var ev = "appcues:launchpad_search_error";
var nv = "appcues:launchpad_search_response";
var $i = function(t, e) {
  return window.addEventListener(t, e), function() {
    return window.removeEventListener(t, e);
  };
};
var rv = function(t) {
  return $i(Qh, t);
};
var iv = function(t, e, n) {
  var r = new CustomEvent(tv, {
    detail: {
      integrationId: t,
      query: e,
      experienceId: n
    }
  });
  window.dispatchEvent(r);
};
var ov = function(t, e) {
  return $i("".concat(nv, ":").concat(t), e);
};
var sv = function(t, e) {
  return $i("".concat(ev, ":").concat(t), e);
};
var av = "@appcues/sdk-middleware-events";
var cv = ({ addHook: t }, { onLaunchpadClose: e }) => {
  let n;
  t("step.begin", (r) => {
    n = rv(() => {
      e.forEach((i) => {
        r.getAction(i.type)?.(i.config, r);
      });
    });
  }), t("step.end", () => {
    n?.();
  });
};
bt(av, cv);
var lv = "@appcues/knowledge-base-integration";
var Yn = (t, { querySelector: e, reportError: n }) => {
  const r = e(t), i = r.length > 1, o = r.length === 0;
  return i && n(
    "The target element is duplicated, please provide a more specific selector"
  ), o && n("The target element is not found"), r[0];
};
var uv = ({ addHook: t, registerAction: e }, n) => {
  const { integrationConnected: r = false } = n;
  let i, o, s, a, c;
  const l = () => {
    r && o?.prev();
  }, v = (f) => {
    if (!r) return;
    const { integrationId: u } = n, { inputValue: p } = f.detail;
    s.setAttribute("searchTerm", p), s.setAttribute("state", "loading"), i.setAttribute("loading", true), a && (a.scrollTop = 0), o?.next(), iv(u, p, c);
  };
  t("step.begin", ({ getExperienceId: f }) => {
    c = f(), ov(c, (u) => {
      const p = u.detail, h = p.results?.length === 0 ? "empty" : "showing_results";
      s.setAttribute("state", h), s.setAttribute("results", JSON.stringify(p.results)), i.setAttribute("loading", false);
    }), sv(c, () => {
      s.setAttribute("state", "error"), i.setAttribute("loading", false);
    });
  }), t("step.end", () => {
    i?.removeEventListener("onSearch", v), i?.removeEventListener("onCancel", l);
  }), e("bindListeners", (f, u) => {
    const { navigation: p } = n;
    (!o || !i) && (o = Yn(p.selector, u), i = Yn("appcues-search-header", u), s = Yn("appcues-search-results", u), a = Yn("#launchpad-container", u), i?.addEventListener("onSearch", v), i?.addEventListener("onCancel", l));
  });
};
bt(lv, uv);
var fv = "@appcues/sequential";
var dv = ({ addHook: t, registerAction: e }) => {
  let n;
  const r = (s, { steps: a }) => {
    n !== 0 && a[n].stop(() => {
      n -= 1, a[n].start();
    });
  }, i = (s, { steps: a }) => {
    if (n === a.length - 1) {
      a[n].stop();
      return;
    }
    a[n].stop(() => {
      n += 1, a[n].start();
    });
  }, o = (s, { step: a, steps: c }) => {
    a.stop(() => {
      const l = c.findIndex(
        (v) => v.getConfig()?.id === s.stepId
      );
      l !== -1 && (n = l, c[n].start());
    });
  };
  t("experience.begin", ({ steps: s }) => {
    n = 0, s[n].start();
  }), e("next", i), e("prev", r), e("goTo", o);
};
bt(fv, dv);
var ki = "appcues-cutout-backdrop";
var es = "appcues-custom-backdrop";
var pv = "hard";
var hi = "apc-spotlight";
var hv = `
  dialog { all: unset; }
  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }
  :-internal-dialog-in-top-layer { all: unset; }
`;
var vv = ({ backdropBlur: t, backdropColor: e }) => ({
  ...t && { "--backdrop-blur": t },
  ...e && { "--backdrop-color": e }
});
var gv = ({
  getWindowReference: t,
  backdropZIndex: e,
  backdropBlur: n,
  backdropColor: r
}) => {
  if (t().document.querySelector(
    `#${es}`
  ))
    return null;
  const o = t().document.createElement("div");
  return o.id = es, o.style.cssText = `
    z-index: ${e};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, o;
};
var yn = 1500;
var ns = 0.67;
var yv = (t) => {
  Object.assign(t.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    pointerEvents: "none"
  });
};
var Ia = (t, e) => {
  const { top: n, left: r, width: i, height: o } = e;
  Object.assign(t.style, {
    position: "absolute",
    top: `${n - yn}px`,
    left: `${r - yn}px`,
    height: `${o ? o + 2 * yn : 0}px`,
    width: `${i ? i + 2 * yn : 0}px`,
    boxSizing: "border-box",
    border: `${yn}px solid transparent`,
    pointerEvents: "none",
    borderImage: `radial-gradient(transparent 2%, rgba(0,0,0,${ns}) 28%) 49% 49% 49% 49%`,
    boxShadow: `0 0 0 2500px rgba(0,0,0,${ns})`
  });
};
var mv = ({ document: t, rect: e, zIndex: n }) => {
  const r = t.createElement("div");
  r.id = ki, yv(r), r.style.zIndex = n;
  const i = t.createElement("div");
  return i.className = hi, Ia(i, e), r.append(i), r;
};
var Ev = ({ container: t, rect: e }) => {
  const n = t.firstElementChild;
  n && Ia(n, e);
};
var Sv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: mv,
  update: Ev
}, Symbol.toStringTag, { value: "Module" }));
var Da = 0.5;
var bv = (t) => {
  Object.assign(t.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    pointerEvents: "none"
  });
};
var La = (t, e, n) => {
  const { top: r, left: i, width: o, height: s } = n;
  Object.assign(t.style, {
    position: "absolute",
    top: `${r}px`,
    left: `${i}px`,
    width: `${o}px`,
    height: `${s}px`,
    overflow: "hidden",
    pointerEvents: "none"
  }), Object.assign(e.style, {
    position: "relative",
    width: `${o}px`,
    height: `${s}px`,
    boxShadow: `0px 0px 0px 2000px rgba(0,0,0,${Da})`,
    borderRadius: "0px",
    pointerEvents: "none"
  });
};
var Zn = (t, e, n, r, i) => {
  Object.assign(t.style, {
    position: "absolute",
    top: `${e}px`,
    left: `${n}px`,
    width: `${r}px`,
    height: `${i}px`,
    background: `rgba(0,0,0,${Da})`,
    pointerEvents: "all"
  });
};
var $a = ([t, e, n, r], i, o) => {
  const { top: s, left: a, right: c, bottom: l, width: v } = i, f = o.innerWidth, u = o.innerHeight;
  Zn(t, 0, a, v, Math.max(0, s)), Zn(e, 0, c, Math.max(0, f - c), u), Zn(n, l, a, v, Math.max(0, u - l)), Zn(r, 0, 0, Math.max(0, a), u);
};
var wv = ({ document: t, win: e, rect: n, zIndex: r }) => {
  const i = t.createElement("div");
  i.id = ki, bv(i), i.style.zIndex = r;
  const o = t.createElement("div"), s = t.createElement("div");
  s.className = hi, La(o, s, n), o.append(s), i.append(o);
  const a = ["top", "right", "bottom", "left"].map((c) => {
    const l = t.createElement("div");
    return l.className = hi, l.setAttribute("aria-label", `${c}-panel`), i.append(l), l;
  });
  return $a(a, n, e), i;
};
var xv = ({ container: t, win: e, rect: n }) => {
  const r = t.children[0], i = r?.firstElementChild;
  r && i && La(r, i, n);
  const o = [...t.children].slice(1);
  o.length === 4 && $a(o, n, e);
};
var _v = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: wv,
  update: xv
}, Symbol.toStringTag, { value: "Module" }));
var Mi = {
  soft: Sv,
  hard: _v
};
var Tv = (t) => t in Mi;
var Rv = ({
  getWindowReference: t,
  target: e,
  backdropType: n,
  zIndex: r
}) => {
  const i = t();
  let o;
  try {
    o = i.document.querySelector(e);
  } catch {
    o = null;
  }
  if (!o) return null;
  const s = o.getBoundingClientRect(), a = { document: i.document, win: i, rect: s, zIndex: r };
  return Mi[n].build(a);
};
var Cv = ({
  container: t,
  getWindowReference: e,
  target: n,
  backdropType: r
}) => {
  const i = e();
  let o;
  try {
    o = i.document.querySelector(n);
  } catch {
    o = null;
  }
  if (!o || !t) return;
  const s = o.getBoundingClientRect();
  Mi[r].update({ container: t, win: i, rect: s });
};
var Ov = /* @__PURE__ */ new Set([
  Nn,
  Pn
]);
var Av = (t) => t.id === ki || Ov.has(t.tagName);
var Nv = (t, e) => {
  if (!e) return null;
  try {
    return t.querySelector(e);
  } catch {
    return null;
  }
};
var Pv = (t, { targetSelector: e } = {}) => {
  const { body: n } = t.document, r = /* @__PURE__ */ new Set(), i = Nv(n, e);
  for (const o of n.children)
    !Av(o) && !o.inert && !o.contains(i) && (o.inert = true, r.add(o));
  return () => {
    for (const o of r)
      o.inert = false;
  };
};
var Iv = "@appcues/dialog";
var Dv = ({ addHook: t }, e) => {
  const {
    backdrop: n,
    variables: r,
    customBackdrop: i,
    target: o,
    autoFocus: s = true
  } = e, { dialogZIndex: a, backdropZIndex: c, backdropBlur: l, backdropColor: v } = r || {};
  let f, u, p, h, g, E, S;
  const y = () => {
    g && E && (g.removeEventListener("scroll", E, true), g.removeEventListener("resize", E));
  };
  if (n === true && !i && !o) {
    const b = ({ getTraitConfig: _, updateRootStyle: w }) => {
      const { variables: A } = _();
      w(vv(A || {}), {
        forceUpdate: true
      });
    };
    t("step.begin", b), t("step.container_change", b);
  }
  t("step.postrender", ({ step: b, getWindowReference: _ }) => {
    if ([u] = b.querySelector("dialog") ?? [], u) {
      n === true && i && (p?.remove(), p = gv({
        getWindowReference: _,
        backdropZIndex: c,
        backdropBlur: l,
        backdropColor: v
      }), p && _().document.body.append(p)), n === true && !i && !o && (f?.remove(), f = _().document.createElement("style"), f.textContent = hv, u.prepend(f)), u.style.zIndex = a, u.removeAttribute("autofocus");
      const w = n === true && !i && !o ? "showModal" : "show", A = _(), O = o ? { x: A.scrollX, y: A.scrollY } : null, C = u.open;
      u[w](), O && (A.scrollX !== O.x || A.scrollY !== O.y) && A.scrollTo(O.x, O.y), w === "show" && s && !C && u.focus({ preventScroll: true });
    }
    o && Tv(n) && (y(), S?.(), h?.remove(), g = _(), h = Rv({
      getWindowReference: _,
      target: o,
      backdropType: n,
      zIndex: (a ?? 2) - 1
    }), h && (g.document.body.append(h), E = () => Cv({
      container: h,
      getWindowReference: _,
      target: o,
      backdropType: n
    }), g.addEventListener("scroll", E, true), g.addEventListener("resize", E), n === pv && (S = Pv(g, {
      targetSelector: o
    }))));
  }), t("step.end", () => {
    u?.close(), f?.remove(), p?.remove(), h?.remove(), y(), S?.();
  });
};
bt(Iv, Dv);
var Lv = "@appcues/experienceTheme";
var $v = ({ addHook: t }) => {
  let e = null;
  function n({
    getContainer: i,
    getExperienceId: o,
    getWindowReference: s,
    getTraitConfig: a
  }) {
    const { css: c } = a(), l = i();
    if (!c || e && e.parentNode === l)
      return;
    const v = o();
    l && (e = s().document.createElement("style"), e.id = `appcues-experience-style-${v}`, e.textContent = c, l.prepend(e));
  }
  function r() {
    e && (e.remove(), e = null);
  }
  t("step.begin", n), t("experience.end", r);
};
bt(Lv, $v);
var kv = "@appcues/scroll-into-view";
var Mv = ({ addHook: t }) => {
  let e = false;
  t(
    "step.postrender",
    ({ getTraitConfig: n, querySelector: r, getWindowReference: i }) => {
      if (e) return;
      const {
        target: o,
        behavior: s = "smooth",
        block: a = "nearest",
        inline: c = "nearest"
      } = n();
      if (!o?.selector) return;
      const l = r(o.selector);
      if (l.length === 0) return;
      const v = l[0], { innerWidth: f, innerHeight: u } = i(), { top: p, left: h, bottom: g, right: E } = v.getBoundingClientRect();
      if (p >= 0 && h >= 0 && g <= u && E <= f) {
        e = true;
        return;
      }
      v.scrollIntoView({ behavior: s, block: a, inline: c }), e = true;
    }
  ), t("step.end", () => {
    e = false;
  });
};
bt(kv, Mv);
var Hv = (t) => class extends t.HTMLElement {
  constructor() {
    super();
    const n = this.ownerDocument || t.document;
    this.hideContentStyles = n.createElement("style"), this.hideContentStyles.innerHTML = `
        * {
          visibility: hidden;
        }
      `;
    try {
      this.attachShadow({ mode: "open" });
    } catch {
    }
    this.webComponentStyles = n.createElement("style"), this.webComponentStyles.innerHTML = `
        :host {
          all: initial;
          font-family: inherit;
          display: inline;
        }
      `;
  }
  async connectedCallback() {
    this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await qs(this), this.shadowRoot.prepend(this.webComponentStyles), this.hideContentStyles.remove();
  }
};
var Yr = /* @__PURE__ */ new WeakMap();
var jv = (t = () => window) => {
  const e = t();
  if (Yr.has(e))
    return Yr.get(e);
  if (!e.customElements.get(Tn)) {
    const r = Hv(e);
    e.customElements.define(Tn, r);
  }
  const n = e.customElements.whenDefined(Tn);
  return Yr.set(e, n), n;
};
var Fv = false;
function Bv({
  runningExperiences: t = /* @__PURE__ */ new Map(),
  sendEvent: e = () => {
  },
  sendCustomEvent: n = () => {
  },
  showFlow: r = () => {
  },
  updateUserProfile: i = () => {
  },
  createRenderListener: o = Od,
  vNodeHandlers: s = Fd,
  accessibilityHandlers: a = zd,
  getWindowReference: c = () => window,
  apiOverrides: l = {}
} = {}) {
  Cu(l);
  const v = /* @__PURE__ */ new Map(), f = {
    sendEvent: e,
    sendCustomEvent: n,
    showFlow: r,
    updateUserProfile: i,
    createRenderListener: o,
    vNodeHandlers: s,
    accessibilityHandlers: a,
    getWindowReference: c,
    apiOverrides: l
  }, u = (_) => _ ? f?.[_] ? f[_] : () => {
    throw new Error(`can't find external dependency called ${_}`);
  } : f, p = ({ reason: _ = Ee.NAVIGATION } = {}) => {
    t.forEach((w) => {
      w.experienceService.send({ type: Ce, reason: _ }), w.experienceService.subscribe((A) => {
        A.matches("end-final") && w.experienceService.stop();
      });
    }), t.clear();
  }, h = (_, { reason: w = Ee.NAVIGATION } = {}) => {
    t.has(_) && (t.get(_).experienceService.send({ type: Ce, reason: w }), t.delete(_));
  };
  return {
    registerAction: ce,
    registerTrait: bt,
    show: async (_) => {
      jv(c), await c().customElements.whenDefined(Tn);
      const w = nr(
        nr(
          _,
          "traits",
          (O) => (O ?? []).map((C, I) => ({
            ...C,
            id: C.id || `${C.type}:${I}`
          }))
        ),
        "steps",
        (O) => (O ?? []).map(
          (C) => nr(
            C,
            "traits",
            (I) => (I ?? []).map((D, $) => ({
              ...D,
              id: D.id || `${D.type}:${$}`
            }))
          )
        )
      ), A = t.get(_.id)?.experienceService ?? ws(Rd(w, u), {
        devTools: Fv
      }).start();
      A.send({
        type: so,
        experience: w
      }), t.set(_.id, {
        experienceService: A,
        experience: w
      });
    },
    stopAll: p,
    stop: h,
    pause: (_) => {
      if (v.get(_)) return;
      const A = t.get(_);
      A && (h(_), v.set(_, {
        experienceService: A.experienceService,
        experience: A.experience
      }));
    },
    resume: (_) => {
      const w = v.get(_);
      w && (w.experienceService.send({ type: so }), t.set(_, {
        experienceService: w.experienceService,
        experience: w.experience
      }), v.delete(_));
    },
    getRunningExperiences: () => [...t].map(([, { experience: _ }]) => _),
    isExperiencePaused: (_) => v.has(_)
  };
}

// src/components/PreviewPane/WebPreviewFrame.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var WebPreviewFrame = ({
  title,
  experience
}) => {
  const [sdk, setSdk] = useState(null);
  const iframeRef = useCallback((node) => {
    if (node === null) return;
    const injectedDeps = {
      sendEvent: () => {
      },
      updateUserProfile: () => {
      },
      showFlow: () => {
      },
      getWindowReference: () => node.contentWindow
    };
    setSdk(Bv(injectedDeps));
  }, []);
  useEffect2(() => {
    sdk?.show(experience);
  }, [sdk, experience]);
  return /* @__PURE__ */ jsxs2(Preview.Wrapper, { children: [
    /* @__PURE__ */ jsx2(
      Preview.Frame,
      {
        ref: iframeRef,
        title,
        scrolling: "no",
        src: "about:blank"
      }
    ),
    title && /* @__PURE__ */ jsx2(Preview.Title, { children: title })
  ] });
};

// src/components/PreviewPane/PreviewFrame.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var PreviewFrame2 = ({
  theme,
  platform,
  component,
  title,
  colorMode = "light"
}) => {
  if (platform === "mobile") {
    const mobileExperience = component ? wrapMobileComponentPreview(component) : makeMobileExperience(theme);
    return /* @__PURE__ */ jsx3(
      MobilePreviewFrame,
      {
        title,
        mobileExperience,
        colorMode
      }
    );
  }
  const webExperience = component?.block ? wrapWebComponentPreview(component.block) : makeWebExperience(theme);
  return /* @__PURE__ */ jsx3(WebPreviewFrame, { title, experience: webExperience });
};

// src/components/PreviewPane/PreviewPane.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var PreviewPane = ({
  platform,
  theme
}) => {
  const [colorMode, setColorMode] = useState2("light");
  return /* @__PURE__ */ jsxs3(Panel, { colorMode, "data-theme": colorMode, children: [
    /* @__PURE__ */ jsx4(ControlBar, { children: /* @__PURE__ */ jsxs3(
      SegmentedControlGroup,
      {
        iconOnly: true,
        value: colorMode,
        size: "small",
        "aria-label": "Preview mode",
        onValueChange: (value) => setColorMode(value),
        children: [
          /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "light", children: /* @__PURE__ */ jsx4(Icon, { icon: import_faSun.faSun }) }),
          /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "dark", children: /* @__PURE__ */ jsx4(Icon, { icon: import_faMoon.faMoon }) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx4(PreviewFrame2, { theme, platform, colorMode })
  ] });
};

// src/components/DonateComponentModal/DonateComponentModal.styled.ts
import styled2 from "styled-components";
var Form = styled2.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large, 24px);
`;
var FormField = styled2.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
`;
var Preview2 = styled2.div`
  display: flex;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-small);

  > div:nth-child(n + 2)::before {
    content: '';
    position: absolute;
    top: var(--spacing-regular);
    bottom: var(--spacing-regular);
    left: 0;
    width: 1px;
    background-color: var(--border-default);
  }
`;

// src/components/DonateComponentModal/DonateComponentModal.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var makeUpdatedComponentDefinition = (base, delta) => {
  const result = { ...base };
  Object.entries(delta).forEach(([key, value]) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      result[key] = makeUpdatedComponentDefinition(result[key] || {}, value);
    } else if (value === void 0) {
      delete result[key];
    } else {
      result[key] = delta[key];
    }
  });
  return result;
};
var DonateComponentModal = ({
  platform,
  onSave
}) => {
  const {
    container,
    theme,
    updateTheme,
    donatedComponent,
    setDonatedComponent
  } = useThemeEditor();
  const [componentName, setComponentName] = useState3("");
  const [saveState, setSaveState] = useState3(
    "idle"
  );
  const { isCreate, type, existingPath } = donatedComponent ?? {};
  const existingName = existingPath?.split(".").pop();
  const path = isCreate ? `${type}.${camelCase(componentName)}` : existingPath;
  useEffect3(() => {
    const initialName = existingName ? `${existingName.split(".").pop()} 2` : void 0;
    setComponentName(initialName ?? "");
    setSaveState("idle");
  }, [existingName]);
  useEffect3(() => {
    if (saveState === "pending") {
      onSave({ donatedVariantName: path });
      setSaveState("saving");
    }
  }, [saveState, onSave, path]);
  if (!donatedComponent || !theme) return null;
  const unavailableNames = Object.keys(
    theme.content.components[donatedComponent.type] ?? {}
  );
  const showErrors = saveState === "idle";
  const nameIsError = showErrors && unavailableNames.includes(camelCase(componentName));
  const handleSave = () => {
    const existingComponent = get2(theme.content.components, existingPath) ?? {};
    const updatedComponent = makeUpdatedComponentDefinition(
      existingComponent,
      donatedComponent.componentDefinition
    );
    updateTheme(`content.components.${path}`, updatedComponent);
    setSaveState("pending");
  };
  return /* @__PURE__ */ jsx5(
    Modal,
    {
      container,
      open: donatedComponent !== null,
      onOpenChange: () => setDonatedComponent(null),
      children: /* @__PURE__ */ jsxs4(ModalContent, { children: [
        /* @__PURE__ */ jsx5(ModalHeader, { children: /* @__PURE__ */ jsxs4(ModalTitle, { children: [
          /* @__PURE__ */ jsx5(Icon2, { icon: isCreate ? import_faFloppyDisk.faFloppyDisk : import_faArrowsRotate.faArrowsRotate }),
          isCreate ? "Save as new variant" : `Update \u201C${startCase(existingName)}\u201D`
        ] }) }),
        /* @__PURE__ */ jsx5(ModalDescription, { children: /* @__PURE__ */ jsxs4(Form, { "aria-label": "save component form", role: "form", "data-theme": "light", children: [
          isCreate && /* @__PURE__ */ jsxs4(Fragment, { children: [
            "Save your changes as a new variant so it can be reused in flows that use the theme \u201C",
            theme.name,
            "\u201D.",
            /* @__PURE__ */ jsxs4(FormItem, { children: [
              /* @__PURE__ */ jsx5(FormLabel, { htmlFor: "name", children: "Variant name" }),
              /* @__PURE__ */ jsx5(FormControl, { children: /* @__PURE__ */ jsx5(
                Input,
                {
                  id: "name",
                  defaultValue: componentName,
                  onChange: (event) => setComponentName(event.target.value),
                  placeholder: "Component name"
                }
              ) }),
              nameIsError && /* @__PURE__ */ jsxs4(FormMessage, { state: "error", children: [
                "\u201C",
                componentName,
                "\u201D already exists."
              ] })
            ] })
          ] }),
          !isCreate && /* @__PURE__ */ jsxs4(Alert, { variant: "warning", children: [
            /* @__PURE__ */ jsx5(Icon2, { icon: import_faCircleExclamation.faCircleExclamation, size: "small" }),
            /* @__PURE__ */ jsx5(AlertDescription, { children: "This updated style will immediately be applied to all flows that use this variant." })
          ] }),
          /* @__PURE__ */ jsxs4(Preview2, { children: [
            donatedComponent.originalReferenceModel && /* @__PURE__ */ jsx5(
              PreviewFrame2,
              {
                theme,
                platform,
                title: "Original",
                component: donatedComponent.originalReferenceModel
              }
            ),
            /* @__PURE__ */ jsx5(
              PreviewFrame2,
              {
                theme,
                platform,
                title: isCreate ? "Preview" : "Updated",
                component: donatedComponent.referenceModel
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsxs4(ModalFooter, { children: [
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "outline",
              onClick: () => setDonatedComponent(null),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "primary",
              disabled: isCreate && !(componentName && !nameIsError),
              onClick: handleSave,
              children: isCreate ? "Save" : "Update variant"
            }
          )
        ] })
      ] })
    }
  );
};

// src/components/ThemeModal/ThemeModal.tsx
var import_faSwatchbook = __toESM(require_faSwatchbook());
import {
  Modal as Modal2,
  ModalContent as ModalContent2,
  ModalHeader as ModalHeader2,
  ModalTitle as ModalTitle2,
  ModalFooter as ModalFooter2,
  Icon as Icon3,
  Button as Button2
} from "@appcues/sonar-builder";

// src/components/StyleSettings/StyleSettings.tsx
import { Accordion } from "@appcues/sonar-builder";

// src/components/StyleSettings/OverviewSection.tsx
import { useState as useState4 } from "react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Input as Input2,
  Label,
  Switch
} from "@appcues/sonar-builder";

// src/lib/color-handler.ts
var updateToDarkMode = (enabled, components) => {
  const processValue = (value) => {
    if (!value || typeof value !== "object") {
      return value;
    }
    if ("light" in value && typeof value.light === "string") {
      if (!enabled) {
        const { dark, ...rest } = value;
        return rest;
      }
      return {
        ...value,
        dark: value.light.startsWith("{colors.") ? value.light.replace("{colors.", "{colors.dark.") : value.light
      };
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, processValue(val)])
    );
  };
  return processValue(components);
};

// src/components/StyleSettings/StyleSettings.styled.ts
import styled3 from "styled-components";
var Controls = styled3.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing) * 3); /* 12px spacing between accordions */
`;
var FieldSet = styled3.fieldset`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--spacing-small);
  margin: 0;
  padding: 0;
  border: none;
  > label {
    min-width: 40%;
    flex: 1;
  }
`;

// src/components/StyleSettings/OverviewSection.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var OverviewSection = ({ theme }) => {
  const { updateTheme } = useThemeEditor();
  const { name: themeName, content } = theme;
  const { meta, components } = content;
  const [name, setName] = useState4(themeName);
  const [darkMode, setDarkMode] = useState4(meta?.darkMode ?? false);
  const handleNameChange = (event) => {
    const { value } = event.target;
    setName(value);
    updateTheme("", { name: value });
  };
  const handleDarkModeChange = (checked) => {
    setDarkMode(checked);
    updateTheme("content", {
      meta: {
        ...meta,
        darkMode: checked
      },
      components: updateToDarkMode(checked, components)
    });
  };
  return /* @__PURE__ */ jsxs5(AccordionItem, { value: "overview", children: [
    /* @__PURE__ */ jsx6(AccordionTrigger, { children: "Theme settings" }),
    /* @__PURE__ */ jsx6(AccordionContent, { children: /* @__PURE__ */ jsxs5(Controls, { children: [
      /* @__PURE__ */ jsxs5(FieldSet, { children: [
        /* @__PURE__ */ jsx6(Label, { htmlFor: "name", children: "Name" }),
        /* @__PURE__ */ jsx6(
          Input2,
          {
            size: "small",
            id: "name",
            defaultValue: name,
            onChange: handleNameChange,
            placeholder: "Theme name"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs5(FieldSet, { children: [
        /* @__PURE__ */ jsx6(Label, { htmlFor: "dark-mode", children: "Enable dark mode" }),
        /* @__PURE__ */ jsx6(
          Switch,
          {
            id: "dark-mode",
            checked: darkMode,
            onCheckedChange: handleDarkModeChange
          }
        )
      ] })
    ] }) })
  ] });
};

// src/components/StyleSettings/ColorSection.tsx
import startCase2 from "lodash.startcase";
import { get as get3 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem2,
  AccordionTrigger as AccordionTrigger2,
  AccordionContent as AccordionContent2,
  Label as Label2
} from "@appcues/sonar-builder";

// src/components/StyleSettings/ColorTokenInput.tsx
import { useState as useState5 } from "react";
import { Input as Input3 } from "@appcues/sonar-builder";
import { jsx as jsx7 } from "react/jsx-runtime";
var ColorTokenInput = ({ path, token }) => {
  const { updateTheme, container } = useThemeEditor();
  const [color, setColor] = useState5(token?.$value ?? "");
  const handleChange = (event) => {
    const { value } = event.target;
    setColor(value);
    updateTheme(path, {
      ...token,
      $value: value
    });
  };
  return /* @__PURE__ */ jsx7(
    Input3,
    {
      id: path,
      type: "text",
      value: color,
      onChange: handleChange,
      size: "small",
      container
    }
  );
};

// src/components/StyleSettings/ColorSection.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ColorSection = ({ tokens, showDarkMode }) => {
  const controls = ["foreground", "background", "primary"].map((field) => ({
    light: {
      path: `content.tokens.colors.${field}`,
      label: startCase2(field),
      token: get3(tokens, `colors.${field}`)
    },
    ...showDarkMode && {
      dark: {
        path: `content.tokens.colors.dark.${field}`,
        token: get3(tokens, `colors.dark.${field}`)
      }
    }
  }));
  return /* @__PURE__ */ jsxs6(AccordionItem2, { value: "color", children: [
    /* @__PURE__ */ jsx8(AccordionTrigger2, { children: "Colors" }),
    /* @__PURE__ */ jsx8(AccordionContent2, { children: /* @__PURE__ */ jsx8(Controls, { children: controls.map(({ light, dark }) => /* @__PURE__ */ jsxs6(FieldSet, { children: [
      /* @__PURE__ */ jsx8(Label2, { htmlFor: light.path, children: light.label }),
      /* @__PURE__ */ jsx8(ColorTokenInput, { path: light.path, token: light.token }),
      dark && /* @__PURE__ */ jsx8(ColorTokenInput, { path: dark.path, token: dark.token })
    ] }, light.path)) }) })
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { useState as useState7 } from "react";
import { get as get5 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem3,
  AccordionTrigger as AccordionTrigger3,
  AccordionContent as AccordionContent3
} from "@appcues/sonar-builder";

// src/components/RangeInput.tsx
import styled4 from "styled-components";
import { Label as Label3, Input as Input4 } from "@appcues/sonar-builder";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var Container = styled4.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--spacing-small);
`;
var RangeInput = ({
  label,
  value,
  min,
  max,
  onValueChange
}) => {
  return /* @__PURE__ */ jsxs7(Container, { children: [
    /* @__PURE__ */ jsx9(Label3, { children: label }),
    /* @__PURE__ */ jsx9(
      Input4,
      {
        type: "number",
        size: "small",
        min,
        max,
        value,
        onChange: (event) => onValueChange(Number(event.target.value))
      }
    )
  ] });
};

// src/lib/basic-theme-tokens.ts
import { get as get4 } from "object-path-immutable";

// src/types.ts
var TOKEN_EXTENSIONS = {
  FONT: "com.appcues.theme.font",
  PRESET: "com.appcues.theme.preset"
};
var PRESET_SIZES = ["S", "M", "L"];

// src/lib/basic-theme-tokens.ts
var PRESET_FONT_SIZES = {
  S: [12, 14, 18, 14, 16, 18, 20, 24],
  M: [14, 16, 22, 16, 18, 20, 24, 32],
  L: [16, 18, 24, 18, 20, 22, 26, 34]
};
var PRESET_SPACING = {
  S: [0, 4, 6, 8, 10, 12],
  M: [0, 8, 12, 16, 20, 24],
  L: [0, 12, 18, 24, 30, 36]
};
var currentFontSize = (tokens) => {
  return get4(tokens, ["font", "size", "$extensions", TOKEN_EXTENSIONS.PRESET]);
};
var currentCornerRadius = (tokens) => Number.parseFloat(get4(tokens, "parts.container.corner-radius.$value"));
var currentSpacing = (tokens) => {
  return get4(tokens, [
    "dimensions",
    "unit",
    "$extensions",
    TOKEN_EXTENSIONS.PRESET
  ]);
};
var presetFontSizes = (size) => {
  const [small, regular, large, h5, h4, h3, h2, h1] = PRESET_FONT_SIZES[size];
  return {
    $type: "dimension",
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    small: { $value: `${small}px` },
    regular: { $value: `${regular}px` },
    large: { $value: `${large}px` },
    h5: { $value: `${h5}px` },
    h4: { $value: `${h4}px` },
    h3: { $value: `${h3}px` },
    h2: { $value: `${h2}px` },
    h1: { $value: `${h1}px` }
  };
};
var presetSpacing = (size) => ({
  $type: "dimension",
  unit: {
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    ...Object.fromEntries(
      PRESET_SPACING[size].map((value, i) => [
        i.toString(),
        { $value: `${value}px` }
      ])
    )
  }
});

// src/components/FontFamilySelect.tsx
import { useState as useState6 } from "react";
import startCase3 from "lodash.startcase";
import {
  Label as Label4,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectPortal,
  SelectItem
} from "@appcues/sonar-builder";
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var SYSTEM_FONT_MAPPING = {
  "System Sans-serif": "System Default",
  "System Serif": "System Serif",
  "System Monospaced": "System Monospaced",
  "System Rounded": "System Rounded"
};
var systemFontMapping = (fontName) => ({
  ultralight: `${fontName} Ultralight`,
  thin: `${fontName} Thin`,
  light: `${fontName} Light`,
  regular: `${fontName} Regular`,
  medium: `${fontName} Medium`,
  semibold: `${fontName} Semibold`,
  bold: `${fontName} Bold`,
  heavy: `${fontName} Heavy`,
  black: `${fontName} Black`
});
var FontFamilySelect = ({
  path,
  label = startCase3(path.split(".").pop()),
  token
}) => {
  const { updateTheme, container } = useThemeEditor();
  const [fontFamily, setFontFamily] = useState6(token?.$value ?? "");
  const handleFontFamilyChange = (value) => {
    setFontFamily(value);
    const systemFontName = SYSTEM_FONT_MAPPING[value];
    updateTheme(path, {
      $value: value,
      $extensions: {
        [TOKEN_EXTENSIONS.FONT]: {
          mobile: systemFontMapping(systemFontName)
        }
      }
    });
  };
  return /* @__PURE__ */ jsxs8(Fragment2, { children: [
    /* @__PURE__ */ jsx10(Label4, { htmlFor: "font-family", children: label }),
    /* @__PURE__ */ jsxs8(
      Select,
      {
        name: "font-family",
        defaultValue: fontFamily,
        onValueChange: handleFontFamilyChange,
        children: [
          /* @__PURE__ */ jsx10(SelectTrigger, { id: "font-family", size: "small", children: /* @__PURE__ */ jsx10(SelectValue, { placeholder: "Select one" }) }),
          /* @__PURE__ */ jsx10(SelectPortal, { container, children: /* @__PURE__ */ jsxs8(SelectContent, { children: [
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Sans-serif", children: "System Sans-serif" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Serif", children: "System Serif" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Monospaced", children: "System Monospaced" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Rounded", children: "System Rounded" })
          ] }) })
        ]
      }
    )
  ] });
};

// src/components/PresetSizeControl.tsx
import {
  Label as Label5,
  SegmentedControlGroup as SegmentedControlGroup2,
  SegmentedControlGroupItem as SegmentedControlGroupItem2
} from "@appcues/sonar-builder";
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var PresetSizeControl = ({
  label,
  value,
  onChange
}) => {
  return /* @__PURE__ */ jsxs9(Fragment3, { children: [
    /* @__PURE__ */ jsx11(Label5, { children: label }),
    /* @__PURE__ */ jsx11(
      SegmentedControlGroup2,
      {
        size: "small",
        value,
        "aria-label": label,
        onValueChange: onChange,
        children: PRESET_SIZES.map((size) => /* @__PURE__ */ jsx11(SegmentedControlGroupItem2, { value: size, children: size }, size))
      }
    )
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var InterfaceSection = ({ tokens }) => {
  const { updateTheme } = useThemeEditor();
  const [fontSize, setFontSize] = useState7(currentFontSize(tokens));
  const [cornerRadius, setCornerRadius] = useState7(currentCornerRadius(tokens));
  const [spacing, setSpacing] = useState7(currentSpacing(tokens));
  const handleFontSizeChange = (value) => {
    setFontSize(value);
    updateTheme("content.tokens.font.size", presetFontSizes(value));
  };
  const handleCornerRadiusChange = (value) => {
    setCornerRadius(value);
    updateTheme("content.tokens.parts.container.corner-radius", {
      $value: `${value}px`
    });
  };
  const handleSpacingChange = (value) => {
    setSpacing(value);
    updateTheme("content.tokens.dimensions", presetSpacing(value));
  };
  return /* @__PURE__ */ jsxs10(AccordionItem3, { value: "interface", children: [
    /* @__PURE__ */ jsx12(AccordionTrigger3, { children: "Interface" }),
    /* @__PURE__ */ jsx12(AccordionContent3, { children: /* @__PURE__ */ jsxs10(Controls, { children: [
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        FontFamilySelect,
        {
          path: "content.tokens.font.family.base",
          label: "Font family",
          token: get5(tokens, "font.family.base")
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        PresetSizeControl,
        {
          label: "Font size",
          value: fontSize,
          onChange: handleFontSizeChange
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        RangeInput,
        {
          label: "Corner radius",
          value: cornerRadius,
          min: 0,
          max: 100,
          onValueChange: handleCornerRadiusChange
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        PresetSizeControl,
        {
          label: "Spacing",
          value: spacing,
          onChange: handleSpacingChange
        }
      ) })
    ] }) })
  ] });
};

// src/components/StyleSettings/StyleSettings.tsx
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var StyleSettings = ({ theme }) => {
  return /* @__PURE__ */ jsxs11(
    Accordion,
    {
      defaultValue: ["overview", "color", "interface"],
      type: "multiple",
      children: [
        /* @__PURE__ */ jsx13(OverviewSection, { theme }),
        /* @__PURE__ */ jsx13(
          ColorSection,
          {
            tokens: theme.content.tokens,
            showDarkMode: theme.content.meta?.darkMode ?? false
          }
        ),
        /* @__PURE__ */ jsx13(InterfaceSection, { tokens: theme.content.tokens })
      ]
    }
  );
};

// src/components/ThemeModal/ThemeModal.styled.ts
import styled5 from "styled-components";
var Wrapper = styled5.div`
  display: flex;
  gap: var(--spacing-small);
  padding: var(--spacing-regular);
  min-height: 500px;
`;
var Settings = styled5.div`
  width: 336px;
  overflow-y: auto;
`;
var Preview3 = styled5.div`
  min-width: 336px;
  flex: 1;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-x-small);
  overflow: hidden;
`;

// src/components/ThemeModal/ThemeModal.tsx
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var ThemeModal = ({ platform, onSave }) => {
  const { theme, container, isEditorOpen, setIsEditorOpen } = useThemeEditor();
  const handleClose = () => setIsEditorOpen(false);
  if (!theme) return null;
  return /* @__PURE__ */ jsx14(
    Modal2,
    {
      open: isEditorOpen,
      onOpenChange: () => setIsEditorOpen(false),
      container,
      children: /* @__PURE__ */ jsxs12(ModalContent2, { size: "large", children: [
        /* @__PURE__ */ jsx14(ModalHeader2, { children: /* @__PURE__ */ jsxs12(ModalTitle2, { children: [
          /* @__PURE__ */ jsx14(Icon3, { icon: import_faSwatchbook.faSwatchbook }),
          "Edit Theme \u201C",
          theme.name,
          "\u201D"
        ] }) }),
        /* @__PURE__ */ jsxs12(Wrapper, { "data-theme": "light", children: [
          /* @__PURE__ */ jsx14(Settings, { children: /* @__PURE__ */ jsx14(StyleSettings, { theme }) }),
          /* @__PURE__ */ jsx14(Preview3, { children: /* @__PURE__ */ jsx14(PreviewPane, { platform, theme }) })
        ] }),
        /* @__PURE__ */ jsxs12(ModalFooter2, { "data-theme": "light", children: [
          /* @__PURE__ */ jsx14(Button2, { type: "button", variant: "outline", onClick: handleClose, children: "Cancel" }),
          /* @__PURE__ */ jsx14(Button2, { type: "button", variant: "primary", onClick: onSave, children: "Save" })
        ] })
      ] })
    }
  );
};

// src/components/ThemeEditor/ThemeEditor.tsx
import { Fragment as Fragment4, jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var ThemeEditor = ({
  id: id2,
  platform: targetPlatform,
  container,
  onPublish
}) => {
  const {
    theme,
    isEditorOpen,
    setIsEditorOpen,
    donatedComponent,
    setDonatedComponent,
    setContainer,
    fetchTheme,
    saveTheme,
    publishTheme
  } = useThemeEditor();
  useEffect4(() => {
    setContainer(container);
  }, [container, setContainer]);
  useEffect4(() => {
    if (isEditorOpen || donatedComponent !== null) {
      fetchTheme(id2);
    }
  }, [isEditorOpen, donatedComponent, fetchTheme, id2]);
  if (!theme) return null;
  const handleSave = async (metadata = {}) => {
    const delta = {
      id: theme.id,
      name: theme.name,
      content: theme.content
    };
    await saveTheme(delta);
    const updatedCompiledThemes = await publishTheme(theme.id);
    onPublish?.(
      updatedCompiledThemes.find(({ platform }) => platform === targetPlatform)
    );
    if (donatedComponent && metadata.donatedVariantName) {
      donatedComponent.onComplete?.(metadata.donatedVariantName);
    }
    setIsEditorOpen(false);
    setDonatedComponent(null);
  };
  return /* @__PURE__ */ jsxs13(Fragment4, { children: [
    /* @__PURE__ */ jsx15(DonateComponentModal, { platform: targetPlatform, onSave: handleSave }),
    /* @__PURE__ */ jsx15(ThemeModal, { platform: targetPlatform, onSave: handleSave })
  ] });
};

// src/components/Provider.tsx
import { useState as useState8, useMemo, useCallback as useCallback2 } from "react";
import { assign } from "object-path-immutable";
import { jsx as jsx16 } from "react/jsx-runtime";
var Provider = ({
  children,
  fetchTheme: fetchThemeApi,
  saveTheme: saveThemeApi,
  publishTheme: publishThemeApi
}) => {
  const [theme, setTheme] = useState8(null);
  const [isLoading, setIsLoading] = useState8(false);
  const [isEditorOpen, setIsEditorOpen] = useState8(false);
  const [donatedComponent, setDonatedComponent] = useState8(null);
  const [container, setContainer] = useState8(null);
  const updateTheme = useCallback2(
    (path, chunk) => {
      setTheme(assign(theme, path, chunk));
    },
    [theme]
  );
  const fetchTheme = useCallback2(
    async (id2) => {
      try {
        setIsLoading(true);
        const loadedTheme = await fetchThemeApi(id2);
        setTheme(loadedTheme);
      } catch (error) {
        console.error("Error fetching theme:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchThemeApi]
  );
  const saveTheme = useCallback2(
    async (model) => {
      try {
        if (!model.id) {
          throw new Error("Theme ID is required");
        }
        const result = await saveThemeApi(model.id, model);
        return result;
      } catch (error) {
        console.error("Theme save failed:", error);
        throw error;
      }
    },
    [saveThemeApi]
  );
  const publishTheme = useCallback2(
    async (id2) => {
      try {
        const publishedThemes = await publishThemeApi(id2);
        return publishedThemes;
      } catch (error) {
        console.error("Theme publish failed:", error);
        throw error;
      }
    },
    [publishThemeApi]
  );
  const value = useMemo(
    () => ({
      theme,
      setTheme,
      updateTheme,
      isLoading,
      setIsLoading,
      isEditorOpen,
      setIsEditorOpen,
      donatedComponent,
      setDonatedComponent,
      container,
      setContainer,
      fetchTheme,
      saveTheme,
      publishTheme
    }),
    [
      theme,
      updateTheme,
      isLoading,
      isEditorOpen,
      donatedComponent,
      container,
      fetchTheme,
      saveTheme,
      publishTheme
    ]
  );
  return /* @__PURE__ */ jsx16(Context_default.Provider, { value, children });
};

// src/model/base-theme.ts
var base_theme_default = {
  name: "Base Theme",
  content: {
    meta: {
      schemaVersion: 5,
      darkMode: false
    },
    tone: {},
    tokens: {
      colors: {
        $type: "color",
        foreground: { $value: "#000000" },
        background: { $value: "#ffffff" },
        primary: { $value: "#5c5cff" },
        "primary-contrast": { $value: "#ffffff" },
        utility: {
          backdrop: { $value: "#0000004d" },
          error: { $value: "#d6216b" },
          unselected: { $value: "#627293" }
        },
        dark: {
          foreground: { $value: "#ffffff" },
          background: { $value: "#000000" },
          primary: { $value: "#5c5cff" },
          "primary-contrast": { $value: "#ffffff" },
          utility: {
            backdrop: { $value: "#0000004d" },
            error: { $value: "#bf3c97" },
            unselected: { $value: "#627293" }
          }
        }
      },
      font: {
        family: {
          $type: "fontFamily",
          base: {
            $value: "System Sans-serif",
            $extensions: {
              "com.appcues.theme.font": {
                web: {},
                mobile: {
                  ultralight: "System Default Ultralight",
                  thin: "System Default Thin",
                  light: "System Default Light",
                  regular: "System Default Regular",
                  medium: "System Default Medium",
                  semibold: "System Default Semibold",
                  bold: "System Default Bold",
                  heavy: "System Default Heavy",
                  black: "System Default Black"
                }
              }
            }
          }
        },
        weight: {
          $type: "fontWeight",
          regular: { $value: "regular" },
          medium: { $value: "medium" },
          bold: { $value: "bold" }
        },
        size: {
          $type: "dimension",
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          small: { $value: "14px" },
          regular: { $value: "16px" },
          large: { $value: "22px" },
          h5: { $value: "16px" },
          h4: { $value: "18px" },
          h3: { $value: "20px" },
          h2: { $value: "24px" },
          h1: { $value: "32px" }
        }
      },
      dimensions: {
        $type: "dimension",
        unit: {
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          0: { $value: "0px" },
          1: { $value: "8px" },
          2: { $value: "12px" },
          3: { $value: "16px" },
          4: { $value: "20px" },
          5: { $value: "24px" }
        }
      },
      parts: {
        container: {
          "corner-radius": { $type: "dimension", $value: "8px" },
          padding: { $type: "dimension", $value: "{dimensions.unit.3}" },
          "shadow-radius": { $type: "dimension", $value: "6px" }
        }
      }
    },
    components: {
      container: {
        modal: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              paddingBottom: "{parts.container.padding}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              }
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            }
          }
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              },
              width: "300px"
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            },
            pointer: {
              $style: {
                pointerBase: "24px",
                pointerLength: "12px"
              }
            }
          }
        },
        embed: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              paddingBottom: "{parts.container.padding}",
              cornerRadius: "{parts.container.corner-radius}"
            }
          }
        }
      },
      text: {
        default: {
          $style: {
            fontFamily: "{font.family.base}",
            fontWeight: "{font.weight.regular}",
            fontSize: "{font.size.regular}",
            textAlignment: "center",
            horizontalAlignment: "center",
            foregroundColor: { light: "{colors.foreground}" },
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          }
        }
      },
      button: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" },
            cornerRadius: "{parts.container.corner-radius}",
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}",
            paddingTop: "{dimensions.unit.2}",
            paddingBottom: "{dimensions.unit.2}",
            paddingLeading: "{dimensions.unit.5}",
            paddingTrailing: "{dimensions.unit.5}"
          },
          text: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" }
            }
          }
        }
      },
      hero: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginTop: "{dimensions.unit.5}",
              marginBottom: "{dimensions.unit.3}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.medium}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginBottom: "{dimensions.unit.5}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          }
        }
      },
      image: {
        default: {
          $style: {}
        }
      },
      imagewithtext: {
        default: {
          $style: {
            paddingTop: "{dimensions.unit.1}",
            paddingBottom: "{dimensions.unit.1}",
            paddingLeading: "{dimensions.unit.3}",
            paddingTrailing: "{dimensions.unit.3}"
          },
          image: {
            $style: {
              marginTrailing: "{dimensions.unit.1}",
              width: "56px"
            }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          }
        }
      },
      select: {
        default: {
          $style: {
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.2}",
            marginTop: "{dimensions.unit.2}",
            marginTrailing: "{dimensions.unit.2}"
          },
          colors: {
            $style: {
              accentColor: { light: "#ffffff" },
              selectedColor: { light: "{colors.foreground}" },
              unselectedColor: { light: "{colors.utility.unselected}" }
            }
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          optionContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}"
            }
          },
          ratingNumberContent: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingNumberContentSelected: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              backgroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContent: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContentSelected: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingEmojiContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" }
            }
          },
          ratingEmojiContentSelected: {
            $style: {
              backgroundColor: { light: "{colors.foreground}" },
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      textinput: {
        default: {
          $style: {
            marginTop: "{dimensions.unit.2}",
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          placeholder: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.utility.unselected}" }
            }
          },
          textField: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              borderColor: { light: "{colors.utility.unselected}" },
              borderWidth: "0.5px",
              cornerRadius: "4px",
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      web: {
        embed: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.foreground}",
              padding: "0px"
            }
          }
        },
        modal: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              border: "none",
              borderRadius: "{parts.container.corner-radius}",
              boxShadow: "0px 6px 16px 0px rgba(0, 0, 0, 0.2)",
              color: "{colors.foreground}",
              height: "360px",
              padding: "0px",
              width: "720px"
            }
          }
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              border: "none",
              borderRadius: "{parts.container.corner-radius}",
              boxShadow: "none",
              filter: "drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.2))",
              color: "{colors.foreground}",
              padding: "0px",
              margin: "0px"
            }
          }
        },
        button: {
          default: {
            $style: {
              backgroundColor: "{colors.primary}",
              borderStyle: "none",
              borderWidth: "0px",
              borderColor: "unset",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.primary-contrast}",
              cursor: "pointer",
              flexGrow: "0",
              fontFamily: "inherit",
              fontSize: "{font.size.small}",
              height: "fit-content",
              marginTop: "0px",
              marginBottom: "0px",
              marginInlineStart: "{dimensions.unit.3}",
              marginInlineEnd: "{dimensions.unit.3}",
              paddingTop: "{dimensions.unit.2}",
              paddingBottom: "{dimensions.unit.2}",
              paddingInlineStart: "{dimensions.unit.3}",
              paddingInlineEnd: "{dimensions.unit.3}",
              textAlign: "center",
              textDecoration: "none",
              transition: "background-color 0.15s ease-out 0s, box-shadow 0.15s ease-out 0s, outline-color 0.15s ease-out 0s",
              width: "fit-content",
              state: {
                hover: {
                  backgroundColor: "{colors.primary}"
                }
              }
            }
          }
        },
        img: {
          default: {
            $style: {
              height: "100%",
              width: "100%"
            }
          }
        },
        p: {
          default: {
            $style: {
              fontFamily: "inherit",
              fontWeight: "unset",
              textAlign: "center",
              margin: "0px",
              color: "{colors.foreground}",
              fontSize: "{font.size.regular}"
            }
          }
        },
        h1: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h1}",
              color: "{colors.foreground}"
            }
          }
        },
        h2: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h2}",
              color: "{colors.foreground}"
            }
          }
        },
        h3: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h3}",
              color: "{colors.foreground}"
            }
          }
        },
        h4: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h4}",
              color: "{colors.foreground}"
            }
          }
        },
        h5: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "inherit",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h5}",
              color: "{colors.foreground}"
            }
          }
        }
      }
    }
  }
};

// src/model/migrations/index.ts
import { set as set2 } from "object-path-immutable";

// src/model/migrations/migrations.ts
import { get as get7 } from "object-path-immutable";

// src/model/migrations/utils.ts
import { get as get6, set } from "object-path-immutable";
var setIfMissing = (theme, path, value) => {
  const existing = get6(theme, path);
  if (existing !== void 0) {
    return theme;
  }
  return set(theme, path, value);
};
var addVariantIfMissing = (theme, variant, variantDefinition) => {
  const path = `content.components.${variant}`;
  return setIfMissing(theme, path, variantDefinition);
};

// src/model/migrations/migrations.ts
var migrations = [
  {
    // Version 1: Baseline - Establishes the initial schema version
    version: 1,
    migrate: (theme) => theme
  },
  {
    // Version 2: 2026-01 - Initial experience-builder components
    version: 2,
    migrate: (theme) => {
      const addedVariants = [
        ["web.modal.default", base_theme_default.content.components.web.modal.default],
        ["web.button.default", base_theme_default.content.components.web.button.default],
        ["web.img.default", base_theme_default.content.components.web.img.default]
      ];
      return addedVariants.reduce(
        (migratedTheme, [variant, definition]) => addVariantIfMissing(migratedTheme, variant, definition),
        theme
      );
    }
  },
  {
    // Version 3: 2026-01 - Rich text components (p, h1-h5) and heading font size tokens
    version: 3,
    migrate: (theme) => {
      const addedVariants = [
        ["web.p.default", base_theme_default.content.components.web.p.default],
        ["web.h1.default", base_theme_default.content.components.web.h1.default],
        ["web.h2.default", base_theme_default.content.components.web.h2.default],
        ["web.h3.default", base_theme_default.content.components.web.h3.default],
        ["web.h4.default", base_theme_default.content.components.web.h4.default],
        ["web.h5.default", base_theme_default.content.components.web.h5.default]
      ];
      let migratedTheme = addedVariants.reduce(
        (acc, [variant, definition]) => addVariantIfMissing(acc, variant, definition),
        theme
      );
      const rawPreset = get7(theme, [
        "content",
        "tokens",
        "font",
        "size",
        "$extensions",
        TOKEN_EXTENSIONS.PRESET
      ]);
      const currentPreset = PRESET_SIZES.includes(rawPreset) ? rawPreset : "M";
      const fontSizeTokens = presetFontSizes(currentPreset);
      const headingFontSizeTokens = ["h1", "h2", "h3", "h4", "h5"];
      migratedTheme = headingFontSizeTokens.reduce(
        (acc, token) => setIfMissing(
          acc,
          `content.tokens.font.size.${token}`,
          fontSizeTokens[token]
        ),
        migratedTheme
      );
      return migratedTheme;
    }
  },
  {
    // Version 4: 2026-02 - Embed web component variant
    version: 4,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.embed.default",
        base_theme_default.content.components.web.embed.default
      );
    }
  },
  {
    // Version 5: 2026-04 - Tooltip web component variant
    version: 5,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.tooltip.default",
        base_theme_default.content.components.web.tooltip.default
      );
    }
  }
];

// src/model/migrations/index.ts
var CURRENT_SCHEMA_VERSION = migrations.length > 0 ? Math.max(...migrations.map((m) => m.version)) : 0;
var getSchemaVersion = (theme) => {
  const meta = theme.content?.meta;
  return meta?.schemaVersion ?? 0;
};
var isThemeCurrent = (theme) => {
  return getSchemaVersion(theme) >= CURRENT_SCHEMA_VERSION;
};
var migrateTheme = (theme) => {
  const currentVersion = getSchemaVersion(theme);
  if (currentVersion >= CURRENT_SCHEMA_VERSION) {
    return theme;
  }
  const pendingMigrations = migrations.filter((m) => m.version > currentVersion).sort((a, b) => a.version - b.version);
  const migratedTheme = pendingMigrations.reduce(
    (currentTheme, migration) => migration.migrate(currentTheme),
    theme
  );
  return set2(
    migratedTheme,
    "content.meta.schemaVersion",
    CURRENT_SCHEMA_VERSION
  );
};
export {
  Context_default as Context,
  ThemeEditor,
  Provider as ThemeEditorProvider,
  base_theme_default as baseTheme,
  isThemeCurrent,
  migrateTheme,
  useThemeEditor
};
//# sourceMappingURL=index.mjs.map